(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/* MIT https://github.com/fabiospampinato/cash */
(function(){
"use strict";

var propMap = {
  /* GENERAL */
  "class": 'className',
  contenteditable: 'contentEditable',

  /* LABEL */
  "for": 'htmlFor',

  /* INPUT */
  readonly: 'readOnly',
  maxlength: 'maxLength',
  tabindex: 'tabIndex',

  /* TABLE */
  colspan: 'colSpan',
  rowspan: 'rowSpan',

  /* IMAGE */
  usemap: 'useMap'
};

function attempt(fn, arg) {
  try {
    return fn(arg);
  } catch (_a) {
    return arg;
  }
}

var doc = document,
    win = window,
    docEle = doc.documentElement,
    createElement = doc.createElement.bind(doc),
    div = createElement('div'),
    table = createElement('table'),
    tbody = createElement('tbody'),
    tr = createElement('tr'),
    isArray = Array.isArray,
    ArrayPrototype = Array.prototype,
    concat = ArrayPrototype.concat,
    filter = ArrayPrototype.filter,
    indexOf = ArrayPrototype.indexOf,
    map = ArrayPrototype.map,
    push = ArrayPrototype.push,
    slice = ArrayPrototype.slice,
    some = ArrayPrototype.some,
    splice = ArrayPrototype.splice;
var idRe = /^#(?:[\w-]|\\.|[^\x00-\xa0])*$/,
    classRe = /^\.(?:[\w-]|\\.|[^\x00-\xa0])*$/,
    htmlRe = /<.+>/,
    tagRe = /^\w+$/; // @require ./variables.ts

function find(selector, context) {
  return !selector || !isDocument(context) && !isElement(context) ? [] : classRe.test(selector) ? context.getElementsByClassName(selector.slice(1)) : tagRe.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
} // @require ./find.ts
// @require ./variables.ts


var Cash =
/** @class */
function () {
  function Cash(selector, context) {
    if (!selector) return;
    if (isCash(selector)) return selector;
    var eles = selector;

    if (isString(selector)) {
      var ctx = (isCash(context) ? context[0] : context) || doc;
      eles = idRe.test(selector) ? ctx.getElementById(selector.slice(1)) : htmlRe.test(selector) ? parseHTML(selector) : find(selector, ctx);
      if (!eles) return;
    } else if (isFunction(selector)) {
      return this.ready(selector); //FIXME: `fn.ready` is not included in `core`, but it's actually a core functionality
    }

    if (eles.nodeType || eles === win) eles = [eles];
    this.length = eles.length;

    for (var i = 0, l = this.length; i < l; i++) {
      this[i] = eles[i];
    }
  }

  Cash.prototype.init = function (selector, context) {
    return new Cash(selector, context);
  };

  return Cash;
}();

var fn = Cash.prototype,
    cash = fn.init;
cash.fn = cash.prototype = fn; // Ensuring that `cash () instanceof cash`

fn.length = 0;
fn.splice = splice; // Ensuring a cash collection gets printed as array-like in Chrome's devtools

if (typeof Symbol === 'function') {
  // Ensuring a cash collection is iterable
  fn[Symbol['iterator']] = ArrayPrototype[Symbol['iterator']];
}

fn.map = function (callback) {
  return cash(concat.apply([], map.call(this, function (ele, i) {
    return callback.call(ele, i, ele);
  })));
};

fn.slice = function (start, end) {
  return cash(slice.call(this, start, end));
}; // @require ./cash.ts


var dashAlphaRe = /-([a-z])/g;

function camelCase(str) {
  return str.replace(dashAlphaRe, function (match, letter) {
    return letter.toUpperCase();
  });
}

cash.guid = 1; // @require ./cash.ts

function matches(ele, selector) {
  var matches = ele && (ele['matches'] || ele['webkitMatchesSelector'] || ele['msMatchesSelector']);
  return !!matches && !!selector && matches.call(ele, selector);
}

function isCash(x) {
  return x instanceof Cash;
}

function isWindow(x) {
  return !!x && x === x.window;
}

function isDocument(x) {
  return !!x && x.nodeType === 9;
}

function isElement(x) {
  return !!x && x.nodeType === 1;
}

function isBoolean(x) {
  return typeof x === 'boolean';
}

function isFunction(x) {
  return typeof x === 'function';
}

function isString(x) {
  return typeof x === 'string';
}

function isUndefined(x) {
  return x === undefined;
}

function isNull(x) {
  return x === null;
}

function isNumeric(x) {
  return !isNaN(parseFloat(x)) && isFinite(x);
}

function isPlainObject(x) {
  if (typeof x !== 'object' || x === null) return false;
  var proto = Object.getPrototypeOf(x);
  return proto === null || proto === Object.prototype;
}

cash.isWindow = isWindow;
cash.isFunction = isFunction;
cash.isArray = isArray;
cash.isNumeric = isNumeric;
cash.isPlainObject = isPlainObject;

fn.get = function (index) {
  if (isUndefined(index)) return slice.call(this);
  index = Number(index);
  return this[index < 0 ? index + this.length : index];
};

fn.eq = function (index) {
  return cash(this.get(index));
};

fn.first = function () {
  return this.eq(0);
};

fn.last = function () {
  return this.eq(-1);
};

function each(arr, callback, _reverse) {
  if (_reverse) {
    var i = arr.length;

    while (i--) {
      if (callback.call(arr[i], i, arr[i]) === false) return arr;
    }
  } else if (isPlainObject(arr)) {
    var keys = Object.keys(arr);

    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      if (callback.call(arr[key], key, arr[key]) === false) return arr;
    }
  } else {
    for (var i = 0, l = arr.length; i < l; i++) {
      if (callback.call(arr[i], i, arr[i]) === false) return arr;
    }
  }

  return arr;
}

cash.each = each;

fn.each = function (callback) {
  return each(this, callback);
};

fn.prop = function (prop, value) {
  if (!prop) return;

  if (isString(prop)) {
    prop = propMap[prop] || prop;
    if (arguments.length < 2) return this[0] && this[0][prop];
    return this.each(function (i, ele) {
      ele[prop] = value;
    });
  }

  for (var key in prop) {
    this.prop(key, prop[key]);
  }

  return this;
};

fn.removeProp = function (prop) {
  return this.each(function (i, ele) {
    delete ele[propMap[prop] || prop];
  });
};

function extend() {
  var sources = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }

  var deep = isBoolean(sources[0]) ? sources.shift() : false,
      target = sources.shift(),
      length = sources.length;
  if (!target) return {};
  if (!length) return extend(deep, cash, target);

  for (var i = 0; i < length; i++) {
    var source = sources[i];

    for (var key in source) {
      if (deep && (isArray(source[key]) || isPlainObject(source[key]))) {
        if (!target[key] || target[key].constructor !== source[key].constructor) target[key] = new source[key].constructor();
        extend(deep, target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }

  return target;
}

cash.extend = extend;

fn.extend = function (plugins) {
  return extend(fn, plugins);
}; // @require ./matches.ts
// @require ./type_checking.ts


function getCompareFunction(comparator) {
  return isString(comparator) ? function (i, ele) {
    return matches(ele, comparator);
  } : isFunction(comparator) ? comparator : isCash(comparator) ? function (i, ele) {
    return comparator.is(ele);
  } : !comparator ? function () {
    return false;
  } : function (i, ele) {
    return ele === comparator;
  };
}

fn.filter = function (comparator) {
  var compare = getCompareFunction(comparator);
  return cash(filter.call(this, function (ele, i) {
    return compare.call(ele, i, ele);
  }));
}; // @require collection/filter.ts


function filtered(collection, comparator) {
  return !comparator ? collection : collection.filter(comparator);
} // @require ./type_checking.ts


var splitValuesRe = /\S+/g;

function getSplitValues(str) {
  return isString(str) ? str.match(splitValuesRe) || [] : [];
}

fn.hasClass = function (cls) {
  return !!cls && some.call(this, function (ele) {
    return isElement(ele) && ele.classList.contains(cls);
  });
};

fn.removeAttr = function (attr) {
  var attrs = getSplitValues(attr);
  return this.each(function (i, ele) {
    if (!isElement(ele)) return;
    each(attrs, function (i, a) {
      ele.removeAttribute(a);
    });
  });
};

function attr(attr, value) {
  if (!attr) return;

  if (isString(attr)) {
    if (arguments.length < 2) {
      if (!this[0] || !isElement(this[0])) return;
      var value_1 = this[0].getAttribute(attr);
      return isNull(value_1) ? undefined : value_1;
    }

    if (isUndefined(value)) return this;
    if (isNull(value)) return this.removeAttr(attr);
    return this.each(function (i, ele) {
      if (!isElement(ele)) return;
      ele.setAttribute(attr, value);
    });
  }

  for (var key in attr) {
    this.attr(key, attr[key]);
  }

  return this;
}

fn.attr = attr;

fn.toggleClass = function (cls, force) {
  var classes = getSplitValues(cls),
      isForce = !isUndefined(force);
  return this.each(function (i, ele) {
    if (!isElement(ele)) return;
    each(classes, function (i, c) {
      if (isForce) {
        force ? ele.classList.add(c) : ele.classList.remove(c);
      } else {
        ele.classList.toggle(c);
      }
    });
  });
};

fn.addClass = function (cls) {
  return this.toggleClass(cls, true);
};

fn.removeClass = function (cls) {
  if (arguments.length) return this.toggleClass(cls, false);
  return this.attr('class', '');
};

function pluck(arr, prop, deep, until) {
  var plucked = [],
      isCallback = isFunction(prop),
      compare = until && getCompareFunction(until);

  for (var i = 0, l = arr.length; i < l; i++) {
    if (isCallback) {
      var val_1 = prop(arr[i]);
      if (val_1.length) push.apply(plucked, val_1);
    } else {
      var val_2 = arr[i][prop];

      while (val_2 != null) {
        if (until && compare(-1, val_2)) break;
        plucked.push(val_2);
        val_2 = deep ? val_2[prop] : null;
      }
    }
  }

  return plucked;
}

function unique(arr) {
  return arr.length > 1 ? filter.call(arr, function (item, index, self) {
    return indexOf.call(self, item) === index;
  }) : arr;
}

cash.unique = unique;

fn.add = function (selector, context) {
  return cash(unique(this.get().concat(cash(selector, context).get())));
}; // @require core/type_checking.ts
// @require core/variables.ts


function computeStyle(ele, prop, isVariable) {
  if (!isElement(ele)) return;
  var style = win.getComputedStyle(ele, null);
  return isVariable ? style.getPropertyValue(prop) || undefined : style[prop] || ele.style[prop];
} // @require ./compute_style.ts


function computeStyleInt(ele, prop) {
  return parseInt(computeStyle(ele, prop), 10) || 0;
}

var cssVariableRe = /^--/; // @require ./variables.ts

function isCSSVariable(prop) {
  return cssVariableRe.test(prop);
} // @require core/camel_case.ts
// @require core/cash.ts
// @require core/each.ts
// @require core/variables.ts
// @require ./is_css_variable.ts


var prefixedProps = {},
    style = div.style,
    vendorsPrefixes = ['webkit', 'moz', 'ms'];

function getPrefixedProp(prop, isVariable) {
  if (isVariable === void 0) {
    isVariable = isCSSVariable(prop);
  }

  if (isVariable) return prop;

  if (!prefixedProps[prop]) {
    var propCC = camelCase(prop),
        propUC = "" + propCC[0].toUpperCase() + propCC.slice(1),
        props = (propCC + " " + vendorsPrefixes.join(propUC + " ") + propUC).split(' ');
    each(props, function (i, p) {
      if (p in style) {
        prefixedProps[prop] = p;
        return false;
      }
    });
  }

  return prefixedProps[prop];
}

; // @require core/type_checking.ts
// @require ./is_css_variable.ts

var numericProps = {
  animationIterationCount: true,
  columnCount: true,
  flexGrow: true,
  flexShrink: true,
  fontWeight: true,
  gridArea: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnStart: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowStart: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  widows: true,
  zIndex: true
};

function getSuffixedValue(prop, value, isVariable) {
  if (isVariable === void 0) {
    isVariable = isCSSVariable(prop);
  }

  return !isVariable && !numericProps[prop] && isNumeric(value) ? value + "px" : value;
}

function css(prop, value) {
  if (isString(prop)) {
    var isVariable_1 = isCSSVariable(prop);
    prop = getPrefixedProp(prop, isVariable_1);
    if (arguments.length < 2) return this[0] && computeStyle(this[0], prop, isVariable_1);
    if (!prop) return this;
    value = getSuffixedValue(prop, value, isVariable_1);
    return this.each(function (i, ele) {
      if (!isElement(ele)) return;

      if (isVariable_1) {
        ele.style.setProperty(prop, value);
      } else {
        ele.style[prop] = value;
      }
    });
  }

  for (var key in prop) {
    this.css(key, prop[key]);
  }

  return this;
}

;
fn.css = css; // @optional ./css.ts
// @require core/attempt.ts
// @require core/camel_case.ts

var JSONStringRe = /^\s+|\s+$/;

function getData(ele, key) {
  var value = ele.dataset[key] || ele.dataset[camelCase(key)];
  if (JSONStringRe.test(value)) return value;
  return attempt(JSON.parse, value);
} // @require core/attempt.ts
// @require core/camel_case.ts


function setData(ele, key, value) {
  value = attempt(JSON.stringify, value);
  ele.dataset[camelCase(key)] = value;
}

function data(name, value) {
  if (!name) {
    if (!this[0]) return;
    var datas = {};

    for (var key in this[0].dataset) {
      datas[key] = getData(this[0], key);
    }

    return datas;
  }

  if (isString(name)) {
    if (arguments.length < 2) return this[0] && getData(this[0], name);
    if (isUndefined(value)) return this;
    return this.each(function (i, ele) {
      setData(ele, name, value);
    });
  }

  for (var key in name) {
    this.data(key, name[key]);
  }

  return this;
}

fn.data = data; // @optional ./data.ts

function getDocumentDimension(doc, dimension) {
  var docEle = doc.documentElement;
  return Math.max(doc.body["scroll" + dimension], docEle["scroll" + dimension], doc.body["offset" + dimension], docEle["offset" + dimension], docEle["client" + dimension]);
} // @require css/helpers/compute_style_int.ts


function getExtraSpace(ele, xAxis) {
  return computeStyleInt(ele, "border" + (xAxis ? 'Left' : 'Top') + "Width") + computeStyleInt(ele, "padding" + (xAxis ? 'Left' : 'Top')) + computeStyleInt(ele, "padding" + (xAxis ? 'Right' : 'Bottom')) + computeStyleInt(ele, "border" + (xAxis ? 'Right' : 'Bottom') + "Width");
}

each([true, false], function (i, outer) {
  each(['Width', 'Height'], function (i, prop) {
    var name = "" + (outer ? 'outer' : 'inner') + prop;

    fn[name] = function (includeMargins) {
      if (!this[0]) return;
      if (isWindow(this[0])) return outer ? this[0]["inner" + prop] : this[0].document.documentElement["client" + prop];
      if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
      return this[0]["" + (outer ? 'offset' : 'client') + prop] + (includeMargins && outer ? computeStyleInt(this[0], "margin" + (i ? 'Top' : 'Left')) + computeStyleInt(this[0], "margin" + (i ? 'Bottom' : 'Right')) : 0);
    };
  });
});
each(['Width', 'Height'], function (index, prop) {
  var propLC = prop.toLowerCase();

  fn[propLC] = function (value) {
    if (!this[0]) return isUndefined(value) ? undefined : this;

    if (!arguments.length) {
      if (isWindow(this[0])) return this[0].document.documentElement["client" + prop];
      if (isDocument(this[0])) return getDocumentDimension(this[0], prop);
      return this[0].getBoundingClientRect()[propLC] - getExtraSpace(this[0], !index);
    }

    var valueNumber = parseInt(value, 10);
    return this.each(function (i, ele) {
      if (!isElement(ele)) return;
      var boxSizing = computeStyle(ele, 'boxSizing');
      ele.style[propLC] = getSuffixedValue(propLC, valueNumber + (boxSizing === 'border-box' ? getExtraSpace(ele, !index) : 0));
    });
  };
}); // @optional ./inner_outer.ts
// @optional ./normal.ts
// @require css/helpers/compute_style.ts

var defaultDisplay = {};

function getDefaultDisplay(tagName) {
  if (defaultDisplay[tagName]) return defaultDisplay[tagName];
  var ele = createElement(tagName);
  doc.body.insertBefore(ele, null);
  var display = computeStyle(ele, 'display');
  doc.body.removeChild(ele);
  return defaultDisplay[tagName] = display !== 'none' ? display : 'block';
} // @require css/helpers/compute_style.ts


function isHidden(ele) {
  return computeStyle(ele, 'display') === 'none';
}

var displayProperty = '___cd';

fn.toggle = function (force) {
  return this.each(function (i, ele) {
    if (!isElement(ele)) return;
    var show = isUndefined(force) ? isHidden(ele) : force;

    if (show) {
      ele.style.display = ele[displayProperty] || '';

      if (isHidden(ele)) {
        ele.style.display = getDefaultDisplay(ele.tagName);
      }
    } else {
      ele[displayProperty] = computeStyle(ele, 'display');
      ele.style.display = 'none';
    }
  });
};

fn.hide = function () {
  return this.toggle(false);
};

fn.show = function () {
  return this.toggle(true);
}; // @optional ./hide.ts
// @optional ./show.ts
// @optional ./toggle.ts


function hasNamespaces(ns1, ns2) {
  return !ns2 || !some.call(ns2, function (ns) {
    return ns1.indexOf(ns) < 0;
  });
}

var eventsNamespace = '___ce',
    eventsNamespacesSeparator = '.',
    eventsFocus = {
  focus: 'focusin',
  blur: 'focusout'
},
    eventsHover = {
  mouseenter: 'mouseover',
  mouseleave: 'mouseout'
},
    eventsMouseRe = /^(mouse|pointer|contextmenu|drag|drop|click|dblclick)/i; // @require ./variables.ts

function getEventNameBubbling(name) {
  return eventsHover[name] || eventsFocus[name] || name;
} // @require ./variables.ts


function getEventsCache(ele) {
  return ele[eventsNamespace] = ele[eventsNamespace] || {};
} // @require core/guid.ts
// @require events/helpers/get_events_cache.ts


function addEvent(ele, name, namespaces, selector, callback) {
  var eventCache = getEventsCache(ele);
  eventCache[name] = eventCache[name] || [];
  eventCache[name].push([namespaces, selector, callback]);
  ele.addEventListener(name, callback);
} // @require ./variables.ts


function parseEventName(eventName) {
  var parts = eventName.split(eventsNamespacesSeparator);
  return [parts[0], parts.slice(1).sort()]; // [name, namespace[]]
} // @require ./get_events_cache.ts
// @require ./has_namespaces.ts
// @require ./parse_event_name.ts


function removeEvent(ele, name, namespaces, selector, callback) {
  var cache = getEventsCache(ele);

  if (!name) {
    for (name in cache) {
      removeEvent(ele, name, namespaces, selector, callback);
    }
  } else if (cache[name]) {
    cache[name] = cache[name].filter(function (_a) {
      var ns = _a[0],
          sel = _a[1],
          cb = _a[2];
      if (callback && cb.guid !== callback.guid || !hasNamespaces(ns, namespaces) || selector && selector !== sel) return true;
      ele.removeEventListener(name, cb);
    });
  }
}

fn.off = function (eventFullName, selector, callback) {
  var _this = this;

  if (isUndefined(eventFullName)) {
    this.each(function (i, ele) {
      if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
      removeEvent(ele);
    });
  } else if (!isString(eventFullName)) {
    for (var key in eventFullName) {
      this.off(key, eventFullName[key]);
    }
  } else {
    if (isFunction(selector)) {
      callback = selector;
      selector = '';
    }

    each(getSplitValues(eventFullName), function (i, eventFullName) {
      var _a = parseEventName(eventFullName),
          nameOriginal = _a[0],
          namespaces = _a[1],
          name = getEventNameBubbling(nameOriginal);

      _this.each(function (i, ele) {
        if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;
        removeEvent(ele, name, namespaces, selector, callback);
      });
    });
  }

  return this;
};

function on(eventFullName, selector, data, callback, _one) {
  var _this = this;

  if (!isString(eventFullName)) {
    for (var key in eventFullName) {
      this.on(key, selector, data, eventFullName[key], _one);
    }

    return this;
  }

  if (!isString(selector)) {
    if (isUndefined(selector) || isNull(selector)) {
      selector = '';
    } else if (isUndefined(data)) {
      data = selector;
      selector = '';
    } else {
      callback = data;
      data = selector;
      selector = '';
    }
  }

  if (!isFunction(callback)) {
    callback = data;
    data = undefined;
  }

  if (!callback) return this;
  each(getSplitValues(eventFullName), function (i, eventFullName) {
    var _a = parseEventName(eventFullName),
        nameOriginal = _a[0],
        namespaces = _a[1],
        name = getEventNameBubbling(nameOriginal),
        isEventHover = nameOriginal in eventsHover,
        isEventFocus = nameOriginal in eventsFocus;

    if (!name) return;

    _this.each(function (i, ele) {
      if (!isElement(ele) && !isDocument(ele) && !isWindow(ele)) return;

      var finalCallback = function finalCallback(event) {
        if (event.target["___i" + event.type]) return event.stopImmediatePropagation(); // Ignoring native event in favor of the upcoming custom one

        if (event.namespace && !hasNamespaces(namespaces, event.namespace.split(eventsNamespacesSeparator))) return;
        if (!selector && (isEventFocus && (event.target !== ele || event.___ot === name) || isEventHover && event.relatedTarget && ele.contains(event.relatedTarget))) return;
        var thisArg = ele;

        if (selector) {
          var target = event.target;

          while (!matches(target, selector)) {
            if (target === ele) return;
            target = target.parentNode;
            if (!target) return;
          }

          thisArg = target;
          event.___cd = true; // Delegate
        }

        if (event.___cd) {
          Object.defineProperty(event, 'currentTarget', {
            configurable: true,
            get: function get() {
              return thisArg;
            }
          });
        }

        Object.defineProperty(event, 'data', {
          configurable: true,
          get: function get() {
            return data;
          }
        });
        var returnValue = callback.call(thisArg, event, event.___td);

        if (_one) {
          removeEvent(ele, name, namespaces, selector, finalCallback);
        }

        if (returnValue === false) {
          event.preventDefault();
          event.stopPropagation();
        }
      };

      finalCallback.guid = callback.guid = callback.guid || cash.guid++;
      addEvent(ele, name, namespaces, selector, finalCallback);
    });
  });
  return this;
}

fn.on = on;

function one(eventFullName, selector, data, callback) {
  return this.on(eventFullName, selector, data, callback, true);
}

;
fn.one = one;

fn.ready = function (callback) {
  var cb = function cb() {
    return setTimeout(callback, 0, cash);
  };

  if (doc.readyState !== 'loading') {
    cb();
  } else {
    doc.addEventListener('DOMContentLoaded', cb);
  }

  return this;
};

fn.trigger = function (event, data) {
  if (isString(event)) {
    var _a = parseEventName(event),
        nameOriginal = _a[0],
        namespaces = _a[1],
        name_1 = getEventNameBubbling(nameOriginal);

    if (!name_1) return this;
    var type = eventsMouseRe.test(name_1) ? 'MouseEvents' : 'HTMLEvents';
    event = doc.createEvent(type);
    event.initEvent(name_1, true, true);
    event.namespace = namespaces.join(eventsNamespacesSeparator);
    event.___ot = nameOriginal;
  }

  event.___td = data;
  var isEventFocus = event.___ot in eventsFocus;
  return this.each(function (i, ele) {
    if (isEventFocus && isFunction(ele[event.___ot])) {
      ele["___i" + event.type] = true; // Ensuring the native event is ignored

      ele[event.___ot]();

      ele["___i" + event.type] = false; // Ensuring the custom event is not ignored
    }

    ele.dispatchEvent(event);
  });
}; // @optional ./off.ts
// @optional ./on.ts
// @optional ./one.ts
// @optional ./ready.ts
// @optional ./trigger.ts
// @require core/pluck.ts
// @require core/variables.ts


function getValue(ele) {
  if (ele.multiple && ele.options) return pluck(filter.call(ele.options, function (option) {
    return option.selected && !option.disabled && !option.parentNode.disabled;
  }), 'value');
  return ele.value || '';
}

var queryEncodeSpaceRe = /%20/g,
    queryEncodeCRLFRe = /\r?\n/g;

function queryEncode(prop, value) {
  return "&" + encodeURIComponent(prop) + "=" + encodeURIComponent(value.replace(queryEncodeCRLFRe, '\r\n')).replace(queryEncodeSpaceRe, '+');
}

var skippableRe = /file|reset|submit|button|image/i,
    checkableRe = /radio|checkbox/i;

fn.serialize = function () {
  var query = '';
  this.each(function (i, ele) {
    each(ele.elements || [ele], function (i, ele) {
      if (ele.disabled || !ele.name || ele.tagName === 'FIELDSET' || skippableRe.test(ele.type) || checkableRe.test(ele.type) && !ele.checked) return;
      var value = getValue(ele);

      if (!isUndefined(value)) {
        var values = isArray(value) ? value : [value];
        each(values, function (i, value) {
          query += queryEncode(ele.name, value);
        });
      }
    });
  });
  return query.slice(1);
};

function val(value) {
  if (!arguments.length) return this[0] && getValue(this[0]);
  return this.each(function (i, ele) {
    var isSelect = ele.multiple && ele.options;

    if (isSelect || checkableRe.test(ele.type)) {
      var eleValue_1 = isArray(value) ? map.call(value, String) : isNull(value) ? [] : [String(value)];

      if (isSelect) {
        each(ele.options, function (i, option) {
          option.selected = eleValue_1.indexOf(option.value) >= 0;
        }, true);
      } else {
        ele.checked = eleValue_1.indexOf(ele.value) >= 0;
      }
    } else {
      ele.value = isUndefined(value) || isNull(value) ? '' : value;
    }
  });
}

fn.val = val;

fn.clone = function () {
  return this.map(function (i, ele) {
    return ele.cloneNode(true);
  });
};

fn.detach = function (comparator) {
  filtered(this, comparator).each(function (i, ele) {
    if (ele.parentNode) {
      ele.parentNode.removeChild(ele);
    }
  });
  return this;
};

var fragmentRe = /^\s*<(\w+)[^>]*>/,
    singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
var containers = {
  '*': div,
  tr: tbody,
  td: tr,
  th: tr,
  thead: table,
  tbody: table,
  tfoot: table
}; //TODO: Create elements inside a document fragment, in order to prevent inline event handlers from firing
//TODO: Ensure the created elements have the fragment as their parent instead of null, this also ensures we can deal with detatched nodes more reliably

function parseHTML(html) {
  if (!isString(html)) return [];
  if (singleTagRe.test(html)) return [createElement(RegExp.$1)];
  var fragment = fragmentRe.test(html) && RegExp.$1,
      container = containers[fragment] || containers['*'];
  container.innerHTML = html;
  return cash(container.childNodes).detach().get();
}

cash.parseHTML = parseHTML;

fn.empty = function () {
  return this.each(function (i, ele) {
    while (ele.firstChild) {
      ele.removeChild(ele.firstChild);
    }
  });
};

function html(html) {
  if (!arguments.length) return this[0] && this[0].innerHTML;
  if (isUndefined(html)) return this;
  return this.each(function (i, ele) {
    if (!isElement(ele)) return;
    ele.innerHTML = html;
  });
}

fn.html = html;

fn.remove = function (comparator) {
  filtered(this, comparator).detach().off();
  return this;
};

function text(text) {
  if (isUndefined(text)) return this[0] ? this[0].textContent : '';
  return this.each(function (i, ele) {
    if (!isElement(ele)) return;
    ele.textContent = text;
  });
}

;
fn.text = text;

fn.unwrap = function () {
  this.parent().each(function (i, ele) {
    if (ele.tagName === 'BODY') return;
    var $ele = cash(ele);
    $ele.replaceWith($ele.children());
  });
  return this;
};

fn.offset = function () {
  var ele = this[0];
  if (!ele) return;
  var rect = ele.getBoundingClientRect();
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset
  };
};

fn.offsetParent = function () {
  return this.map(function (i, ele) {
    var offsetParent = ele.offsetParent;

    while (offsetParent && computeStyle(offsetParent, 'position') === 'static') {
      offsetParent = offsetParent.offsetParent;
    }

    return offsetParent || docEle;
  });
};

fn.position = function () {
  var ele = this[0];
  if (!ele) return;
  var isFixed = computeStyle(ele, 'position') === 'fixed',
      offset = isFixed ? ele.getBoundingClientRect() : this.offset();

  if (!isFixed) {
    var doc_1 = ele.ownerDocument;
    var offsetParent = ele.offsetParent || doc_1.documentElement;

    while ((offsetParent === doc_1.body || offsetParent === doc_1.documentElement) && computeStyle(offsetParent, 'position') === 'static') {
      offsetParent = offsetParent.parentNode;
    }

    if (offsetParent !== ele && isElement(offsetParent)) {
      var parentOffset = cash(offsetParent).offset();
      offset.top -= parentOffset.top + computeStyleInt(offsetParent, 'borderTopWidth');
      offset.left -= parentOffset.left + computeStyleInt(offsetParent, 'borderLeftWidth');
    }
  }

  return {
    top: offset.top - computeStyleInt(ele, 'marginTop'),
    left: offset.left - computeStyleInt(ele, 'marginLeft')
  };
};

fn.children = function (comparator) {
  return filtered(cash(unique(pluck(this, function (ele) {
    return ele.children;
  }))), comparator);
};

fn.contents = function () {
  return cash(unique(pluck(this, function (ele) {
    return ele.tagName === 'IFRAME' ? [ele.contentDocument] : ele.tagName === 'TEMPLATE' ? ele.content.childNodes : ele.childNodes;
  })));
};

fn.find = function (selector) {
  return cash(unique(pluck(this, function (ele) {
    return find(selector, ele);
  })));
}; // @require core/variables.ts
// @require collection/filter.ts
// @require traversal/find.ts


var HTMLCDATARe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
    scriptTypeRe = /^$|^module$|\/(java|ecma)script/i,
    scriptAttributes = ['type', 'src', 'nonce', 'noModule'];

function evalScripts(node, doc) {
  var collection = cash(node);
  collection.filter('script').add(collection.find('script')).each(function (i, ele) {
    if (scriptTypeRe.test(ele.type) && docEle.contains(ele)) {
      // The script type is supported // The element is attached to the DOM // Using `documentElement` for broader browser support
      var script_1 = createElement('script');
      script_1.text = ele.textContent.replace(HTMLCDATARe, '');
      each(scriptAttributes, function (i, attr) {
        if (ele[attr]) script_1[attr] = ele[attr];
      });
      doc.head.insertBefore(script_1, null);
      doc.head.removeChild(script_1);
    }
  });
} // @require ./eval_scripts.ts


function insertElement(anchor, target, left, inside, evaluate) {
  if (inside) {
    // prepend/append
    anchor.insertBefore(target, left ? anchor.firstChild : null);
  } else {
    // before/after
    anchor.parentNode.insertBefore(target, left ? anchor : anchor.nextSibling);
  }

  if (evaluate) {
    evalScripts(target, anchor.ownerDocument);
  }
} // @require ./insert_element.ts


function insertSelectors(selectors, anchors, inverse, left, inside, reverseLoop1, reverseLoop2, reverseLoop3) {
  each(selectors, function (si, selector) {
    each(cash(selector), function (ti, target) {
      each(cash(anchors), function (ai, anchor) {
        var anchorFinal = inverse ? target : anchor,
            targetFinal = inverse ? anchor : target,
            indexFinal = inverse ? ti : ai;
        insertElement(anchorFinal, !indexFinal ? targetFinal : targetFinal.cloneNode(true), left, inside, !indexFinal);
      }, reverseLoop3);
    }, reverseLoop2);
  }, reverseLoop1);
  return anchors;
}

fn.after = function () {
  return insertSelectors(arguments, this, false, false, false, true, true);
};

fn.append = function () {
  return insertSelectors(arguments, this, false, false, true);
};

fn.appendTo = function (selector) {
  return insertSelectors(arguments, this, true, false, true);
};

fn.before = function () {
  return insertSelectors(arguments, this, false, true);
};

fn.insertAfter = function (selector) {
  return insertSelectors(arguments, this, true, false, false, false, false, true);
};

fn.insertBefore = function (selector) {
  return insertSelectors(arguments, this, true, true);
};

fn.prepend = function () {
  return insertSelectors(arguments, this, false, true, true, true, true);
};

fn.prependTo = function (selector) {
  return insertSelectors(arguments, this, true, true, true, false, false, true);
};

fn.replaceWith = function (selector) {
  return this.before(selector).remove();
};

fn.replaceAll = function (selector) {
  cash(selector).replaceWith(this);
  return this;
};

fn.wrapAll = function (selector) {
  var structure = cash(selector),
      wrapper = structure[0];

  while (wrapper.children.length) {
    wrapper = wrapper.firstElementChild;
  }

  this.first().before(structure);
  return this.appendTo(wrapper);
};

fn.wrap = function (selector) {
  return this.each(function (i, ele) {
    var wrapper = cash(selector)[0];
    cash(ele).wrapAll(!i ? wrapper : wrapper.cloneNode(true));
  });
};

fn.wrapInner = function (selector) {
  return this.each(function (i, ele) {
    var $ele = cash(ele),
        contents = $ele.contents();
    contents.length ? contents.wrapAll(selector) : $ele.append(selector);
  });
};

fn.has = function (selector) {
  var comparator = isString(selector) ? function (i, ele) {
    return find(selector, ele).length;
  } : function (i, ele) {
    return ele.contains(selector);
  };
  return this.filter(comparator);
};

fn.is = function (comparator) {
  var compare = getCompareFunction(comparator);
  return some.call(this, function (ele, i) {
    return compare.call(ele, i, ele);
  });
};

fn.next = function (comparator, _all, _until) {
  return filtered(cash(unique(pluck(this, 'nextElementSibling', _all, _until))), comparator);
};

fn.nextAll = function (comparator) {
  return this.next(comparator, true);
};

fn.nextUntil = function (until, comparator) {
  return this.next(comparator, true, until);
};

fn.not = function (comparator) {
  var compare = getCompareFunction(comparator);
  return this.filter(function (i, ele) {
    return (!isString(comparator) || isElement(ele)) && !compare.call(ele, i, ele);
  });
};

fn.parent = function (comparator) {
  return filtered(cash(unique(pluck(this, 'parentNode'))), comparator);
};

fn.index = function (selector) {
  var child = selector ? cash(selector)[0] : this[0],
      collection = selector ? this : cash(child).parent().children();
  return indexOf.call(collection, child);
};

fn.closest = function (comparator) {
  var filtered = this.filter(comparator);
  if (filtered.length) return filtered;
  var $parent = this.parent();
  if (!$parent.length) return filtered;
  return $parent.closest(comparator);
};

fn.parents = function (comparator, _until) {
  return filtered(cash(unique(pluck(this, 'parentElement', true, _until))), comparator);
};

fn.parentsUntil = function (until, comparator) {
  return this.parents(comparator, until);
};

fn.prev = function (comparator, _all, _until) {
  return filtered(cash(unique(pluck(this, 'previousElementSibling', _all, _until))), comparator);
};

fn.prevAll = function (comparator) {
  return this.prev(comparator, true);
};

fn.prevUntil = function (until, comparator) {
  return this.prev(comparator, true, until);
};

fn.siblings = function (comparator) {
  return filtered(cash(unique(pluck(this, function (ele) {
    return cash(ele).parent().children().not(ele);
  }))), comparator);
}; // @optional ./children.ts
// @optional ./closest.ts
// @optional ./contents.ts
// @optional ./find.ts
// @optional ./has.ts
// @optional ./is.ts
// @optional ./next.ts
// @optional ./next_all.ts
// @optional ./next_until.ts
// @optional ./not.ts
// @optional ./parent.ts
// @optional ./parents.ts
// @optional ./parents_until.ts
// @optional ./prev.ts
// @optional ./prev_all.ts
// @optional ./prev_until.ts
// @optional ./siblings.ts
// @optional attributes/index.ts
// @optional collection/index.ts
// @optional css/index.ts
// @optional data/index.ts
// @optional dimensions/index.ts
// @optional effects/index.ts
// @optional events/index.ts
// @optional forms/index.ts
// @optional manipulation/index.ts
// @optional offset/index.ts
// @optional traversal/index.ts
// @require core/index.ts
// @priority -100
// @require ./cash.ts
// @require ./variables.ts


if (typeof exports !== 'undefined') {
  // Node.js
  module.exports = cash;
} else {
  // Browser
  win['cash'] = win['$'] = cash;
}
})();
},{}],2:[function(require,module,exports){
/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

},{}],3:[function(require,module,exports){
function isUndefined(value) {
  return value === undefined;
}

function isNull(value) {
  return value === null;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function isObject(value) {
  return value === Object(value);
}

function isArray(value) {
  return Array.isArray(value);
}

function isDate(value) {
  return value instanceof Date;
}

function isBlob(value) {
  return (
    value &&
    typeof value.size === 'number' &&
    typeof value.type === 'string' &&
    typeof value.slice === 'function'
  );
}

function isFile(value) {
  return (
    isBlob(value) &&
    typeof value.name === 'string' &&
    (typeof value.lastModifiedDate === 'object' ||
      typeof value.lastModified === 'number')
  );
}

function initCfg(value) {
  return isUndefined(value) ? false : value;
}

function serialize(obj, cfg, fd, pre) {
  cfg = cfg || {};
  fd = fd || new FormData();

  cfg.indices = initCfg(cfg.indices);
  cfg.nullsAsUndefineds = initCfg(cfg.nullsAsUndefineds);
  cfg.booleansAsIntegers = initCfg(cfg.booleansAsIntegers);
  cfg.allowEmptyArrays = initCfg(cfg.allowEmptyArrays);
  cfg.noFilesWithArrayNotation = initCfg(cfg.noFilesWithArrayNotation);

  if (isUndefined(obj)) {
    return fd;
  } else if (isNull(obj)) {
    if (!cfg.nullsAsUndefineds) {
      fd.append(pre, '');
    }
  } else if (isBoolean(obj)) {
    if (cfg.booleansAsIntegers) {
      fd.append(pre, obj ? 1 : 0);
    } else {
      fd.append(pre, obj);
    }
  } else if (isArray(obj)) {
    if (obj.length) {
      obj.forEach((value, index) => {
        let key = pre + '[' + (cfg.indices ? index : '') + ']';

        if (cfg.noFilesWithArrayNotation && isFile(value)) {
          key = pre;
        }

        serialize(value, cfg, fd, key);
      });
    } else if (cfg.allowEmptyArrays) {
      fd.append(pre + '[]', '');
    }
  } else if (isDate(obj)) {
    fd.append(pre, obj.toISOString());
  } else if (isObject(obj) && !isFile(obj) && !isBlob(obj)) {
    Object.keys(obj).forEach((prop) => {
      const value = obj[prop];

      if (isArray(value)) {
        while (prop.length > 2 && prop.lastIndexOf('[]') === prop.length - 2) {
          prop = prop.substring(0, prop.length - 2);
        }
      }

      const key = pre ? pre + '[' + prop + ']' : prop;

      serialize(value, cfg, fd, key);
    });
  } else {
    fd.append(pre, obj);
  }

  return fd;
}

module.exports = {
  serialize,
};

},{}],4:[function(require,module,exports){
const $ = require('cash-dom');

const Annotations = {
  init() {
    this._initAnnotations();

    $(window).on('resize', this._initAnnotations);
    $(window).on('load', this._initAnnotations);
  },

  _initAnnotations: function () {
    var imgAnnotaionI = 0;
    $('[data-annotation-x]').each(function () {
      var $annotation = $(this);
      var $img;

      $annotation.prevAll('*').each(function () {
        if ($(this).get(0).tagName.toLowerCase() === 'img') {
          $img = $(this);
          return false;

        } else if ($(this).find('img').length > 0) {
          $img = $(this).find('img').last();
          return false;
        }
      });

      if (typeof $img === 'undefined' || $img.length === 0) {
        $annotation.parent().prevAll('*').each(function () {
          if ($(this).get(0).tagName.toLowerCase() === 'img') {
            $img = $(this);
            return false;

          } else if ($(this).find('img').length > 0) {
            $img = $(this).find('img').last();
            return false;
          }
        });
      }

      if (typeof $img === 'undefined' || $img.length === 0) {
        return;
      }

      var imgAnnotationId = 'img-annotations-' + imgAnnotaionI;
      if (typeof $img.data('annotations') === 'undefined') {
        $img.data('annotations', imgAnnotationId);

        var timeout = null;
        $img.on('mouseenter', function () {
          var $this = $(this);
          clearTimeout(timeout);
          var imgAnnotationId = $this.data('annotations');
          var $annotations = $('[data-img="' + imgAnnotationId + '"]');
          $annotations.addClass('active');

          $annotations
            .off('mouseenter')
            .on('mouseenter', function () {
              clearTimeout(timeout);
            })
            .off('mouseout')
            .on('mouseout', function () {
              $this.mouseout();
            });
        }).on('mouseout', function () {
          var $this = $(this);
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            var imgAnnotationId = $this.data('annotations');
            var $annotations = $('[data-img="' + imgAnnotationId + '"]');
            $annotations.removeClass('active');
          }, 1000);
        });
        imgAnnotaionI++;
      }

      var imgX = $img.position().left;
      var imgY = $img.position().top;

      var imgW = $img.width();
      var imgH = $img.height();
      var annotationX = $annotation.data('annotation-x');
      var annotationY = $annotation.data('annotation-y');

      if (annotationX.toString().indexOf('%') !== -1) {
        annotationX = (imgW / 100 * +annotationX.replace('%', ''));
      } else if (annotationX.toString().indexOf('px') !== -1) {
        annotationX = +annotationX.replace('px', '');
      } else {
        annotationX = +annotationX;
      }

      if (annotationY.toString().indexOf('%') !== -1) {
        annotationY = (imgH / 100 * +annotationY.replace('%', ''));
      } else if (annotationY.toString().indexOf('px') !== -1) {
        annotationY = +annotationY.replace('px', '');
      } else {
        annotationY = +annotationY;
      }

      if (annotationX >= 0) {
        annotationX += imgX;
      } else {
        annotationX += imgX + imgW;
      }

      if (annotationY >= 0) {
        annotationY += imgY;
      } else {
        annotationY += imgY + imgH;
      }


      $annotation.css({
        top: annotationY,
        left: annotationX
      }).attr({
        'data-img': imgAnnotationId
      });

    });
  },
};

module.exports = Annotations;


},{"cash-dom":1}],5:[function(require,module,exports){
const Base = require('./base');
const $ = require('cash-dom');
const CouponsPage = require('../components/coupons-page');
const Poll = require('../components/poll');
const MacrosFront = require('../components/macros');
require('../../vendor/splide.min');
const Template = require('../components/template');
const Ajax = require('../components/ajax');
require("../components/accessibility-widget");

window.galleriesHtml = [];
const BaseOrganic = {
  init() {
    Base.init();
    CouponsPage.init();
    Poll.init();
    MacrosFront.init();

    //popup for slider images
    $(document).on('click', '.popup-image', function () {
      //if slider is not in the affiliate link
      if ($(this).closest('.gallery-carousel').parent().get( 0 ).tagName !== "A") {
        const gallery = $(this).closest('.gallery-carousel'),
          galleryId = gallery.attr('id'),
          galleryIdNum = gallery.attr('id').split('_')[1];

        $('#gallery-image').html(window.galleriesHtml[galleryIdNum - 1]);
        Template.popup('#gallery-image', {}, {'className': 'gallery-image-popup'});
        const popupContent = $('.gallery-image-popup .popup-content');
        popupContent.children('.gallery-carousel').attr('id', galleryId + '_popup');
        popupContent.children('.gallery-carousel').attr('data-splide',
          '{"type":"loop","focus":"center","gap":"","pagination":"slider","arrows":true}');
        popupContent.find('img').each((i, img) => {
          $(img).removeClass('popup-image');
        });
        var slideElem = $(this).closest('.splide__slide').attr('id').split('slide')[1];
        slideElem = slideElem.charAt(0) === "0" ? slideElem.slice(1) - 1 : slideElem - 1;
        new Splide('#' +galleryId + '_popup', {
          'direction': $(document.documentElement).hasClass('is-rtl') ? 'rtl' : 'ltr',
          'start': slideElem
        }).mount();
      }
    });

    //gallery carousel
    if ($('.gallery-carousel').length) {
      $('.gallery-carousel').each((i, gallery) => {
        let galleryId = $(gallery).attr('id');

        window.galleriesHtml[i] = gallery.outerHTML;

        if (galleryId) {
          new Splide('#' + galleryId, {
            'direction': $(document.documentElement).hasClass('is-rtl') ? 'rtl' : 'ltr',
            'keyboard' : false,
            'paginationKeyboard': false
          }).mount();
        }
      });
    }

    $(document).on('click', 'label.custom-checkbox', function () {
      var el = $(this).find('input[type="checkbox"]');

      if (!el.prop('disabled')) {
        el.prop('checked', !el.prop('checked'));
        $(this).toggleClass('checked', el.prop('checked'));
      }
    });

    $(document).on('click', '.toggle-show-more', function (e) {
      e.preventDefault();

      var $content = $(this).closest('.toggle-content');

      $(this).addClass('hidden');
      $content.find('.toggle-show-less').removeClass('hidden');
      $content.find('.toggle-dots').addClass('hidden');
      $content.find('.toggle-full-content').removeClass('hidden');

    }).on('click', '.toggle-show-less', function (e) {
      e.preventDefault();

      var $content = $(this).closest('.toggle-content');

      $(this).addClass('hidden');

      $content.find('.toggle-show-more').removeClass('hidden');
      $content.find('.toggle-dots').removeClass('hidden');
      $content.find('.toggle-full-content').addClass('hidden');
    });

    $('[data-video-id]').on('click', function () {
      let video_id = $(this).data('video-id');

      if ($(this).closest('.yt-video-inner').length) {
        let iframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video_id + '?feature=oembed&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe>';

        $(this).replaceWith(iframe);
      } else {
        let iframeHeight = $(this).height(),
          iframe = '<iframe width="100%" height="' + iframeHeight + '" src="https://www.youtube.com/embed/' + video_id + '?feature=oembed&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe>';

        $(this)
          .html(iframe)
          .data('video-id', null)
          .addClass('youtube-loaded', null);
      }
    });

    /** Adding .is_stuck to position:sticky element **/
    const stickyElm = document.querySelector('.sticky');
    if (stickyElm !== null) {

      let getScrollParent = function (element, includeHidden) {
        var style = getComputedStyle(element),
          excludeStaticParent = style.position === 'absolute',
          overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

        if (style.position !== 'fixed')
          for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static')
              continue;
            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
              return parent;
          }

        return window;
      };

      let throttle = function (callback, limit) {
        var wait = false;                  // Initially, we're not waiting
        return function () {               // We return a throttled function
          if (!wait) {                   // If we're not waiting
            callback.call();           // Execute users function
            wait = true;               // Prevent future invocations
            setTimeout(function () {   // After a period of time
              wait = false;          // And allow future invocations
            }, limit);
          }
        };
      };

      const stickyElmScrollableParent = getScrollParent(stickyElm);
      stickyElm._originalOffsetTop = stickyElm.offsetTop;

      const detectStickiness = (elm, cb) => () => cb & cb(elm.offsetTop != elm._originalOffsetTop);

      const onSticky = isSticky => {
        stickyElm.classList.toggle('is_stuck', isSticky);
      };

      const scrollCallback = throttle(detectStickiness(stickyElm, onSticky), 100);
      stickyElmScrollableParent.addEventListener('scroll', scrollCallback);
    }

    this._activateStickyTableScrollBar();
  },
  _activateStickyTableScrollBar: function () {
    let fixedBarTemplate = '<div class="fixed-scrollbar"><div></div></div>',
      fixedBarCSS = {display: 'none', overflowX: 'scroll', position: 'fixed', width: '100%', bottom: 0};

    $('.fixed-scrollbar-container').each(function () {
      let $container = $(this),
        $bar = $(fixedBarTemplate).appendTo($container).css(fixedBarCSS);

      $bar[0].onscroll = function () {
        $container[0].scrollLeft = $bar[0].scrollLeft;
      };

      $bar.data('status', 'off');
    });

    let fixSize = function () {
      $('.fixed-scrollbar').each(function () {
        let $bar = $(this),
          $container = $bar.parent();

        $bar.children('div').height(1).width($container[0].scrollWidth);
        $bar.width($container.width());
        $bar[0].scrollLeft = $container[0].scrollLeft;
      });
    };

    $(window).on('load.fixedbar resize.fixedbar', function () {
      fixSize();
    });

    let scrollTimeout = null;

    $(window).on('scroll.fixedbar', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        $('.fixed-scrollbar-container').each(function () {
          let $container = $(this),
            $bar = $container.children('.fixed-scrollbar');

          if ($bar.length) {
            let containerOffset = {top: $container.offset().top, bottom: $container.offset().top + $container.height()},
              windowOffset = {top: window.pageYOffset, bottom: window.pageYOffset + $(window).height()};
            if ((containerOffset.top > windowOffset.bottom) || (windowOffset.bottom > containerOffset.bottom)) {
              if ($bar.data('status') == 'on') {
                $bar.hide().data('status', 'off');
              }
            } else {
              if ($bar.data('status') == 'off') {
                $bar.show().data('status', 'on');
                $bar[0].scrollLeft = $container[0].scrollLeft;
              }
            }
          }
        });
      }, 50);
    });

    $(window).trigger('scroll.fixedbar');
  }

};

module.exports = BaseOrganic;

},{"../../vendor/splide.min":42,"../components/accessibility-widget":14,"../components/ajax":16,"../components/coupons-page":17,"../components/macros":23,"../components/poll":25,"../components/template":32,"./base":6,"cash-dom":1}],6:[function(require,module,exports){
require('../components/ga-events');
const CustomSelect = require('./custom-select');
const LanguageAndCurrencySelectors = require('./language-and-currency-selectors');
const JsLinks = require('./js-links');
const Annotations = require('./annotations');
const ScrollToTop = require('./scroll-to-top');
const ExitPopup = require('./exit-popup');
const MainSearch = require('./main-search');
const MobileMenu = require('./mobile-menu');
const $ = require('cash-dom');
const DynamicData = require('../components/dynamic-data');
const Tooltip = require('../components/tooltips');
const ShareButtons = require('../components/share-buttons');
const Video = require('../components/video');
require('../components/keyboard-navigation');

const Base = {
  init() {
    const self = this;

    DynamicData.init();
    CustomSelect.init();
    LanguageAndCurrencySelectors.init();
    JsLinks.init();
    Annotations.init();
    ScrollToTop.init();
    ExitPopup.init();
    MainSearch.init();
    MobileMenu.init();
    Tooltip.init();
    ShareButtons.init();
    Video.init();

    $('.adsbygoogle').each(function () {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });

    if(document.body.textContent.includes('/go/')){
      $('.top-disclosure').show();
    }

    //dropdown-box shortcode
    $(document).on('mousedown', '.article-dropdown-box-container .dropdown-box-title', (e) => {
      e.preventDefault();

      $(e.target).closest('.article-dropdown-box-container').toggleClass('active');
    });
  },
};

module.exports = Base;

},{"../components/dynamic-data":19,"../components/ga-events":21,"../components/keyboard-navigation":22,"../components/share-buttons":28,"../components/tooltips":33,"../components/video":35,"./annotations":4,"./custom-select":7,"./exit-popup":8,"./js-links":9,"./language-and-currency-selectors":10,"./main-search":11,"./mobile-menu":12,"./scroll-to-top":13,"cash-dom":1}],7:[function(require,module,exports){
const $ = require('cash-dom');

const CustomSelect = {
  init() {
    /*Triggers custom change event. Use $('.select-custom').on('change', function (e, value) {}); to catch */
    $(document).on('click', '.select-custom .selected', function () {
      $(this).closest('.select-custom').toggleClass('opened');

      let watcher = $(this).closest('.watch-select-custom');

      if (watcher.length) {
        let toggle = !!watcher.find('.select-custom.opened').length;

        watcher.toggleClass('select-custom-opened', toggle);
      }
    });

    $(document).on('click', '.select-custom .options .option', function (e) {
      if ($(this).attr('href') === '#') {
        e.preventDefault();
      }
      var title = $(this).html(),
        value = $(this).attr('data-value'),
        select = $(this).closest('.select-custom'),
        inp = select.find('input');

      select.find('.selected').html(title);

      if (inp.length) {
        inp.val(value);
      }

      select.removeClass('opened');

      select.trigger('change', value);

      if ($(this).closest('.watch-select-custom').length) {
        $(this).closest('.watch-select-custom').removeClass('select-custom-opened');
      }
    });

    $(document).on('click', '.select-custom-close', function () {
      $('.select-custom').removeClass('opened');

      if ($(this).closest('.watch-select-custom').length) {
        $(this).closest('.watch-select-custom').removeClass('select-custom-opened');
      }
    });
  },
};

module.exports = CustomSelect;


},{"cash-dom":1}],8:[function(require,module,exports){
const $ = require('cash-dom');
const popup = require('../components/popup');
const GAEvents = require('../components/ga-events');
const Ajax = require('../components/ajax');
const Device = require('../components/device');
const Cookie = require('js-cookie');
const ouibounce = require('../../vendor/ouibounce.min');
const DynamicData = require('../components/dynamic-data');

const ExitPopup = {
  _mobilePopupShown: false,

  init() {
    this._initExitPopup();
    this._initCountdown();
  },

  _initExitPopup() {
    if (Device.isGPSI()) {
      return;
    }

    let self = this;
    let forceExitIntent = (window.location.hash === '#force-exit-intent');
    let loadExitPopup = forceExitIntent || self._isCookieNotSet();
    let isMobile = Device.isMobile();
    let comparisonId = $('#comparison_id').length ? $('#comparison_id').val() : '';

    if (!loadExitPopup) {
      return false;
    }

    Ajax.post(ajaxurl, {
      action: 'load-exit-intent',
      url: window.location.href,
      post_id: $('body').first().data('post-id'),
      is_mobile: +isMobile,
      comparison_id: comparisonId,
    }, function (html) {
      const $exitPopup = $(html.trim());

      if (!$exitPopup.length) {
        return false;
      }

      $(document.body).append($exitPopup);

      if (forceExitIntent) {
        if (isMobile) {
          self._showMobilePopup('password meter copy button');
        } else {
          self._showPopup();
        }
      } else if ($(document.body).hasClass('page-template-password-generator')) {
        //password page has custom trigger event
        document.addEventListener("password-meter-copy-clicked", (e) => {
          if (isMobile) {
            self._showMobilePopup('password meter copy button', true);
          } else {
            self._showPopup(true);
          }
        }, false);
      } else if (isMobile) {
        //mobile device
        if (!self._shouldDisplayMobilePopup()) {
          return false;
        }

        let popupShown = false,
            timeoutId = null,
            secondVendor = $('.vendor-card[data-pos="1"]');

        if (!secondVendor.length) {
          secondVendor = $('.single-vendor[data-pos="1"]');
        }

        if (!secondVendor.length && $('.vendor-card-shortcode').length) {
          secondVendor = $($('.vendor-card-shortcode')[0]);
        }

        if (!secondVendor.length && $('.vendor-screenshot-block').length) {
          secondVendor = $($('.vendor-screenshot-block')[0]);
        }

        const startPopupTimer = function() {
          clearTimeout(timeoutId);

          timeoutId = setTimeout(function () {
            if (popupShown) return;

            self._showMobilePopup('time trigger 5 seconds', true);
            popupShown = true;
          }, 5000);
        }

        startPopupTimer();

        window.addEventListener('scroll', function () {
          if (popupShown) return;

          startPopupTimer();

          if (secondVendor.length && secondVendor.get(0).getBoundingClientRect().bottom < -10) {
            self._showMobilePopup('vendor trigger', true);
            popupShown = true;
            clearTimeout(timeoutId);
          }
        }, { passive: true });
      } else {
        //desktop
        ouibounce($exitPopup.get(0), {
          aggressive: forceExitIntent,
          sitewide: true,
          cookieDomain: '.' + window.location.host,
          timer: 150, //3000,
          delay: 30, //500,
          cookieExpire: 30,
          cookieName: '_exit_ppc_pp',
          callback: self._showPopup,
        });
      }
    });
  },

  _showPopup(setCookie = false) {
    const $exitPopup = $('#exit-popup'),
          self = ExitPopup, //b/c we are using it as Ouibounce callback
          options = {};

    if (setCookie) {
      Cookie.set('_exit_ppc_pp', true);
    }

    if (typeof $exitPopup.attr('data-class-name') !== 'undefined') {
      options['className'] = $exitPopup.attr('data-class-name');
    }

    popup.show($exitPopup.html(), options);

    self.sendExitPopupEvents($exitPopup);

    if (typeof DynamicData !== 'undefined') {
      DynamicData.update();
    }

    self._initCountdown();
  },

  _showMobilePopup(triggerType, setCookie = false) {
    const self = this;
    const $exitPopup = $('#exit-popup');

    if (!$exitPopup || !$exitPopup.length) {
      return false;
    }

    const className = $exitPopup.attr('data-class-name');
    const isPpc = className && className.indexOf('organic-exit-intent') === -1;
    const align = $exitPopup.attr('data-mobile-align');

    const options = {
      className: className,
    };

    if (!isPpc) {
      options['align'] = align ? align : 'top';
      options['backgroundLayer'] = false;
    }

    self._mobilePopupShown = true;

    if (setCookie) {
      Cookie.set('_exit_ppc_pp', true);
    }

    popup.show($exitPopup.html(), options);
    self.sendExitPopupEvents($exitPopup, true, triggerType);

    self._initCountdown();
  },

  _initCountdown() {
    const self = this;

    if (!$('.countdown').length) {
      return false;
    }

    if ($('.countdown.initialized[data-time-left]').first().length) {
      return false;
    }

    // for the proper init we need to run this for the first time not in setInterval().
    this._runCountdownTimer();

    const countdownIntervalId = setInterval(function () {
      self._runCountdownTimer(countdownIntervalId);
    }, 1000);

    setTimeout(function () {
      $('.countdown').css({opacity: 1});
    }, 1000);

  },

  _runCountdownTimer(countdownIntervalId) {
    $('.countdown[data-time-left]').each(function () {
      $(this).addClass('initialized');
      let distance = $(this).data('time-left') - 1;

      if (distance < 1) {
        clearInterval(countdownIntervalId);
      }

      $(this).data('time-left', distance);

      let days = Math.floor(distance / (60 * 60 * 24)).toString(),
        hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60)).toString(),
        minutes = Math.floor((distance % (60 * 60)) / (60)).toString(),
        seconds = Math.floor((distance % 60)).toString();

      if (days.length < 2) {
        days = '0' + days;
      }

      if (hours.length < 2) {
        hours = '0' + hours;
      }

      if (minutes.length < 2) {
        minutes = '0' + minutes;
      }

      if (seconds.length < 2) {
        seconds = '0' + seconds;
      }

      $(this).find('[data-countdown]').each(function () {
        switch ($(this).data('countdown')) {
          case 'days':
            $(this).text(days);
            break;
          case 'hours':
            $(this).text(hours);
            break;
          case 'minutes':
            $(this).text(minutes);
            break;
          case 'seconds':
            $(this).text(seconds);
            break;
        }

      });
    });
  },

  sendExitPopupEvents(popup, isMobile, triggerType) {
    let name = popup.attr('data-name'),
      vendor = typeof popup.attr('data-vendor') !== 'undefined' ?
        popup.attr('data-vendor') :
        popup.find('img:first').attr('alt'),
      action = 'impression';

    if (triggerType) {
      action += ' - ' + triggerType;
    }
    action += ' - ' + GAEvents.getPageName(window.location.href);

    GAEvents.sendEvent(
      isMobile ? 'mobile exit popup' : 'exit popup',
      action,
      vendor,
      true
    );

    if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
      let aloomaData = aloomaPageData;

      if (typeof name !== 'undefined' && name !== '') {
        aloomaData.pop_name = name;
      }

      let popup_href = popup.find('#cboxInnerContent').length > 0 ? popup.find('#cboxInnerContent').data('href') : '';

      if (popup_href) {
        let vendor_id_in_href = popup_href.match(/\/go\/vendor\/([a-z\-0-9]+)\/(\d+)\//);
        let vendor_id = '';

        if (vendor_id_in_href !== null && typeof vendor_id_in_href[2] !== 'undefined') {
          if (typeof vendor_id_in_href[2] !== 'undefined') {
            vendor_id = +vendor_id_in_href[2];
          }
        } else {
          let vendor_id_in_href = popup_href.match(/\/go\/vendor\/(\d+)\//);

          if (vendor_id_in_href !== null && typeof vendor_id_in_href[1] !== 'undefined') {
            vendor_id = +vendor_id_in_href[1];
          }
        }

        if (vendor_id !== '') {
          aloomaData.vendor_id = vendor_id;
        }
      }


      if (isMobile && triggerType) {
        aloomaData.trigger_type = triggerType;
      }

      if (typeof applyAloomaTracking !== 'undefined') {
        applyAloomaTracking();
      }

      aloomaSendEvent('exit_intent_fired', aloomaData);
    }
  },

  _showIfUserIsInactive(seconds, callback) {
    // Set the javascript window events to monitor activity
    window.onload = activityDetected;      // detects initial load / reload
    window.onkeypress = activityDetected;  // detects key presses
    window.onclick = activityDetected;     // detects mouse clicks
    //window.onmousemove = activityDetected; // detects mouse movement
    window.onscroll = activityDetected;    // detects arrow key scrolling
    window.onmousedown = activityDetected; // detects touchscreen interaction

    callback = callback || function () {
    };

    let timer,
      timout = 1000 * seconds;

    function activityDetected() {
      clearTimeout(timer);
      timer = setTimeout(callback, timout);
    }
  },

  _shouldDisplayMobilePopup() {
    const $exitPopup = $('#exit-popup');

    return $(window).height() > 525 &&
      $exitPopup &&
      $exitPopup.length &&
      $exitPopup.find('.mobile-popup').length > 0;
  },

  _isCookieNotSet() {
    return typeof Cookie.get('_exit_ppc_pp') === 'undefined';
  }
};

module.exports = ExitPopup;


},{"../../vendor/ouibounce.min":40,"../components/ajax":16,"../components/device":18,"../components/dynamic-data":19,"../components/ga-events":21,"../components/popup":26,"cash-dom":1,"js-cookie":2}],9:[function(require,module,exports){
const $ = require('cash-dom');

const JsLinks = {
  init() {
    const self = this;

    $(document).on('click keydown', '[data-href]', function (e) {
      if (e instanceof KeyboardEvent && e.key !== "Enter") {
        return;
      }

      var targetTag = $(e.target).prop('tagName');

      if ($(e.target).hasClass('unbind-data-href') ||
        $(this).hasClass('unbind-data-href') ||
        $(e.target).closest('.unbind-data-href').length ||
        ['INPUT', 'SELECT', 'TEXTAREA'].indexOf(targetTag) >= 0)
      {
        return;
      }

      self.emulateLink('', $(this));
    });
  },

  emulateLink(href, clickedElement) {
    clickedElement = $(clickedElement);

    if (typeof href === 'undefined' || !href.length) {
      href = clickedElement.data('href');
    }

    if (!href) {
      return;
    }

    var target = clickedElement.data('target');

    if (target === 'blank') {
      var a = $('<a>').attr({
        'href': href,
        'target': '_blank',
        'rel': 'nofollow',
        'id': 'link_for_click'
      });

      if (typeof clickedElement.data('rel') !== 'undefined') {
        a.attr('rel', clickedElement.data('rel'));
      }

      if (typeof clickedElement.data('ga-event') !== 'undefined') {
        a.attr('data-ga-event', clickedElement.data('ga-event'));
      }

      if (typeof clickedElement.data('ga-label') !== 'undefined') {
        a.attr('data-ga-label', clickedElement.data('ga-label'));
      }

      if (typeof clickedElement.data('ga-prefix') !== 'undefined') {
        a.attr('data-ga-prefix', clickedElement.data('ga-prefix'));
      }

      if (typeof clickedElement.data('ga-suffix') !== 'undefined') {
        a.attr('data-ga-suffix', clickedElement.data('ga-suffix'));
      }

      if (typeof clickedElement.attr('title') !== 'undefined') {
        a.attr('title', clickedElement.attr('title'));
      }

      if (typeof clickedElement.attr('data-title') !== 'undefined') {
        a.attr('data-title', clickedElement.attr('data-title'));
      }

      if (typeof clickedElement.attr('data-btn-name') !== 'undefined') {
        a.attr('data-btn-name', clickedElement.attr('data-btn-name'));
      }

      $(document.body).append(a);
      $('#link_for_click')[0].click();
      $('#link_for_click').remove();
    } else {
      if (typeof GAEvents !== 'undefined') {
        GAEvents.trackClick(clickedElement.get(0));
      }
      window.location.href = href;
    }
  },
};

window.JsLinks = JsLinks;
module.exports = JsLinks;

},{"cash-dom":1}],10:[function(require,module,exports){
const $ = require('cash-dom');
const Cookie = require('js-cookie');
const Page = require('../components/page');

const LanguageAndCurrencySelectors = {
  init() {
    $('#header_languages .selected').on('click', function () {
      $('#header_currencies').removeClass('opened');
    });

    $('#header_currencies .selected').on('click', function () {
      $('#header_languages').removeClass('opened');
    });

    $('#footer_currencies, #header_currencies').on('change', function (e, value) {
      Cookie.set('chosen-currency', value, {
        expires: 31,
        path: '/',
        domain: '.' + window.location.host.replace(/^(\w{2,3}\.)?(.+)/, '$2')
      });

      location.reload();
    });

    //TODO: return if needed
    /*$('#header_languages').on('change', function (e, value) {
      if (value === 'en') {
        value = 'www';
      }

      var url = location.href;
      url = url.replace(/:\/\/\w{2,3}\./, '://' + value + '.');
      window.location.replace(decodeURI(url));
    });*/

    //append needed GET params to Languages links
    let params = Page.getSearchParameters();

    $('#header_languages .option').each(function () {
      let option = $(this),
        href = option.attr('href');

      if (typeof href !== 'undefined' && href.length) {
        for (let param in params) {
          if (params.hasOwnProperty(param) && href.indexOf(param) === -1) {
            if (href.indexOf('?') === -1) {
              href += '?';
            } else {
              href += '&';
            }

            href += param + '=' + params[param];
          }
        }

        option.attr('href', href);
      }
    });
  },
};

module.exports = LanguageAndCurrencySelectors;

},{"../components/page":24,"cash-dom":1,"js-cookie":2}],11:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('../components/page');
const Ajax = require('../components/ajax');

const MainSearch = {
  _$mainSearch: $('#main-search'),
  _$mainSearchHolder: $('#main-search-holder'),
  _$mainSearchHolderInput: $('#main-search-holder input'),
  _$mainSearchHolderResults: $('#main-search-holder .results'),

  init() {
    const self = this;

    self._$mainSearch.on('click', function (e) {
      e.preventDefault();

      self._$mainSearchHolder.toggleClass('active');
      $('body').toggleClass('search-active');
      self._$mainSearchHolderInput.first().trigger('focus');
      self._mainSearch();
    });

    $('#main-search-close').on('click', function (e) {
      e.preventDefault();
      self._$mainSearchHolder.removeClass('active');
      $('body').removeClass('search-active');
      Page.finishLoad('main-search-load');

      if (self._$mainSearchHolder.hasClass('active-on-results')) {
        self._$mainSearchHolderResults.html('');
        self._$mainSearchHolderInput.first().val('');
      }

      let watcher = $(this).closest('.watch-search-results');

      if (watcher.length) {
        watcher.removeClass('search-results-active');
      }
    });

    var mainSearchTimeout = null;
    self._$mainSearchHolderInput.first().on('keyup', function (e) {

      var isUpDown = false;
      var $results = self._$mainSearchHolderResults;
      var selectedIndex = 0;

      if ($results.find('.search-entry').length > 0) {
        selectedIndex = $results.find('.selected').index();
        switch (e.which) {
          case 38: // up
            selectedIndex--;
            isUpDown = true;
            break;

          case 40: // down
            selectedIndex++;
            isUpDown = true;
            break;

          case 13: // enter
            e.preventDefault();
            $results.find('.selected').trigger('click');
            break;
        }
      }

      if (isUpDown) {
        if (selectedIndex < 0) {
          selectedIndex = $results.find('.search-entry').length - 1;
        }

        if (selectedIndex > ($results.find('.search-entry').length - 1)) {
          selectedIndex = 0;
        }


        $results.find('.search-entry.selected').removeClass('selected');
        $results.find('.search-entry:eq(' + selectedIndex + ')').addClass('selected');

        if ($results.find('.search-entry.selected').length > 0) {
          $(this).val($results.find('.search-entry.selected').data('label'));
        }
      }

      //do search
      if (!isUpDown) {
        clearTimeout(mainSearchTimeout);

        mainSearchTimeout = setTimeout(function () {
          self._mainSearch();
        }, 500);

        //navigate through results
      } else {

      }
    });

    $('#search_nav_toggler').on('click', function (e) {
      $('.lang-curr-togglers .select-custom').removeClass('opened');
      $('#main_nav').removeClass('show');
      $('#search_nav').toggleClass('show');
    });

    if (window.location.hash !== '') {
      var hashMatches = window.location.hash.match(/#s=(.+)/);

      if (hashMatches && typeof hashMatches[1] !== 'undefined') {
        self._$mainSearchHolderInput.val(decodeURIComponent(hashMatches[1].replace(/\+/g, ' ')));
        self._$mainSearch.click();
      }
    }
  },

  _mainSearch() {
    const self = this;

    var data = {};
    data['query'] = self._$mainSearchHolderInput.first().val();
    data['action'] = 'main-search';
    Page.finishLoad('main-search-load');
    Page.startLoad('main-search-load', '#main-search-holder input');

    Ajax.post(ajaxurl, data, function (results) {
      self._$mainSearchHolderResults.html(results);
      $('#main-search-holder .results .search-entry').first().addClass('selected');

      if (self._$mainSearchHolder.hasClass('active-on-results')) {
        self._$mainSearchHolder.addClass('active');
      }

      let watcher = $('.watch-search-results');

      if (watcher.length) {
        watcher.addClass('search-results-active');
      }
      Page.finishLoad('main-search-load');

    });
  },
};

module.exports = MainSearch;

},{"../components/ajax":16,"../components/page":24,"cash-dom":1}],12:[function(require,module,exports){
const $ = require('cash-dom');
const Device = require('../components/device');

const MobileMenu = {
  init() {
    // mobile menu toggler
    $('#main_nav_toggler').on('click', function (e) {
      $('.lang-curr-togglers .select-custom').removeClass('opened');
      $('#search_nav').removeClass('show');
      $('#main_nav').toggleClass('show');
      $(this).toggleClass('active');
    });

    //mobile submenu collapse
    $('#main_nav').on('click', 'li.nav-item.dropdown a', function (e) {
      if (Device.isTablet()) {
        const subMenu = $(this).next('.sub-menu');
        if (subMenu.length > 0 && !subMenu.hasClass('no-categories-menu')) {
          e.preventDefault();
        }

        $(this).parent('li').toggleClass('submenu-collapse');
      }
    });
  },
};

module.exports = MobileMenu;

},{"../components/device":18,"cash-dom":1}],13:[function(require,module,exports){
const $ = require('cash-dom');

const ScrollToTop = {
  init() {
    const $scrollCtrl = $('#scroll-to-top');

    $scrollCtrl.on('click', function (e) {
      e.preventDefault();

      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    });

    $(window).on('scroll resize', function () {
      // let scrollTop = $(document).scrollTop(),
      let scrollTop = document.querySelector('html').scrollTop,
        windowHeight = $(window).height(),
        showOnScrollMobile = windowHeight;

      if ($(window).width() > 700 && (scrollTop - windowHeight) > 0) {
        //desktop
        $scrollCtrl.addClass('active');
      } else if ($(window).width() <= 700 && (showOnScrollMobile - scrollTop) < 150) {
        //mobile
        $scrollCtrl.addClass('active');
      } else {
        $scrollCtrl.removeClass('active');
      }
    });
  }
};

module.exports = ScrollToTop;

},{"cash-dom":1}],14:[function(require,module,exports){
const $ = require('cash-dom');

$(function () {
	const $showAccessibilityButton = $('#show-accessibility-button');

	if ($showAccessibilityButton.length) {
		require("../../vendor/sienna.min");
	}

	// we use setInterval() because the button is not on page immediately
	const intervalId = setInterval(() => {
		const $accessibilityWidgetButton = $('.asw-widget .asw-menu-btn');

		if ($accessibilityWidgetButton.length) {
			$accessibilityWidgetButton.attr('data-btn-name', 'accessibility-widget');
			clearInterval(intervalId);
		}
	}, 50);
});

},{"../../vendor/sienna.min":41,"cash-dom":1}],15:[function(require,module,exports){
/**
 * Uses as response of ajax requests.
 * @see Ajax.post()
 */
class AjaxResponse {
  constructor() {
    this._done = [];
    this._fail = [];
    this._always = [];
  }

  done(callback) {
    this._done.push(callback);
    return this;
  }

  runDone(response) {
    for (const doneHandler of this._done) {
      doneHandler(response);
    }
  }

  fail(callback) {
    this._fail.push(callback);
    return this;
  }

  runFail(error) {
    for (const failHandler of this._fail) {
      failHandler(error);
    }
  }

  always(callback) {
    this._always.push(callback);
    return this;
  }

  runAlways() {
    for (const alwaysHandler of this._always) {
      alwaysHandler();
    }
  }
}

module.exports = AjaxResponse;

},{}],16:[function(require,module,exports){
const AjaxResponse = require('./ajax-response');
const {serialize} = require('object-to-formdata');

const Ajax = {
  /**
   * Makes HTTP request to the server.
   * @param {string} method HTTP method (GET, POST)
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  request(method, url, data, callback, responseType = 'text') {
    const self = this;

    const ajaxResponse = new AjaxResponse();
    const formData = this._getFormData(data);

    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.responseType = responseType;

    xhr.send(formData);

    xhr.onload = function () {
      self._handleOnLoad(xhr, ajaxResponse, callback);
    };

    xhr.onerror = function () {
      self._handleOnError(ajaxResponse);
    };

    return ajaxResponse;
  },
  _getFormData(data) {
    if (!data) {
      return null;
    }

    let formData = null;

    if (data instanceof FormData) {
      formData = data;
    } else if (data && typeof data === 'object') {
      formData = serialize(data, {indices: true, allowEmptyArrays: false});
    } else {
      console.warn('Wrong post data format. Cannot transform into FormData.');
    }

    return formData;
  },

  _handleOnLoad(xhr, ajaxResponse, callback) {
    if (+xhr.status !== 200) {
      ajaxResponse.runFail(new Error('Error ' + xhr.status + ': ' + xhr.statusText));
    } else {
      if (typeof callback === 'function') {
        callback(xhr.response);
      }

      ajaxResponse.runDone(xhr.response);
    }

    ajaxResponse.runAlways();
  },

  _handleOnError(ajaxResponse) {
    ajaxResponse.runFail(new Error('Request failed'));
    ajaxResponse.runAlways();
  },

  /**
   * Makes POST request
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  post(url, data, callback, responseType = 'text') {
    return this.request('POST', url, data, callback, responseType)
  },

  /**
   * Makes GET request
   * @param {string} url
   * @param {*|FormData} data
   * @param {function} callback Signature of the callback: `function (error, response)`.
   * If error is null, then success response.
   * @param {XMLHttpRequestResponseType} responseType
   * @return {AjaxResponse}
   */
  get(url, data, callback, responseType) {
    return this.request('GET', url, data, callback, responseType);
  },
};

module.exports = Ajax;

},{"./ajax-response":15,"object-to-formdata":3}],17:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');
const Template = require('./template');
const Validator = require('./validator');
const JsLinks = require('../common/js-links');

const CouponsPage = {
  page: 1,
  initShowMore: function () {
    const self = this;

    $(document).on('click', '.show-more-coupons', function (e) {
      e.preventDefault();

      Page.startLoad('coupons-list', '.coupons-list-holder');

      $(this).remove();

      self.page++;

      var data = {'_page': self.page};

      Ajax.get(location.href, data, function (html) {
        Page.finishLoad('coupons-list');

        $('.coupons-page').find('.loadable-content').append($(html).find('.coupons-page').find('.loadable-content').html());
      }, 'text');
    });
  },
  initVote: function () {
    $(document).on('click', '.coupon-vote', function (e) {
      e.preventDefault();

      var voter = $(this),
        coupon_id = voter.data('coupon-id'),
        tag = 'coupon-vote-' + coupon_id,
        couponHolder = $('.coupon-holder[data-coupon-id="' + coupon_id + '"]'),
        couponPopup = voter.closest('.coupon-popup-content');

      if (Page.tagIsFree(tag)) {
        Page.startLoad(tag, 'popup');

        Ajax.post(
          ajaxurl,
          {
            action: 'coupon_vote',
            coupon_id: coupon_id,
            vote: !voter.is('.voted') ? voter.data('vote') : 'cancel'
          },
          function (response) {
            if (response.success === true) {
              couponHolder.find('.vote-successful').text(response.successful);

              couponPopup.find('.vote-count').text(response.votes);
              couponPopup.find('.coupon-vote.voted').removeClass('voted');
              couponPopup.find('.coupon-vote[data-vote="' + response.vote + '"]').addClass('voted');
            }
          },
          'json'
        ).always(function () {
          Page.finishLoad(tag);
        });
      }
    });
  },
  initEmailPopup: function () {
    $(document).on('click', '.coupon-email', function (e) {
      e.preventDefault();

      var id = $(this).attr('data-coupon-id');

      Page.closePopups();

      Template.popup($('.coupon-email-popup'), {'id': id}, {className: 'coupon-popup template-popup'});
    });

    $(document).on('click', '.send-coupon-email', function (e) {
      e.preventDefault();

      Page.startLoad('coupon-email', 'popup');

      var popup = $(this).closest('.coupon-email-popup-content'),
        form = $(this).closest('form');

      Ajax.post(ajaxurl, {
        'action': 'coupon_email',
        'email': popup.find('[name="email"]').val(),
        'coupon_id': popup.find('[name="coupon_id"]').val(),
      }, function (res) {
        if (res.success) {
          Page.closePopups();
        } else if (typeof res.errors !== 'undefined' && res.errors.length > 0) {
          Validator.validate(form, res.errors, false);
        }
      }, 'json').always(function () {
        Page.finishLoad('coupon-email');
      });
    });
  },
  initCouponPopup: function () {
    let self = this;

    setTimeout(function () {
      //  let coupon_id = window.location.hash !== 'undefined' && window.location.hash.length > 1 ?
      //    window.location.hash.substr(1) :
      //    '';
      let coupon_id = '';
      let couponMatch = window.location.pathname.match(/coupons\/(\d+)\//);
      if (couponMatch && typeof couponMatch[1] !== 'undefined' && couponMatch[1]) {
        coupon_id = couponMatch[1];
      }
      if (coupon_id) {
        self._showCouponPopup(coupon_id);
      }
    }, 1000);
  },
  couponClick: function (el, targetEl) {
    if (typeof el === 'undefined' || $(targetEl).closest('.share_buttons').length) {
      return false;
    }

    let self = this,
      coupon = $(el).closest('.coupon-holder'),
      couponPermalink = coupon.attr('data-coupon-permalink'),
      redirectLink = $(el).attr('data-href'),
      couponId = coupon.attr('data-coupon-id');

    if (coupon.hasClass('coupon-shortcode')) {
      if (coupon.hasClass('with-code')) {
        self._showCouponPopup(couponId);
      } else {
        JsLinks.emulateLink('', $(el));
      }
    } else {
      if (typeof couponPermalink !== 'undefined' && couponPermalink) {
        JsLinks.emulateLink(couponPermalink, $(el));
        setTimeout(function () {
          window.location.assign(redirectLink);
        }, 300);
      } else {
        self._showCouponPopup(couponId);
      }
    }
  },
  couponKeydown: function (el, event) {
    if (event.keyCode === 13) {
      this.couponClick(el, event.target);
    }
  },
  _showCouponPopup: function (couponId) {
    Ajax.post(ajaxurl, {
      action: 'get_coupon_popup',
      coupon_id: couponId
    }, function (res) {
      if (!res.length) {
        return;
      }

      Template.popup(res, [], {className: 'coupon-popup'});
    }, 'text');
  },
  initShortcodeClick: function () {
    let self = this;

    $(document).on('click', '.coupon-discount-shortcode.with-code', function (e) {
      e.preventDefault();

      let couponId = $(this).attr('data-coupon-id');

      if (couponId) {
        self._showCouponPopup(couponId);
      }
    });
  },
  initTimeleft() {
    const now = Date.now();

    $('[data-timeleft]').each(function () {
      let end = $(this).data('timeleft') * 1000,
        daysLeft = Math.round((end - now) / (1000 * 60 * 60 * 24)),
        text = $(this).data('default');
      if (daysLeft > 0) {
        text = daysLeft + ' ' + (daysLeft > 1 ? tr('days') : tr('day'));
      }
      $(this).text(text);
    });
  },
  init: function () {
    var self = this;

    self.initCouponPopup();
    self.initEmailPopup();
    self.initVote();
    self.initShowMore();
    self.initShortcodeClick();
  }
};

window.CouponsPage = CouponsPage;
module.exports = CouponsPage;

},{"../common/js-links":9,"./ajax":16,"./page":24,"./template":32,"./validator":34,"cash-dom":1}],18:[function(require,module,exports){
const $ = require('cash-dom');

const DeviceSizes = {
    'screen-xs-min': 480,
    'screen-xs-max': 767 - 1,
    'screen-sm-min': 767,
    'screen-sm-max': 992 - 1,
    'screen-md-min': 992,
    'screen-md-max': 1200 - 1,
    'screen-lg-min': 1200
};

const Device = {
    'screen-xs-min': 480,
    'screen-xs-max': 767 - 1,
    'screen-sm-min': 767,
    'screen-sm-max': 992 - 1,
    'screen-md-min': 992,
    'screen-md-max': 1200 - 1,
    'screen-lg-min': 1200,
    'breakpointMap': {
        'mobile': {'max': DeviceSizes['screen-xs-max']},
        'mobile-xs': {'max': DeviceSizes['screen-xs-min']},
        'non-mobile': {'min': DeviceSizes['screen-sm-min']},
        'tablet': {'max': DeviceSizes['screen-sm-max']},
        'tablet-landscape': {'max': DeviceSizes['screen-md-max']},
        'screen': {'min': DeviceSizes['screen-md-min']},
        'big-screen': {'min': DeviceSizes['screen-lg-min']}
    },
    breakpoint: function (point) {
        var map = this.breakpointMap[point];
        if (map) {
            if (window.matchMedia) {
                var queries = [];
                if (map.min) {
                    queries.push("(min-width: " + map.min + "px)");
                }
                if (map.max) {
                    queries.push("(max-width: " + map.max + "px)");
                }
                return window.matchMedia(queries.join(" and ")).matches;
            } else {
                if (map.min) {
                    if ($(window).width() < map.min) {
                        return false;
                    }
                }
                if (map.max) {
                    if ($(window).width() > map.max) {
                        return false;
                    }
                }
                return true;
            }
        }
    },
    isMobile: function (bigScreenCheck) {
        return this.breakpoint('mobile') || this.isMobileUA();
    },
    isMobileXS: function () {
        return this.breakpoint('mobile-xs');
    },
    isTablet: function () {
        return this.breakpoint('tablet');
    },
    isTabletLandscape: function () {
        return this.breakpoint('tablet-landscape');
    },
    isScreen: function () {
        return this.breakpoint('screen');
    },
    isBigScreen: function () {
        return this.breakpoint('big-screen');
    },
    isTouch: function () {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

        var mq = function (query) {
            return window.matchMedia(query).matches;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    },

    isGPSI: function() {
        return navigator.userAgent.indexOf("Speed Insights") !== -1 || navigator.userAgent.indexOf("Lighthouse") !== -1;
    },

    isMobileUA: function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }
};

module.exports = Device;

},{"cash-dom":1}],19:[function(require,module,exports){
const $ = require('cash-dom');
const Ajax = require('./ajax');

const DynamicData = {
  loaded: false,
  post_id: null,
  registered_for_observing: [],
  _active: function () {
    if (this.loaded) {
      return;
    }
    this.loaded = true;
    return $('.dynamic-data').length > 0;
  },
  _getDynamicDataFromElement: function (el) {
    let data = el.attr('data-dynamic-params');

    if (typeof data === 'undefined') {
      data = {};

      let elData = el.data();

      if (elData) {
        for (let key in elData) {
          if (elData.hasOwnProperty(key) && key.indexOf('dynamicParameter') === 0) {
            let formattedKey = key.replace('dynamicParameter', '').toLocaleLowerCase();
            data[formattedKey] = elData[key];
          }
        }
      }
    } else {
      data = JSON.parse(data);
    }

    if (data) {
      data['hash'] = el.attr('data-dynamic-hash');
      data['post_id'] = this.post_id;
    }

    return data;
  },
  _loadData: function (data) {
    let self = this;

    if (typeof data !== 'object' || !data.length) {
      return false;
    }

    Ajax.post(ajaxurl, {
      action: 'load-dynamic-data',
      post_id: self.post_id,
      data: data
    }, function (response) {
      response.forEach(function (item) {
        if (item['hash']) {

          let $container = $('[data-dynamic-hash="' + item['hash'] + '"]');

          if ($container.length > 0) {
            $container.each(function () {
              let $dynamic = item['result'] ? $($.parseHTML(item['result'])) : '';
              /**
               * For some HTML holders we need to load only plain text (no HTML), for example, for coupon-title shortcodes in quick nav
               * Please add class "dynamic-data-no-html" to the dynamic data holder and plain text will be loaded
               */
              if ($(this).closest('.dynamic-data-no-html').length > 0 && typeof $dynamic.text !== 'undefined') {
                $dynamic = $dynamic.text();
                $dynamic = document.createTextNode($dynamic);
              }

              if (item['result']) {
                $(this).replaceWith($dynamic);
              } else {
                $(this).remove();
              }
            });
          } else {
            //Search in meta attributes
            $('meta, head title').each(function () {
              let metaTag = $(this),
                content = metaTag.prop('tagName') === 'TITLE' ? metaTag.text() : metaTag.attr('content');

              if (typeof content !== 'undefined' && content.length && content.indexOf('dynamic-data') >= 0) {
                let $container = $('<div>' + content + '</div>').find('[data-dynamic-hash="' + item['hash'] + '"]');

                if ($container.length) {
                  let dataReplacer = item['result'] ? item['result'] : '';

                  content = content.replace($container.get(0).outerHTML, dataReplacer);

                  if (metaTag.prop('tagName') === 'TITLE') {
                    metaTag.text(content);
                  } else {
                    metaTag.attr('content', content);
                  }
                }
              }
            });
          }

          if (typeof applyAloomaTracking !== 'undefined') {
            applyAloomaTracking();
          }
        }
      });

      if (typeof response === 'object' && response.length) {
        self._loadLazy();
        self.update();
      }
    }, 'json');
  },
  _loadLazy: function () {
    let self = this;

    if (typeof window.IntersectionObserver !== 'undefined') {
      let observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            observer.unobserve(entry.target);

            let data = [self._getDynamicDataFromElement($(entry.target))];

            self._loadData(data);
          }
        });
      }, {
        rootMargin: '300px 0px',
        threshold: 0.01
      });

      $('.dynamic-data.lazy-dynamic').each(function () {
        let hash = $(this).attr('data-dynamic-hash');

        //prevent many-times observing
        if (typeof hash !== 'undefined' && hash.length && self.registered_for_observing.indexOf(hash) < 0) {
          self.registered_for_observing.push(hash);
          observer.observe(this);
        }
      });
    } else {
      self._loadNotLazy(true);
    }
  },
  _loadNotLazy: function (loadLazyElements) {
    let self = this,
      data = [],
      hashes = [],
      elements = loadLazyElements ? $('.dynamic-data.lazy-dynamic') : $('.dynamic-data:not(.lazy-dynamic)');

    elements.each(function () {
      let hash = $(this).attr('data-dynamic-hash');

      if (hash && hashes.indexOf(hash) < 0) {
        hashes.push(hash);

        data.push(self._getDynamicDataFromElement($(this)));
      }
    });

    $('meta, head title').each(function () {
      let content = $(this).prop('tagName') === 'TITLE' ? $(this).text() : $(this).attr('content');

      if (typeof content !== 'undefined' && content.length && content.indexOf('dynamic-data') >= 0) {
        let elements = $('<div>' + content + '</div>').find('.dynamic-data');

        elements.each(function () {
          let hash = $(this).attr('data-dynamic-hash');

          if (hash && hashes.indexOf(hash) < 0) {
            hashes.push(hash);

            data.push(self._getDynamicDataFromElement($(this)));
          }
        });
      }
    });

    self._loadData(data);
  },
  _createBlanks: function () {
    let self = this;

    $('.dynamic-data[data-dynamic-placeholders]').each(function () {
      let el = $(this),
        data = self._getDynamicDataFromElement(el),
        placeholders = parseInt($(this).attr('data-dynamic-placeholders'));

      if (!isNaN(placeholders) && typeof data['type'] !== 'undefined') {
        el.addClass(data['type'] + '-placeholders-container');

        for (placeholders; placeholders > 0; placeholders--) {
          let placeholder = $('<div/>');
          placeholder.addClass('card dynamic-data-placeholder ' + data['type'] + '-placeholder');
          placeholder.append('<div class="placeholder-inner card-body"><div class="placeholder-load"></div></div>');
          el.append(placeholder);
        }
      }
    });
  },
  update: function () {
    this._loadNotLazy();
  },
  init: function () {
    let self = this;

    self.post_id = $('body').first().attr('data-post-id');

    if (!self._active()) {
      return false;
    }

    //self._createBlanks();
    self._loadNotLazy();
    self._loadLazy();
  },
};

module.exports = DynamicData;

},{"./ajax":16,"cash-dom":1}],20:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');

const Feedback = {
    triggerNoteError: function (show) {
        if (show) {
            $('#note_error').removeClass('hidden');
            $('.feedback-note').addClass('error');
        } else {
            $('#note_error').addClass('hidden');
            $('.feedback-note').removeClass('error');
        }
    },
    initScores: function () {
        let self = this;

        const GOOD_SCORE = 8;
        const $feedbackScore = $('.feedback [name="feedback_score"]');
        const feedbackScoreValue = $feedbackScore.length ? parseFloat($feedbackScore.val()) : null;

        if (feedbackScoreValue >= GOOD_SCORE) {
            _makeScoreNotEditable();
            return;
        }

        $(document).on('change', '.feedback [name="feedback_score"]', function () {
            let feedbackContainerEl = $(this).closest('.feedback'),
                score = parseFloat($(this).val()),
                postId = feedbackContainerEl.attr('data-post-id');

            Page.startLoad('feedback', feedbackContainerEl);
            $('.thanks-for-feedback').addClass('hidden');
            $('.feedback-note-holder').addClass('hidden');
            Ajax.post(ajaxurl, {
                action: 'post_feedback_score',
                post_id: postId,
                score: score
            }, function (response) {
                if (response.success) {
                    if (response.thank_you) {
                        $('.thanks-for-feedback').removeClass('hidden');
                    }
                    if (response.show_note) {
                        $('.feedback-note-holder').removeClass('hidden');
                    } else {
                        $('.feedback-note-holder').addClass('hidden');
                    }

                    if (response.share) {
                        $($('.facebook-share.sharrre').get(0)).trigger("click");
                    }

                    if (response.feedbackResult) {
                        $('#feedback-result').html(response.feedbackResult);
                    }

                    if (score >= GOOD_SCORE) {
                        _makeScoreNotEditable();
                    }
                }
            }, 'json').done(function () {
                Page.finishLoad('feedback');
            });
        });

        function _makeScoreNotEditable() {
            $('.stars-rating.feedback-score').removeClass('editable-rating');
        }
    },
    initNote: function () {
        let self = this;

        $('.feedback .submit-note').on('click', function () {
            let postId = $(this).closest('.feedback').attr('data-post-id'),
                note = $('.feedback-note').val();

            $('.thanks-for-feedback').addClass('hidden');

            if (note.length) {
                self.triggerNoteError();
                Page.startLoad('feedback', $('.feedback-note-holder'));

                Ajax.post(ajaxurl, {
                    action: 'post_feedback_note',
                    post_id: postId,
                    note: note
                }, function (response) {
                    if (response.success) {
                        $('.thanks-for-feedback').removeClass('hidden');
                        $('.feedback-note-holder').remove();

                        if (response.feedbackResult) {
                            $('#feedback-result').html(response.feedbackResult);
                        }
                    }
                }, 'json').done(function () {
                    Page.finishLoad('feedback');
                });
            } else {
                self.triggerNoteError(true);
            }

            return false;
        });
    },
    init: function () {
        this.initScores();
        this.initNote();
    }
};

module.exports = Feedback;

},{"./ajax":16,"./page":24,"cash-dom":1}],21:[function(require,module,exports){
const $ = require('cash-dom');

const GAEvents = {

    parseUrl: function (url) {
        var parser = document.createElement('a');
        parser.href = url;

        return parser;
    },

    trackClick: function ($obj) {
        $obj = $($obj);

        var href;
        if ($obj.data('href') === 'undefined') {
            href = $obj.data('href');
        } else {
            href = $obj.attr('href');
        }

        if (typeof href === 'undefined') {
            return;
        }

        //CATEGORY
        let category = $obj.data('ga-category');

        if (!category) {
            category =  $obj.data('btn-name');
        }

        if (!category) {
            category = this.getPageName(window.location.href);
        }

        if (!category) {
            return;
        }

        //ACTION
        let action = $obj.data('ga-event');

        if (!action) {
            action = ($obj.attr('target') && $obj.attr('target') === '_blank') ? 'click out' : 'click in';

            if (action === 'click in' && (href.indexOf('http:') === 0 || href.indexOf('https:') === 0)) {
                let hostname = this.parseUrl(href).hostname;

                if (hostname.indexOf('safetydetective.') === -1 && hostname.indexOf('safetydetectives.') === -1) {
                    action = 'click out';
                }
            }
        }

        //LABEL
        var label = $obj.data('ga-label');

        if (typeof label === 'undefined') {
            label = $obj.attr('title');
        }

        if (typeof label === 'undefined') {
            label = $obj.attr('data-title');
        }

        if (typeof label === 'undefined') {
            label = $obj.text().trim();
        }
        let nonInteraction = $obj.attr('data-ni');
        //go/vendor click out tracking in go-vendor routes
        //if (href.indexOf('go/vendor') >= 0 && category === 'click out') {
        //    return;
        //}

        this.sendEvent(category, action, label, nonInteraction);
    },

    sendEvent: function (category, action, label, nonInteraction) {
        nonInteraction = typeof nonInteraction === "undefined" ? false : true;

        let param = {
            event_category: category,
            event_label: label,
        };

        if (nonInteraction) {
            param.non_interaction = true;
        }

        if (document.body.classList.contains('logged-in') ||
          (typeof window.location.hash !== 'undefined' && window.location.hash === '#debug-events'))
        {
            console.log('GA Action: ' + action);
            console.log(param);
        }

        if (window.location.host.indexOf('.com') !== -1) {
            if (typeof gtag !== "undefined") {
                gtag('event', action, param);
            }
        }
    },

    getPageName: function (url) {
        var name, subpage;
        var aUrl = url.split('/');

        if (url.indexOf('http:') === 0 || url.indexOf('https:') === 0) {
            var hostname = this.parseUrl(url).hostname;

            if (hostname.indexOf('safetydetective.') === -1 && hostname.indexOf('safetydetectives.') === -1) {
                return '3rd party website';
            }

            name = aUrl[3];
            subpage = typeof aUrl[4] !== 'undefined' ? aUrl[4] : '';
        } else {
            name = aUrl[1];
            subpage = typeof aUrl[2] !== 'undefined' ? aUrl[2] : '';
        }

        if (typeof name === 'undefined' || name === '') {
            return 'homepage';
        }


        if (subpage !== '') {
            switch (name) {
                case 'blog':
                    if (subpage !== 'tags' && subpage !== 'page') {
                        name = 'blog-post';
                    }
                    break;

                case 'best-antivirus':
                    if (subpage !== 'windows' && subpage !== 'linux' && subpage !== 'mac' && subpage !== 'android' && subpage !== 'ios') {
                        name = 'vendor';
                    }
                    break;
                case 'best-password-managers':
                    if (subpage !== 'windows' && subpage !== 'linux' && subpage !== 'mac' && subpage !== 'android' && subpage !== 'ios') {
                        name = 'vendor';
                    }
                    break;
                case 'go':
                    if (subpage === 'product') {
                        name = 'go-product';
                    }
                    break;
            }
        }

        return name;
    },

    getPrefix: function ($obj) {
        var prefix = '';

        if (typeof $obj.attr('data-ga-prefix') !== 'undefined' && $obj.attr('data-ga-prefix').length) {
            prefix = $obj.attr('data-ga-prefix') + ': ';
        } else if ($obj.hasClass('page-numbers')) {
            prefix = 'pagination: ';
        } else if ($obj.parent().hasClass('nav-item')) {
            prefix = 'menu: ';
        } else if ($obj.closest('#breadcrumbs').length > 0) {
            prefix = 'breadcrumbs: ';
        }

        return prefix;
    },

    getSuffix: function ($obj) {
        var suffix = '';

        if (typeof $obj.attr('data-ga-suffix') !== 'undefined' && $obj.attr('data-ga-suffix').length) {
            suffix = ' (' + $obj.attr('data-ga-suffix') + ')';
        } else if ($obj.closest('[data-popup-id]').length > 0) {
            suffix = ' (' + $obj.closest('[data-popup-id]').data('popup-id') + ')';
        } else if ($obj.closest('#colorbox').length > 0) {
            suffix = ' (popup)';
        } else if ($obj.closest('aside').length > 0) {
            suffix = ' (sidebar)';
        }

        return suffix;
    },

    getObjType: function ($obj) {
        var type = '';

        if ($obj.hasClass('btn')) {
            type = ' (button)';
        } else {
            var $img = $obj.find('img').first();
            if ($img.length > 0) {
                if ($img.attr('src').indexOf('avatar') !== -1) {
                    type = ' (avatar)';
                } else {
                    type = ' (image)';
                }
            }
        }

        return type;
    }
};

$(function () {
    setTimeout(function () {
        $(document).on('click', 'a,div[data-ga-event]', function () {
            GAEvents.trackClick($(this));
        });

        //404 GA event report
        if ($('body.error404').length > 0) {
            var label = '';
            if (window.location.pathname) {
                label = window.location.pathname;
            }

            if (label.length > 40) {
                label = label.substr(0, 35) + '...';
            }

            GAEvents.sendEvent('error', '404', label)
        }
    }, 200);


    let sentEvents = [],
      ticking = false;

    window.addEventListener('scroll', function (e) {
        if (ticking) {
            return;
        }

        ticking = true;
        let pos = getScrollYPosition() + window.innerHeight,
          height = document.documentElement.scrollHeight,
          ratio = pos / height * 100;

        if (ratio < 25) {
            ticking = false;
            return;
        }

        let metricName;
        let scroll;
        if (ratio >= 90) {
            metricName = 'metric4';
            scroll = 90;
        } else if (ratio >= 75) {
            metricName = 'metric3';
            scroll = 75;
        } else if (ratio >= 50) {
            metricName = 'metric2';
            scroll = 50;
        } else {
            metricName = 'metric1';
            scroll = 25;
        }

        if (sentEvents.indexOf(scroll) !== -1) {
            ticking = false;
            return;
        }
        sentEvents.push(scroll);

        let params = {};
        params[metricName] = 1;

        gtag("set", params);

        GAEvents.sendEvent('Scroll tracking', 'Scroll ' + scroll + '%', document.title, true);
        ticking = false;
    }, {passive: true});

    function getScrollYPosition() {
        let supportPageOffset = window.pageYOffset !== undefined;
        let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

        return supportPageOffset
          ? window.pageYOffset
          : (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
    }
});

window.GAEvents = GAEvents;
module.exports = GAEvents;

},{"cash-dom":1}],22:[function(require,module,exports){
const $ = require("cash-dom");
/*
* NOTICE: if your element changing ".active" class on click somewhere - use 'mousedown' event with e.preventDefault(); instead of 'click' event. Example: FAQ
*/
class KeyboardNavigation {
	constructor({$rootLinks, closestSelectorToPreventToHideMenu, rootLinkContainerSelector}) {
		this._$rootLinks = $rootLinks;
		this._closestSelectorToPreventToHideMenu = closestSelectorToPreventToHideMenu;
		this._rootLinkContainerSelector = rootLinkContainerSelector;
	}

	init() {
		const self = this;

		$('a, button, select, input, [tabindex="0"]').on('focus', function () {
			const $el = $(this);

			if (!$el.closest(self._closestSelectorToPreventToHideMenu).length) {
				self._removeAllActiveClasses();
			}
		});

		self._$rootLinks.on('focus', function (e) {
			const $navLink = $(this);

			self._addClassActive($navLink);
		});

		$(document).on('click', function (e) {
			const $el = $(e.target);

			if (!$el.hasClass('unfocusable-click')) {
				self._removeAllActiveClasses();
			}
		});
	}

	_addClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.addClass('active');
	}

	_removeClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.removeClass('active');
	}

	_removeAllActiveClasses() {
		this._$rootLinks.each((i, navLink) => {
			const $navLink = $(navLink);

			this._removeClassActive($navLink);
		});
	}
}

$(function () {
	const $navLinks = $('ul.navbar-nav > li.nav-item > .nav-link');

	if ($navLinks.length) {
		(new KeyboardNavigation({
			$rootLinks: $navLinks,
			closestSelectorToPreventToHideMenu: '.sub-menu',
			rootLinkContainerSelector: 'li.nav-item',
		})).init();
	}

	const customSelects = $('#header_currencies, #header_languages');

	if (customSelects.length) {
		(new KeyboardNavigation({
			$rootLinks: customSelects,
			closestSelectorToPreventToHideMenu: '.options',
			rootLinkContainerSelector: null,
		})).init();
	}

	const faq = $('#faq .single-qa');

	if (faq.length) {
		(new KeyboardNavigation({
			$rootLinks: faq,
			closestSelectorToPreventToHideMenu: '.answer',
			rootLinkContainerSelector: null,
		})).init();
	}
});

},{"cash-dom":1}],23:[function(require,module,exports){
const Ajax = require('./ajax');

const MacrosFront = {
    loaded: false,
    _active: function () {
        if (this.loaded) {
            return;
        }
        this.loaded = true;
        this._user_country = document.querySelectorAll('*[data-user-country]');
        return this._user_country.length;
    },
    init: function () {
        let self = this;
        if (!self._active()) {
            return false;
        }

        Ajax.get(ajaxurl + '?action=get_user_country', function (response) {
            self._user_country.forEach(function (item) {
                item.innerHTML = response;
            });
        });
    },
};

module.exports = MacrosFront;

},{"./ajax":16}],24:[function(require,module,exports){
const $ = require('cash-dom');
const popup = require('./popup');

let suppressChatPopTimeout = null;

const loadMap = {};
let firstLoaderAdding = true;

function setLoadMap(tag, value, element = null) {
  loadMap[tag] = loadMap[tag] !== undefined ? loadMap[tag] : {};
  loadMap[tag]['value'] = value;
  loadMap[tag]['element'] = element;
}

function getLoadMapValue(tag) {
  return loadMap[tag] ? loadMap[tag]['value'] : undefined;
}

function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

function fixLoaders() {
  $.each(loadMap, function (i, loaderValAndEl) {
    const loader = loaderValAndEl['value']
    const element = loaderValAndEl['element']

    if (loader.hasClass('global-loader') && element) {
      const offset = element.offset();
      if (offset) {
        loader.css({
          top: offset.top - document.documentElement.scrollTop,
          left: offset.left - document.documentElement.scrollLeft,
          right: 'auto',
          bottom: 'auto',
          width: element.outerWidth(),
          height: element.outerHeight()
        });
      }
    }
  });
}

const Page = {
  scrollTo: function (dest, time, offset) {
    setTimeout(function () {
      var $offset = $(dest).offset();
      if ($offset) {
        window.scroll({top: $offset.top + (offset || 0), left: 0, behavior: 'smooth'});
      }
    }, 1);
  },
  getLanguage: function () {
    var matches = $('html').get(0).className.match(/language-(\w{2})/);
    if (matches) {
      return matches[1];
    }

    return false;
  },
  isRTL: function () {
    return hasClass(document.documentElement, 'is-rtl');
  },
  tagIsFree: function (tag) {
    return typeof (getLoadMapValue(tag)) === 'undefined';
  },
  startLoad: function (tag, element) {
    if (element === 'popup') {
      element = '#popup .popup-container';
    }
    element = $(element);
    //console.log('Loading ', tag, '...');
    if (element.is('.action-loader')) {
      setLoadMap(tag, element);
      element.addClass('active');
    } else {
      var offset = element.offset();
      if (offset) {
        setLoadMap(tag, $('<div class="global-loader">&nbsp;</div>').appendTo('body').show(), element);

        if (firstLoaderAdding) {
          firstLoaderAdding = false;
          $(window).on('resize scroll', fixLoaders);
        }

        fixLoaders();
      }
    }
  },
  onHashTag: function (hashTag, callback) {
    $(document).on('click', '[href*="#"]', function (event) {
      var hash = $(this).attr('href').split('#')[1];
      if (!hash) {
        return true;
      }
      if (hashTag instanceof RegExp) {
        var matches = hash.match(hashTag);
        if (matches) {
          event.preventDefault();
          callback.apply(hash, matches.slice(1));
        }
      } else {
        if (hash === hashTag) {
          event.preventDefault();
          callback.call(this);
        }
      }
    });
    $(window).on('load', function () {
      var hash = window.location.href.split('#')[1];
      if (!hash) {
        return true;
      }

      if (hashTag instanceof RegExp) {
        var matches = hash.match(hashTag);
        if (matches) {
          callback.apply(null, matches.slice(1));
        }
      } else {
        if (hash === hashTag) {
          callback.call(null);
        }
      }
    });
  },
  finishLoad: function (tag) {
    //console.log('Finished loading ', tag);
    var element = getLoadMapValue(tag);
    if (element && element.length > 0) {
      if (element.is('.action-loader')) {
        element.removeClass('active');
      } else {
        element.remove();
      }

      delete loadMap[tag];
    }
  },
  load: function (url) {
    document.location = url ? url : document.location;
  },
  inNewTab: function (url) {
    var win = window.open(url, '_blank');
    win.focus();

  },
  isAtPath: function (path) {
    return document.location.pathname === path;
  },
  isSingle: function (slug) {
    return slug ? hasClass(document.body, 'single-' + slug) : hasClass(document.body, 'single');
  },
  isTemplate: function (slug) {
    return slug ? hasClass(document.body, 'page-template-' + slug) : hasClass(document.body, 'page-template');
  },
  isCategory: function (slug) {
    return slug ? hasClass(document.body, 'category-' + slug) : hasClass(document.body, 'category');
  },
  isSSL: function () {
    return document.location.protocol === 'https:';
  },
  closePopups: function () {
    popup.hide();
  },
  suppressChatPop: function (yes) {
    // console.log("suppressChatPop");
    if (yes) {
      //     console.log("yes");
      // TODO where is _trySuppressChatPop?
      // suppressChatPopTimeout = setTimeout(_trySuppressChatPop, 10);
    } else {
      //   console.log("no");
      if (suppressChatPopTimeout) {
        clearTimeout(suppressChatPopTimeout);
        suppressChatPopTimeout = null;
      }
      if (typeof (window['LC_API']) !== 'undefined' && typeof (window['LC_Invite']) !== 'undefined') {
        window['LC_API']['minimize_chat_window']();
      }
    }
  },
  getSearchParameters: function () {
    if (window.location.search.length) {
      var searchArr = window.location.search.substr(1).split('&'),
        result = {};

      searchArr.forEach(function (item) {
        var tmp = item.split('=');
        result[tmp[0]] = decodeURIComponent(tmp[1]);
      });

      return result;
    } else {
      return {};
    }
  },
};

module.exports = Page;

},{"./popup":26,"cash-dom":1}],25:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');
const Ajax = require('./ajax');

const Poll = {
  init: function () {
    let self = this;

    $(document).on('click', 'button.poll-control', (e) => {
      let inputEl = $(e.target);

      self.sendPollData(inputEl);
    });
    $(document).on('change', '.poll-control', (e) => {
      let inputEl = $(e.target);

      self.sendPollData(inputEl);
    });
  },
  sendPollData: (inputEl) => {
    let answersHolder = inputEl.closest('.poll-answers-holder'),
      qaHolder = inputEl.closest('.poll-qa-holder'),
      qaId = qaHolder.length ? qaHolder.attr('data-qa-id') : 0,
      value = '';

    if (!qaId) {
      return false;
    }

    if (inputEl.prop("tagName") === 'SELECT') {
      value = inputEl.val();
    } else {
      let checkedInputEl = answersHolder.find('input:checked');

      if (checkedInputEl.length > 1) {
        checkedInputEl.each((i ,v) => {
          value += $(v).val() + ';';
        });
      } else {
        value = checkedInputEl.closest('.poll-answers-holder').find('input:checked').val();
      }
    }

    if (typeof value !== 'undefined') {
      Page.startLoad('poll-vote', qaHolder);

      Ajax.post(ajaxurl, {
        'action': 'poll_vote',
        'answer': value,
        'qa_id': qaId,
        'post_id': $("body").first().data("post-id"),
      }, function (res) {
        Page.finishLoad('poll-vote');

        if (res.length) {
          qaHolder.replaceWith(res);
        }
      });
    }
  },
};

module.exports = Poll;

},{"./ajax":16,"./page":24,"cash-dom":1}],26:[function(require,module,exports){
const $ = require('cash-dom');
const {Cash} = require("cash-dom");

let instance = null;

/**
 * Class Popup Is singleton.
 *
 * Usage:
 * ```
 * const popup = require('path/to/popup');
 *
 * popup.show('some html content as string');
 *
 * // with options
 * popup.show('some html', {className: 'some-class', width: '90vw', height: '90vh'})
 * // className will be set to .popup-container
 * // width and height will be set to .popup-content as css properties
 *
 * // to hide popup:
 * popup.hide();
 * ```
 *
 * Special classes. You can use one of predefined css classes:
 * ```
 * popup.show('some html', {className: 'template-popup'}); // adds border radius, paddings and $white background
 * popup.show('some html', {className: 'simple-template-popup'}); // adds just $white background
 * ```
 */
class Popup {
  constructor() {
    if (!instance) {
      this._Popup = $('#main-pp');
      this._popupContainer = this._Popup.find('.popup-container');
      this._popupContent = this._popupContainer.find('.popup-content');

      this._defaultShowOptions = {
        className: 'template-popup',
        align: 'center',
        backgroundLayer: true
      };

      this._handleKeyup = (e) => {
        const isEscape = ('key' in e) ? e.key === 'Escape' || e.key === 'Esc' : e.keyCode === 27;

        if (isEscape) {
          this.hide();
        }
      }

      this._init();

      instance = this;
    }

    return instance;
  }

  _init() {
    this._Popup.on('click', (e) => {
      if (!e.isPopupContentClick) {
        this.hide();
        e.isPopupContentClick = false;
      }
    });

    this._Popup.find('.popup-container').on('click', (event) => {
      event.isPopupContentClick = true;
    });
  }

  _attachPopupCloseHandling() {
    this._Popup.find('.popup-close').on('click', (e) => {
      e.preventDefault();
      this.hide();
    });
  }

  hide() {
    this._Popup.hide();
    $(document).off('keyup', this._handleKeyup);
  }

  /**
   * Shows popup for Cash (tiny jQuery) object.
   * The purpose is to preserve object's (element's) events and inline styles.
   * @param {Cash} $cashElement
   * @param {{className: string|undefined, width: string|undefined, height: string|undefined,backgroundLayer: bool|undefined}} options If you are
   * overriding the className, please add class `simple-template-popup` to have white background.
   */
  showForCashObject($cashElement, options = {}) {
    options = Object.assign({className: 'simple-template-popup'}, options);
    this.show('', options);
    $cashElement.appendTo('#popup .popup-content');
    this._attachPopupCloseHandling();
  }

  /**
   * Shows html content inside popup.
   * Usage:
   * ```
   * const popup = require('./popup');
   *
   * popup.show({html: '<div>Some content</div>'});
   * ```
   * @param {string} html
   * @param {{className: string|undefined, width: string|undefined, height: string|undefined, align: string|undefined}} options
   * Note: add 'template-popup' if you override default className and need white background
   */
  show(html, options = {}) {
    options = Object.assign(this._defaultShowOptions, options);
    this._applyOptions(options);

    this._popupContent.html(html);

    this._showPopupElement();
    this._attachPopupCloseHandling();

    $(document).on('keyup', this._handleKeyup);
  }

  _applyOptions(options) {
    this._clearOptions();

    if (options.className) {
      this._popupContainer.addClass(options.className);
    }

    if (options.width) {
      this._popupContent.css('width', options.width);
    }

    if (options.height) {
      this._popupContent.css('height', options.height);
    }

    if (options.align) {
      if (options.align === 'top') {
        this._Popup.addClass('popup-align-top');
      } else if (options.align === 'bottom') {
        this._Popup.addClass('popup-align-bottom');
      }
    }

    if (options.backgroundLayer === false) {
      this._Popup.addClass("popup-no-bg-layer");
    }


  }

  _clearOptions() {
    // remove all classes
    this._popupContainer.removeClass();
    // add permanent class
    this._popupContainer.addClass('popup-container');

    this._popupContainer.removeAttr('style');
  }

  _showPopupElement() {
    this._Popup.css('display', 'flex');
  }
}

module.exports = new Popup();

},{"cash-dom":1}],27:[function(require,module,exports){
const $ = require('cash-dom');

const QuickNav = {
  autoClose: true,
  hasScrolledFromTop: false,
  lastScrollY: 0, // Track previous scroll position

  init() {
    this.lastScrollY = window.scrollY;
    this._initQuickNav();
    this._initQuickNavMobile();
  },

  _initQuickNav() {
    const self = this, quickNavElement = document.querySelector('#quick_nav');
    if (!quickNavElement) return;

    const $quickNav = $(quickNavElement),
      listHolder = quickNavElement.querySelector('.quick-nav-list-holder'),
      $titleHolder = $quickNav.find('.quick-nav-title'),
      $titleHolderDynamic = $titleHolder.find('#quick-nav-title-dynamic'),
      originalTitle = $titleHolder.attr('data-title'),
      firstH2 = document.querySelector('h2');

    // Set max height for the list based on first 4 list items
    if (listHolder) {
      self._waitForRenderedHeight(listHolder, function () {
        const listItems = Array.from(listHolder.querySelectorAll('li')).slice(0, 4);
        const totalHeight = listItems.reduce((sum, li) => sum + li.offsetHeight, 0);
        const height = totalHeight - 2;

        if (height > 220) {
          listHolder.style.setProperty('max-height', `${height}px`, 'important');
        }
      });
    }

    // Toggle collapsed state on title click and update title text
    $titleHolder.on('click', function () {
      $quickNav.toggleClass('collapsed');
      self.autoClose = false;

      if ($quickNav.hasClass('collapsed')) {
        const $activeLink = $quickNav.find('li.active > a');
        if ($activeLink.length) {
          $titleHolderDynamic.text($activeLink.text());
        }
      } else {
        $titleHolderDynamic.text(originalTitle || '');
        self._recalculateQuickNavScroll($quickNav);
      }
    });

    // On scroll, auto-collapse menu and update active link & title
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollDown = currentScrollY > self.lastScrollY;
      self.lastScrollY = currentScrollY;

      if (window.scrollY > 100) {
        self.hasScrolledFromTop = true;
      }

      if (firstH2 && self.autoClose) {
        const y = firstH2.getBoundingClientRect().y, isAbove = y < 0;

        $quickNav.toggleClass('collapsed', isAbove);
        const $activeLink = $quickNav.find('li.active > a');

        if ($activeLink.length && $titleHolderDynamic.length) {
          $titleHolderDynamic.text(isAbove ? $activeLink.text() : originalTitle || '');
        }
      }

      // Update active link and title dynamically during scroll
      self._updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, scrollDown);
    }, {passive: true});

    // On page load, set initial collapsed state and active link
    window.addEventListener('load', () => {
      if (firstH2 && firstH2.getBoundingClientRect().y < 0) {
        $quickNav.addClass('collapsed');
      }

      self._updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, true);
    });
  },

  _updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, scrollDown) {
    let activeUpdated = false,
      closestLink = null,
      closestDistance = Infinity;

    const self = this,
      links = $quickNav.find('li > a'),
      linkArray = Array.from(links);

    if (scrollDown) {
      linkArray.forEach(($a) => {
        const $currentA = $($a), id = $currentA.attr('href');
        if (!id || !id.startsWith('#')) return;

        const $section = $(id);
        if (!$section.length) return;

        const top = $section.get(0).getBoundingClientRect().top;

        if (top < 200 && top > -300 && !activeUpdated) {
          $quickNav.find('li').removeClass('active');
          $currentA.parent('li').addClass('active');

          $quickNav.hasClass('collapsed')
            ? $titleHolderDynamic.text($currentA.text())
            : $titleHolderDynamic.text(originalTitle || '');

          self._recalculateQuickNavScroll($quickNav);
          activeUpdated = true;
        }

        if (!self.hasScrolledFromTop) {
          const distance = Math.abs(top);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestLink = $currentA;
          }
        }
      });
    } else {
      const OFFSET = 20; // If 0, it will choose the previous heading (tested with 20 and works correctly)

      let closestTopAboveThreshold = Infinity;
      let closestLinkAboveThreshold = null;

      let bestTopBelowThreshold = -Infinity;
      let bestLinkBelowThreshold = null;

      linkArray.forEach(($a) => {
        const $currentA = $($a), id = $currentA.attr('href');
        if (!id || !id.startsWith('#')) return;

        const $section = $(id);
        if (!$section.length) return;

        const top = $section.get(0).getBoundingClientRect().top;

        if (top >= -OFFSET && top < closestTopAboveThreshold) {
          closestTopAboveThreshold = top;
          closestLinkAboveThreshold = $currentA;
        }

        // Find the closest heading whose top is above or within the OFFSET threshold
        if (top < -OFFSET && top > bestTopBelowThreshold) {
          bestTopBelowThreshold = top;
          bestLinkBelowThreshold = $currentA;
        }
      });

      // Choose the heading that is closest to the top but within the OFFSET,
      // or if none found, choose the last heading above the OFFSET
      const finalLink = closestLinkAboveThreshold || bestLinkBelowThreshold;

      if (finalLink) {
        $quickNav.find('li').removeClass('active');
        finalLink.parent('li').addClass('active');

        $quickNav.hasClass('collapsed')
          ? $titleHolderDynamic.text(finalLink.text())
          : $titleHolderDynamic.text(originalTitle || '');

        self._recalculateQuickNavScroll($quickNav);
        activeUpdated = true;
      }
    }
  },

  _recalculateQuickNavScroll($quickNav) {
    const listHolder = $quickNav.find('.quick-nav-list-holder');

    if (listHolder.length) {
      const $active = listHolder.find('.active');
      if (!$active.length) return;

      const activeTop = $active.get(0).offsetTop,
        holder = listHolder.get(0),
        holderHeight = holder.clientHeight,
        scrollTop = holder.scrollTop;

      // Scroll the list holder so the active item is visible
      if (activeTop < scrollTop || activeTop + $active.get(0).offsetHeight > scrollTop + holderHeight) {
        holder.scrollTo({top: activeTop, behavior: 'smooth'});
      }
    }
  },

  _waitForRenderedHeight(el, callback, maxTries = 10) {
    let tries = 0;
    function check() {
      const heightReady = el.offsetHeight > 0;
      if (heightReady || tries >= maxTries) {
        callback();
      } else {
        tries++;
        requestAnimationFrame(check);
      }
    }
    requestAnimationFrame(check);
  },

  _initQuickNavMobile() {
    const $quickNavMobile = $('#quick_nav_mobile');
    if (!$quickNavMobile.length) return;

    $quickNavMobile.on('click', function () {
      $(this).toggleClass('collapsed');
    });
  },
};

module.exports = QuickNav;
},{"cash-dom":1}],28:[function(require,module,exports){
const $ = require('cash-dom');

const ShareButtons = {
  init() {
    $('body').on('click', '.facebook-share', function (e) {
      e.preventDefault();
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + $(this).data('url'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
    });


    $('body').on('click', '.twitter-share', function (e) {
      e.preventDefault();
      window.open("http://twitter.com/intent/tweet?text=" + $(this).data('url'), 'twShareWindow', 'height=550, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 275) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
    });
  },
};

module.exports = ShareButtons;

},{"cash-dom":1}],29:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');
require('../../vendor/modernizr-custom.min');

const SmoothScroll = {
  init() {
    $('a[href^="#"]').on('click', function (e) {
      var id = $(this).attr('href');
      if (id.length > 1) {
        var $el = $(id);
        var offset = typeof $(this).attr('data-offset') !== 'undefined' && !isNaN(parseInt($(this).attr('data-offset'))) ?
          parseInt($(this).attr('data-offset')) :
          0;

        if ($el.length === 1) {
          e.preventDefault();
          Page.scrollTo(id, 0, offset);

          if (typeof Modernizr !== 'undefined' && Modernizr.history) {
            window.history.pushState(null, $('title').html(), window.location.href.replace(/#(.*)?$/, '') + id);
          }
        }
      }
    })
  },
};

module.exports = SmoothScroll;

},{"../../vendor/modernizr-custom.min":39,"./page":24,"cash-dom":1}],30:[function(require,module,exports){
const StarsRating = require('./stars-rating');
const Feedback = require('./feedback');

const StarsRatingAndFeedback = {
  init() {
    StarsRating.init();
    Feedback.init();
  },
};

module.exports = StarsRatingAndFeedback;

},{"./feedback":20,"./stars-rating":31}],31:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');

const StarsRating = {
    init() {
        let scorePercent = function (e, stars_holder) {
            var width = $(stars_holder).width();
            var left = e.pageX - $(stars_holder).offset().left;
            var offset = Math.min(Math.max(0, Page.isRTL() ? width - left : left), width);
            return Math.round((offset / width * 100 / 10) + 0.49) * 10;
        };

        let updateSelectedScore = function (score) {
            const $selectedRatingSpan = $('#selected-rating span');

            if ($selectedRatingSpan.length === 0) {
                return false;
            }

            let scoreClass = 'bad';

            if (score >= 8) {
                scoreClass = 'good';
            } else if (score >= 5) {
                scoreClass = 'neutral';
            }
            $selectedRatingSpan
              .removeClass('bad')
              .removeClass('neutral')
              .removeClass('good')
              .addClass(scoreClass)
              .text(score.toFixed(1));
        };

        $(document)
          .on('mousemove', '.editable-rating', function (e) {
              let percent = scorePercent(e, this);
              $(this).attr("style", "--rating: " + (percent) + '%');

              let score = Math.round(percent * 10 / 100) / 5 * 5;

              updateSelectedScore(score);
          })

          .on('click', '.editable-rating', function (e) {
              e.stopPropagation();

              let $input = $(this).find('input[type="hidden"]');

              let score = Math.round(scorePercent(e, this) * 10 / 100) / 5 * 5;

              if ($input.length > 0) {
                  $input.val(score).trigger('change');
              }

              updateSelectedScore(score);
          })

          .on('mouseleave', '.editable-rating', function () {
              let $input = $(this).find('input[type="hidden"]');
              let score = 0;

              if ($input.length > 0) {
                  score = $input.val();
              }

              $(this).attr("style", "--rating: " + (score * 10) + "%");

              updateSelectedScore(+$input.val());
          });
    },
};

module.exports = StarsRating;

},{"./page":24,"cash-dom":1}],32:[function(require,module,exports){
const $ = require('cash-dom');
const popup = require('./popup');

const Template = {
    // takes innerHTML from the source, replaces all variables
    get: function (source, vars) {
        let html = $(source).html();
        if (typeof (vars) !== 'undefined') {
            $.each(vars, function (search, replacement) {
                html = html.replace(new RegExp("{{" + search + "}}", 'g'), replacement);
            });
        }
        return html;
    },

    // gets template and puts it to the dest
    put: function (source, dest, vars) {
        $(dest).html(Template.get(source, vars));
    },

    popup: function (source, vars, options = {}) {
        let $popupContent = $(Template.get(source, vars));

        $popupContent.find('img.lazy').each(function () {
            $(this)
                .on('load', function () {
                    // TODO check this
                    // $.colorbox.resize();
                })
                .attr('src', $(this).data('src'))
                .removeClass('lazy');
        });

        const popupHtml = $('<div>').append($popupContent).html();

        popup.show(popupHtml, options);

        setTimeout(function () {
            if (typeof applyAloomaTracking !== 'undefined') {
                applyAloomaTracking();
            }
        }, 300);
    }
};

module.exports = Template;

},{"./popup":26,"cash-dom":1}],33:[function(require,module,exports){
const $ = require("cash-dom");
const popup = require('./popup');

const Tooltip = {
    show: function (el) {
        var self = this,
          position = self.getPosition(el),
          tooltip = self.build(el),
          id = this._id();

        //apply id to link control and tooltip
        el.data("tooltip-id", id);
        tooltip.attr("data-id", id);

        if (tooltip.length > 0) {
            tooltip.css({top: 0, left: 0, display: 'block', opacity: 1});
            $(document.body).append(tooltip);

            var pos = self.getPositionData(el),
              actualWidth = tooltip.width(),
              actualHeight = tooltip.height(),
              tp = {top: pos.top - actualHeight - 20, left: pos.left + pos.width / 2 - actualWidth / 2}; //top position

            switch (position) {
                case 'bottom':
                    var left = pos.left + pos.width / 2 - actualWidth / 2;

                    //fix for the tooltip which goes over the screen to the left
                    if (left < 0) {
                        var newWidth = actualWidth + (left * 2);

                        if (newWidth / actualWidth < 0.5) {
                            newWidth = actualWidth / 2;
                        }

                        tooltip.width(newWidth);
                        left = pos.left + pos.width / 2 - newWidth / 2;
                    }

                    tp = {top: pos.top + pos.height, left: left};
                    break;
                case 'left':
                    tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth};
                    break;
                case 'right':
                    tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width};
                    break;
            }

            tooltip.css(tp);
        }
    },
    getPositionData: function (el) {
        return $.extend({}, (el.offset()), {
            width: el[0].offsetWidth,
            height: el[0].offsetHeight
        });
    },
    getPosition: function (el) {
        var self = this,
          position = el.attr('data-tooltip-position') || 'top',
          position_lg = el.attr('data-tooltip-position-lg') || position;

        if ($(window).width() >= 1500) {
            position = position_lg;
        }

        return position;
    },
    build: function (el) {
        var self = this,
          content = el.data('tooltip'),
          position = self.getPosition(el),
          is_thumb = false,
          additional_classes = '',
          data_classes = el.data('tooltip-classes');


        if (!content.length) {
            return '';
        }

        if (/^http.+\.(jpg|png)$/.test(content)) {
            is_thumb = true;
            additional_classes = 'thumbnail loading';
            content = $('<img />').attr('src', content);

        }

        if (typeof data_classes !== 'undefined' && data_classes.length) {
            additional_classes += " " + data_classes + " ";
        }

        additional_classes += " " + 'tooltip-' + position;

        var $tooltip_content = $('<div />').attr({
            class: 'simple-tooltip-content'
        }).html(content).append('<div class="simple-tooltip-arrow"></div>');

        if (is_thumb) {
            $tooltip_content.append('<div class="img-loader light-loader"></div>');
        }

        var $tooltip = $('<div />').attr({
            class: 'simple-tooltip ' + additional_classes
        }).append($tooltip_content);


        if (is_thumb) {
            content.load(function () {
                $tooltip.removeClass('loading');
            });
        }

        return $tooltip;
    },
    init: function () {
        var self = this;

        $(document).on('mouseenter', '[data-tooltip]', function () {
            if ($(this).data("tooltip-trigger") === "click") {
                return;
            }

            self.show($(this));
        }).on('mouseleave', '[data-tooltip]', function (e) {
            if ($(this).data("tooltip-trigger") === "click") {
                return;
            }

            $('.simple-tooltip').remove();
        }).on('click', '[data-tooltip]', function () {
            self.popup($(this));
        }).on('keydown', '[data-tooltip]', function (e) {
            if (e.keyCode === 13) {
                self.popup($(this));
            }
        });

        $('[data-tooltip][data-tooltip-autoshow]').each(function () {
            var $host = $(this),
              timeout = $host.attr('data-tooltip-autoshow');

            if (timeout === '') timeout = 0;

            timeout = +timeout; //convert to Number

            setTimeout(function () {
                $host.trigger('mouseenter');
            }, timeout);

            setTimeout(function () {
                $host.trigger('mouseleave');
            }, timeout + 9000);
        });

        var window_width = $(window).width();
        $(window).on("resize", function () {
            if (window_width !== $(window).width()) {
                $('[data-tooltip]').first().trigger('mouseleave');
            }
        });
    },

    popup: function ($el) {
        if ($el.data("tooltip-trigger") === "click" && $(window).width() > 992) {

            if ($(".simple-tooltip[data-id=\"" + $el.data("tooltip-id") + "\"]").length > 0) {
                $(".simple-tooltip[data-id=\"" + $el.data("tooltip-id") + "\"]").remove();
                return;
            } else {
                $(".simple-tooltip").remove();
            }

            this.show($el);
            return;
        }

        if ($(window).width() > 992) {
            return;
        }

        var content = "<div class=\"mobile-tooltip-content\">" +
          "<h3>" + $el.text() + "</h3>" +
          $el.attr('data-tooltip') + "</div>";

        popup.show(content, {className: 'tooltip-popup-container'});
    },

    _id: function () {
        return 't_' + Math.random().toString(36).substr(2, 9);
    }
};

module.exports = Tooltip;

},{"./popup":26,"cash-dom":1}],34:[function(require,module,exports){
const $ = require('cash-dom');
const Page = require('./page');

var Validator = {
    validate: function($form, errors, scrollToError) {
        this.removeErrors($form);

        for (var e in errors) {
            var $el = $form.find('[data-field="' + errors[e]['field'] + '"]');

            if ($el.length > 0) {
                var $errEl = '<div class="error-msg">' + errors[e]['error_str'] + '</div>';
                $el.addClass('error validation-error');

                if ($el.attr('type') == 'checkbox' && $el.parent('label').length) {
                    $el.parent('label').after($errEl);
                } else {
                    $el.after($errEl);
                }
            }
        }

        if (typeof scrollToError === 'undefined' || scrollToError === true) {
            Page.scrollTo($('.error').first(), 300, -100);
        }
    },
    validateModel: function($form, errors, scrollToError) {
        this.removeErrors($form);

        for (var e in errors) {
            var $el = $('[data-field="' + e + '"]');
            if (!$el.length) {
                $el = $('[name="' + e + '"]');
            }

            if ($el.length > 0) {
                var $errEl = '<div class="error-msg">' + errors[e] + '</div>';
                $el.addClass('error validation-error');

                if ($el.attr('type') == 'checkbox' && $el.parent('label').length) {
                    $el.parent('label').after($errEl);
                } else {
                    $el.after($errEl);
                }
            }
        }

        if (typeof scrollToError === 'undefined' || scrollToError === true) {
            Page.scrollTo($form.find('.error').first(), 300, -100);
        }
    },
    removeErrors: function ($form) {
        $form.find('.validation-error.error').removeClass('error validation-error');
        $form.find('.error-msg').remove();
        $('.error-msg').remove();
    }
}

module.exports = Validator;

},{"./page":24,"cash-dom":1}],35:[function(require,module,exports){
const GAEvents = require('./ga-events');

const Video = {
  init() {
    const videosArray = document.querySelectorAll("video");

    videosArray.forEach(video => {
      video.addEventListener("playing", (event) => {
        GAEvents.sendEvent('click in', 'Video Block Click', document.title);
      });


      // Fixing "click to start video" native behaviour on mobile
      video.addEventListener("touchstart", (event) => {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }, {passive: true});
    });
  },
};

module.exports = Video;

},{"./ga-events":21}],36:[function(require,module,exports){
const $ = require('cash-dom');
const Ajax = require('./ajax');
const popup = require('./popup');
const Page = require('./page');
const Validator = require('./validator');

const WriteReview = {
  init() {
    $(document.body).on('click', '.submit-review', function () {
      let $btn = $(this),
        $form = $btn.parents('.review-form'),
        formData = new FormData($form.get(0));

      if ($btn.hasClass('process')) {
        return false;
      }

      $btn.addClass('process');
      Page.startLoad('submit-review', $btn);
      Validator.removeErrors($form);

      formData.set('review-email', $('#review-email').val());
      formData.set('review-author', $('#review-author').val());

      Ajax.post(ajaxurl + '?action=submit-user-review', formData, function (result) {
        Page.finishLoad('submit-review');

        //validation errors
        if (typeof result.errors !== 'undefined' && result.errors.length > 0) {
          Validator.validate($form, result.errors);
        }

        //show popup with email and name
        if (typeof result.success !== 'undefined' && result.success === true &&
          typeof result.additional_fields !== 'undefined' && result.additional_fields === true) {

          $('[name="only-validation"]').remove();

          $('.navigation, .breadcrumbs, #content, .footer').addClass('blurred');
          popup.show($('#write-review-additional').html());
        } else if (typeof result.success !== 'undefined' && result.success === true && typeof result.redirect !== 'undefined') {
          //everything is good, review added
          window.location.href = result.redirect;
        }

        $btn.removeClass('process');

      }, 'json');

      return false;
    });

    $(document.body).on('click', '#submit-additional-form', function () {
      $('.submit-review').trigger('click');
      popup.hide();
      return false;
    });
  },
};

module.exports = WriteReview;

},{"./ajax":16,"./page":24,"./popup":26,"./validator":34,"cash-dom":1}],37:[function(require,module,exports){
const $ = require('cash-dom');
const GAEvents = require('./ga-events');

const YoutubeEmbedEvents = {
  init() {
    window.addEventListener('blur',function(){
      let activeEl = $(document.activeElement);

      if(activeEl.prop('tagName') === 'IFRAME' && activeEl.attr('src').indexOf('youtube.com/embed') > 0){
        GAEvents.sendEvent('YouTubeEmbedShortcode', 'VideoPlayed', document.title);

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
          let aloomaData = $.extend({}, aloomaPageData);
          aloomaData.eventName = 'YouTubeEmbedShortcode';

          aloomaSendEvent('VideoPlayed', aloomaData);
        }
      }
    });
  }
}

module.exports = YoutubeEmbedEvents;
},{"./ga-events":21,"cash-dom":1}],38:[function(require,module,exports){
const BaseOrganic = require('./common/base-organic');
const $ = require('cash-dom');
const QuickNav = require('./components/quick-nav');
require('../vendor/modernizr-custom.min');
const Ajax = require('./components/ajax');
const Page = require('./components/page');
const Validator = require('./components/validator');
const Device = require('./components/device');
const Template = require('./components/template');
const WriteReview = require('./components/write-review');
const SmoothScroll = require('./components/smooth-scroll');
const StarsRatingAndFeedback = require('./components/stars-rating-and-feedback');
const YoutubeEmbedEvents = require('./components/youtube-embed-events');

const VendorPage = {
  stickyEnabled: false,

  initSingleReview: function () {
    const self = this;

    //helpful link
    $(document).on('click', '.review-helpful-link:not(.loading)', function (e) {
      var $btn = $(this),
        review_id = $btn.closest('.single-user-review').attr('data-review');

      Page.startLoad('helpful', $btn);
      Ajax.post(ajaxurl, {
        action: 'UserReview_vote',
        type: 'helpful',
        review_id: review_id,
        remove: $btn.hasClass('clicked')
      }, function (response) {
        Page.finishLoad('helpful');

        if (response.success) {
          if (response.status) {
            $btn.addClass('clicked');

            $btn.find('.counter')
              .toggleClass('zero', !(response.status.helpful > 0))
              .text(response.status.helpful - 0);
          }

          $btn.toggleClass('clicked', response.status.type === 'helpful');

          if (response.status.helpful > 0) {
            setTimeout(function () {
              $btn.closest('.single-user-review').find('.review-share-link').trigger('click');
            }, 1000);
          }

        }
      }, 'json');
    });

    //share popup
    $(document).on('click', '.review-share-link', function (e) {
      e.preventDefault();

      var href = $(this).data('share-href');
      Template.popup('#review-share-popup', []);

      // setting urls the selected review
      $('#cboxLoadedContent').find('.sharrre[data-url]').attr('data-url', href);
    });

    //reply popup
    $(document).on('click', '.review-reply-link', function (e) {
      e.preventDefault();

      var vars = {};
      vars.review_id = $(this).attr('data-review');
      vars.reply_id = typeof $(this).attr('data-reply') !== 'undefined' ? $(this).attr('data-reply') : 0;
      vars.name = $(this).attr('data-author').trim();

      if (vars.review_id > 0) {
        Template.popup('#user_review_reply_form', vars, {'className': 'review-reply-popup template-popup'});
      }
    });

    //submit reply form
    $(document).on('click', 'form.add-reply .add-reply-btn', function (e) {
      e.preventDefault();

      var form = $(this).closest('form'),
        response = form.find('.server-response');

      Page.startLoad('reply-popup', 'popup');

      Ajax.post(ajaxurl, new FormData(form.get(0)), function (res) {
        Page.finishLoad('reply-popup');

        response.html('');

        if (typeof res.errors !== 'undefined' && res.errors.length > 0) {
          Validator.validate(form, res.errors, false);
        } else {
          Validator.removeErrors(form);
          form.get(0).reset();
          response.append('<div class="alert alert-success">' + res.msg + '</div>');
        }
      }, 'json');
    });
  },
  initSubmittedReview: function () {
    if ($('#ask_to_share').length) {
      setTimeout(function () {
        Template.popup('#ask_to_share', []);
      }, 2000);
    }
  },
  filterReviews: function (href, doNotUpdateHistory) {
    if (typeof href !== 'undefined') {
      if (Modernizr.history && doNotUpdateHistory !== true) {
        window.history.pushState(null, $('title').html(), href);
      }

      Ajax.post(href, {ajaxReviews: 1}, function (html) {
        $('.users-reviews-container').html(html);

        Page.scrollTo($('.users-reviews-container'), 500, -20);

        Page.finishLoad('reviews-filter');
      });
    }
  },
  initMobileScrollbox: function () {
    let scrollbox = $('#mobile_scrollbox');

    if (!scrollbox.length) {
      return;
    }

    let hideBeforeFooter = scrollbox.hasClass('desktop-visible'),
      footerEl =  $('.site-footer').get(0);

    scrollbox.find('.close-btn').on('click', (e) => {
      $('#mobile_scrollbox').remove();
    });

    window.addEventListener('scroll', function () {
      let isShowScrollbox = $('#page_title').get(0).getBoundingClientRect().top < 0;

      if (isShowScrollbox && hideBeforeFooter) {
        isShowScrollbox = Math.floor(window.scrollY) <=
          Math.ceil(document.body.scrollHeight - document.body.offsetHeight - footerEl.offsetHeight);
      }

      if (isShowScrollbox && scrollbox.hasClass('hidden')) {
        scrollbox.removeClass('hidden');
        $('body').first().addClass('mobile-scrollbox-active');
      } else if (!isShowScrollbox && !scrollbox.hasClass('hidden')) {
        scrollbox.addClass('hidden');
        $('body').first().removeClass('mobile-scrollbox-active');
      }
    }, {passive: true});
  },
  init: function () {
    var self = this;

    self.initSingleReview();
    // self.initSubmittedReview();
    self.initMobileScrollbox();

    //Filters
    $(document).on('change', '[name="reviews-filter[language][]"]', function () {
      var href = $(this).attr('data-filter-href');

      Page.startLoad('reviews-filter', '.language-filter');

      self.filterReviews(href);
    });

    $(document).on('click', 'a.page-numbers, .sort-choices a', function (e) {
      e.preventDefault();

      var href = $(this).attr('href');

      Page.startLoad('reviews-filter', $(this));

      self.filterReviews(href);
    });

    $(document).on('click', '#show_next_page', function (e) {
      e.preventDefault();

      var href = $(this).attr('href');

      Page.startLoad('reviews-filter', $(this));

      Ajax.post(href, {ajaxReviews: 1}, function (html) {
        let userReviewsList = $(html).find('#user_reviews_list'),
          moreBtn = $(html).find('#show_next_page');

        if (userReviewsList.length) {
          let userReviews = userReviewsList.find('.single-user-review');

          if (userReviews.length) {
            let firstNewReviewId = $(userReviews.get(0)).attr('data-review');

            $('#show_next_page').trigger('blur');

            $('#user_reviews_list').append(userReviewsList.html());

            // Page.scrollTo($('.single-user-review[data-review="' + firstNewReviewId + '"]'), 500, -20);
          }
        }

        if (moreBtn.length) {
          $('#show_next_page').attr('href', moreBtn.attr('href'));
        } else {
          $('.user-reviews-holder .card-footer').remove();
        }

        Page.finishLoad('reviews-filter');
      });
    });

    $(document).on('click', '#toggle_language_filter', function (e) {
      e.preventDefault();

      $('.language-filter').toggleClass('opened');
    });

    $(document).on('click', '.filter-sort-toggle', function (e) {
      e.preventDefault();
      $(this).closest('.sort-filter').toggleClass('active');
    });

    //comparisons in expert review
    $('.comparison-toggle').on('click', function (e) {
      e.preventDefault();

      var $section = $(this).closest('.section');

      $section.find('.comparison').toggleClass('d-none');
      $section.find('.bar').each(function () {
        var width = $(this).data('width');
        $(this).width(width);
      });
      $(this).find('i').toggleClass('fa-chevron-up');
    });

    $('.score-entry a').on('click', function (e) {
      e.preventDefault();

      var section = $(this).find('.score-label').text();
      var $h3 = $('h3').filter(function (i, el) {
        return $(el).text().toUpperCase().indexOf(section.toUpperCase()) >= 0;
      });

      if ($h3.length > 0) {
        Page.scrollTo($h3, 0);
      }
    });

    //selected review
    $('.selected-review').each(function () {
      this.scrollIntoView();

      var $reviewEl = $(this);
      $reviewEl.addClass('selected-review-loaded');

      setTimeout(function () {
        $reviewEl.removeClass('selected-review-loaded');
      }, 1000);
    });

    //init expert review navbar
    if ($('.expert-review').length > 0) {
      window.addEventListener('scroll', function () {
        var reviewBottom = $('.expert-review').offset().top + $('.expert-review').outerHeight() - 60,
          reviewTop = $('.expert-review').offset().top,
          scrollTop = document.documentElement.scrollTop;

        if (Device.isMobile() || Device.isTablet()) {
          if ((reviewTop > scrollTop || reviewBottom < scrollTop) && !$('#expert_review_nav').hasClass('hidden')) {
            $('#expert_review_nav').addClass('hidden');
            $('aside .sticky').removeClass('margin-top');
          }
          return;
        }

        if ($('#expert_review_nav').hasClass('hidden') && reviewTop < scrollTop && reviewBottom > scrollTop) {
          $('#expert_review_nav').removeClass('hidden');
          //add margin to sticky sidebar
          $('aside .sticky.is_stuck').addClass('margin-top');
        }

        if ((reviewTop > scrollTop || reviewBottom < scrollTop) && !$('#expert_review_nav').hasClass('hidden')) {
          $('#expert_review_nav').addClass('hidden');
          $('aside .sticky').removeClass('margin-top');
        }
      }, {passive: true});
    }

    if ($('#inactive-notification').length > 0) {
      Template.popup('#inactive-notification', {}, {'className': 'inactive-notification-popup'});
    }
  }
};

$(function () {
  BaseOrganic.init();
  QuickNav.init();
  VendorPage.init();
  WriteReview.init();
  StarsRatingAndFeedback.init();
  SmoothScroll.init();
  YoutubeEmbedEvents.init();
});

},{"../vendor/modernizr-custom.min":39,"./common/base-organic":5,"./components/ajax":16,"./components/device":18,"./components/page":24,"./components/quick-nav":27,"./components/smooth-scroll":29,"./components/stars-rating-and-feedback":30,"./components/template":32,"./components/validator":34,"./components/write-review":36,"./components/youtube-embed-events":37,"cash-dom":1}],39:[function(require,module,exports){
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-history !*/
!function(n,e,o){function i(n,e){return typeof n===e}function t(){var n,e,o,t,r,f,d;for(var l in a)if(a.hasOwnProperty(l)){if(n=[],e=a[l],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(o=0;o<e.options.aliases.length;o++)n.push(e.options.aliases[o].toLowerCase());for(t=i(e.fn,"function")?e.fn():e.fn,r=0;r<n.length;r++)f=n[r],d=f.split("."),1===d.length?Modernizr[d[0]]=t:(!Modernizr[d[0]]||Modernizr[d[0]]instanceof Boolean||(Modernizr[d[0]]=new Boolean(Modernizr[d[0]])),Modernizr[d[0]][d[1]]=t),s.push((t?"":"no-")+d.join("-"))}}var s=[],a=[],r={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var o=this;setTimeout(function(){e(o[n])},0)},addTest:function(n,e,o){a.push({name:n,fn:e,options:o})},addAsyncTest:function(n){a.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=r,Modernizr=new Modernizr,Modernizr.addTest("history",function(){var e=navigator.userAgent;return-1===e.indexOf("Android 2.")&&-1===e.indexOf("Android 4.0")||-1===e.indexOf("Mobile Safari")||-1!==e.indexOf("Chrome")||-1!==e.indexOf("Windows Phone")||"file:"===location.protocol?n.history&&"pushState"in n.history:!1}),t(),delete r.addTest,delete r.addAsyncTest;for(var f=0;f<Modernizr._q.length;f++)Modernizr._q[f]();n.Modernizr=Modernizr}(window,document);
},{}],40:[function(require,module,exports){
!function(e,n){"function"==typeof define&&define.amd?define(n):"object"==typeof exports?module.exports=n(require,exports,module):e.ouibounce=n()}(this,function(e,n,o){return function(e,n){"use strict";function o(e,n){return"undefined"==typeof e?n:e}function i(e){var n=24*e*60*60*1e3,o=new Date;return o.setTime(o.getTime()+n),"; expires="+o.toUTCString()}function t(){s()||(L.addEventListener("mouseleave",u),L.addEventListener("mouseenter",r),L.addEventListener("keydown",c))}function u(e){e.clientY>k||(D=setTimeout(m,y))}function r(){D&&(clearTimeout(D),D=null)}function c(e){g||e.metaKey&&76===e.keyCode&&(g=!0,D=setTimeout(m,y))}function d(e,n){return a()[e]===n}function a(){for(var e=document.cookie.split("; "),n={},o=e.length-1;o>=0;o--){var i=e[o].split("=");n[i[0]]=i[1]}return n}function s(){return d(T,"true")&&!v}function m(){s()||(e&&(e.style.display="block"),E(),f())}function f(e){var n=e||{};"undefined"!=typeof n.cookieExpire&&(b=i(n.cookieExpire)),n.sitewide===!0&&(w=";path=/"),"undefined"!=typeof n.cookieDomain&&(x=";domain="+n.cookieDomain),"undefined"!=typeof n.cookieName&&(T=n.cookieName),document.cookie=T+"=true"+b+x+w,L.removeEventListener("mouseleave",u),L.removeEventListener("mouseenter",r),L.removeEventListener("keydown",c)}var l=n||{},v=l.aggressive||!1,k=o(l.sensitivity,20),p=o(l.timer,1e3),y=o(l.delay,0),E=l.callback||function(){},b=i(l.cookieExpire)||"",x=l.cookieDomain?";domain="+l.cookieDomain:"",T=l.cookieName?l.cookieName:"viewedOuibounceModal",w=l.sitewide===!0?";path=/":"",D=null,L=document.documentElement;setTimeout(t,p);var g=!1;return{fire:m,disable:f,isDisabled:s}}});
},{}],41:[function(require,module,exports){
/*!
 * Sienna Accessibility Widget v1.1
 * (c) 2024 Benny Luk
 * License: GNU
 * Home Page : https://accessibility-widget.pages.dev/
 * Repository: git+https://github.com/bennyluk/Sienna-Accessibility-Widget.git
 *
 * 2025-06-10 SAF-1310 - Fixed: set zh_Hans for zh language as default
 * 2025-06-11 SAF-1310 - Added da, sv, th, tr languages
 */
(() => {
  'use strict';
  var t = function () {
    return t = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, t.apply(this, arguments);
  }, e = {}, n = 'asw';

  function i(n) {
    var i = t(t({}, e), {states: t(t({}, e.states), n)});
    return a(i), i;
  }

  function a(i) {
    e = t(t({}, e), i), function (t, e, n) {
      var i = new Date;
      i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3);
      var a = 'expires=' + i.toUTCString();
      document.cookie = t + '=' + e + ';' + a + ';path=/';
    }(n, JSON.stringify(e));
  }

  function o(t) {
    var n;
    return null === (n = null == e ? void 0 : e.states) || void 0 === n ? void 0 : n[t];
  }

  function s(t) {
    if (void 0 === t && (t = !0), t) return e;
    var i = function (t) {
      for (var e = t + '=', n = decodeURIComponent(document.cookie).split(';'), i = 0; i < n.length; i++) {
        for (var a = n[i]; " " == a.charAt(0);) a = a.substring(1);
        if (0 == a.indexOf(e)) return a.substring(e.length, a.length);
      }
      return '';
    }(n);
    return i && (e = JSON.parse(i)), e;
  }

  function r(t) {
    void 0 === t && (t = 1), document.querySelectorAll('h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,th,td,span,blockquote,.asw-text').forEach((function (e) {
      var n;
      if (!e.classList.contains('material-icons') && !e.classList.contains('fa')) {
        var i = Number(null !== (n = e.getAttribute('data-asw-orgFontSize')) && void 0 !== n ? n : 0);
        i || (i = parseInt(window.getComputedStyle(e).getPropertyValue('font-size')), e.setAttribute('data-asw-orgFontSize', String(i)));
        var a = i * t;
        e.style['font-size'] = a + 'px';
      }
    }));
    var e = document.querySelector('.asw-amount');
    e && (e.innerText = ''.concat((100 * t).toFixed(0), '%'));
  }

  function l(t) {
    var e = t.id, n = t.css;
    if (n) {
      var i = document.getElementById(e || '') || document.createElement('style');
      i.innerHTML = n, i.id || (i.id = e, document.head.appendChild(i));
    }
  }

  var c = ['-o-', '-ms-', '-moz-', '-webkit-', ''], g = ['filter'];

  function u(t) {
    var e, n = '';
    return t && ((n += function (t) {
      var e = '';
      if (t) {
        var n = function (n) {
          (g.includes(n) ? c : ['']).forEach((function (i) {
            e += ''.concat(i).concat(n, ':').concat(t[n], ' !important;');
          }));
        };
        for (var i in t) n(i);
      }
      return e;
    }(t.styles)).length && t.selector && (n = function (t) {
      var e = t.selector, n = t.childrenSelector, i = void 0 === n ? [''] : n, a = t.css, o = '';
      return i.forEach((function (t) {
        o += ''.concat(e, ' ').concat(t, '{').concat(a, '}');
      })), o;
    }({
      selector: t.selector,
      childrenSelector: t.childrenSelector,
      css: n
    })), n += null !== (e = t.css) && void 0 !== e ? e : ''), n;
  }

  function d(t) {
    var e, n = t.id, i = void 0 === n ? '' : n, a = t.enable, o = void 0 !== a && a, s = 'asw-'.concat(i);
    o ? l({css: u(t), id: s}) : null === (e = document.getElementById(s)) || void 0 === e || e.remove();
    document.documentElement.classList.toggle(s, o);
  }

  var h = function (t, e, n) {
      if (n || 2 === arguments.length) for (var i, a = 0, o = e.length; a < o; a++) !i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
      return t.concat(i || Array.prototype.slice.call(e));
    }, p = ['', '*:not(.material-icons,.asw-menu,.asw-menu *)'],
    m = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.wsite-headline', '.wsite-content-title'],
    v = h(h([], m, !0), ['img', 'p', 'i', 'svg', 'a', 'button:not(.asw-btn)', 'label', 'li', 'ol'], !1), b = {
      'dark-contrast': {styles: {color: '#FFF', fill: '#FFF', 'background-color': '#000'}, childrenSelector: v},
      'light-contrast': {styles: {color: '#000', fill: '#000', 'background-color': '#FFF'}, childrenSelector: v},
      'high-contrast': {styles: {filter: 'contrast(125%)'}},
      'high-saturation': {styles: {filter: 'saturate(200%)'}},
      'low-saturation': {styles: {filter: 'saturate(50%)'}},
      monochrome: {styles: {filter: 'grayscale(100%)'}}
    };
  var S = function () {
    return S = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, S.apply(this, arguments);
  };

  function w() {
    var t = s().states.contrast, e = '', n = b[t];
    n && (e = u(S(S({}, n), {selector: 'html.aws-filter'}))), l({
      css: e,
      id: 'asw-filter-style'
    }), document.documentElement.classList.toggle('aws-filter', Boolean(t));
  }

  var f = function () {
    return f = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, f.apply(this, arguments);
  }, y = {
    id: 'stop-animations',
    selector: 'html',
    childrenSelector: ['*'],
    styles: {
      transition: 'none',
      'animation-fill-mode': 'forwards',
      'animation-iteration-count': '1',
      'animation-duration': '.01s'
    }
  };
  var k = function () {
    return k = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, k.apply(this, arguments);
  }, C = {
    id: 'readable-font',
    selector: 'html',
    childrenSelector: function (t, e, n) {
      if (n || 2 === arguments.length) for (var i, a = 0, o = e.length; a < o; a++) !i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
      return t.concat(i || Array.prototype.slice.call(e));
    }(['', '*:not(.material-icons,.fa)'], v, !0),
    styles: {'font-family': 'OpenDyslexic3,Comic Sans MS,Arial,Helvetica,sans-serif'},
    css: '\n        @font-face {\n            font-family: OpenDyslexic3;\n            src: url("https://website-widgets.pages.dev/fonts/OpenDyslexic3-Regular.woff") format("woff"), url("https://website-widgets.pages.dev/fonts/OpenDyslexic3-Regular.ttf") format("truetype");\n        }\n    '
  };
  var A = function () {
    return A = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, A.apply(this, arguments);
  }, L = {
    id: 'big-cursor',
    selector: 'body',
    childrenSelector: ['*'],
    styles: {cursor: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'98px\' height=\'98px\' viewBox=\'0 0 48 48\'%3E%3Cpath fill=\'%23E0E0E0\' d=\'M27.8 39.7c-.1 0-.2 0-.4-.1s-.4-.3-.6-.5l-3.7-8.6-4.5 4.2c-.1.2-.3.3-.6.3-.1 0-.3 0-.4-.1-.3-.1-.6-.5-.6-.9V12c0-.4.2-.8.6-.9.1-.1.3-.1.4-.1.2 0 .5.1.7.3l16 15c.3.3.4.7.3 1.1-.1.4-.5.6-.9.7l-6.3.6 3.9 8.5c.1.2.1.5 0 .8-.1.2-.3.5-.5.6l-2.9 1.3c-.2-.2-.4-.2-.5-.2z\'/%3E%3Cpath fill=\'%23212121\' d=\'m18 12 16 15-7.7.7 4.5 9.8-2.9 1.3-4.3-9.9L18 34V12m0-2c-.3 0-.5.1-.8.2-.7.3-1.2 1-1.2 1.8v22c0 .8.5 1.5 1.2 1.8.3.2.6.2.8.2.5 0 1-.2 1.4-.5l3.4-3.2 3.1 7.3c.2.5.6.9 1.1 1.1.2.1.5.1.7.1.3 0 .5-.1.8-.2l2.9-1.3c.5-.2.9-.6 1.1-1.1.2-.5.2-1.1 0-1.5l-3.3-7.2 4.9-.4c.8-.1 1.5-.6 1.7-1.3.3-.7.1-1.6-.5-2.1l-16-15c-.3-.5-.8-.7-1.3-.7z\'/%3E%3C/svg%3E") 40 15, auto'}
  };
  var F = function () {
    return F = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, F.apply(this, arguments);
  }, x = {
    id: 'highlight-title',
    selector: 'html',
    childrenSelector: m,
    styles: {outline: '2px solid #0048ff', 'outline-offset': '2px'}
  };
  const H = '<style>.asw-rg{position:fixed;top:0;left:0;right:0;width:100%;height:0;pointer-events:none;background-color:rgba(0,0,0,.8);z-index:1000000}</style> <div class="asw-rg asw-rg-top"></div> <div class="asw-rg asw-rg-bottom" style="top:auto;bottom:0"></div>';
  var z = function () {
    return z = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, z.apply(this, arguments);
  }, j = {
    id: 'highlight-links',
    selector: 'html',
    childrenSelector: ['a[href]'],
    styles: {outline: '2px solid #0048ff', 'outline-offset': '2px'}
  };
  var M = function () {
    return M = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, M.apply(this, arguments);
  }, D = {id: 'letter-spacing', selector: 'html', childrenSelector: p, styles: {'letter-spacing': '2px'}};
  var R = function () {
    return R = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, R.apply(this, arguments);
  }, O = {id: 'line-height', selector: 'html', childrenSelector: p, styles: {'line-height': '3'}};
  var T = function () {
    return T = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, T.apply(this, arguments);
  }, B = {id: 'font-weight', selector: 'html', childrenSelector: p, styles: {'font-weight': '700'}};

  function P() {
    var t, e = s().states;
    void 0 === (t = e['highlight-title']) && (t = !1), d(F(F({}, x), {enable: t})), function (t) {
      void 0 === t && (t = !1), d(z(z({}, j), {enable: t}));
    }(e['highlight-links']), function (t) {
      void 0 === t && (t = !1), d(M(M({}, D), {enable: t}));
    }(e['letter-spacing']), function (t) {
      void 0 === t && (t = !1), d(R(R({}, O), {enable: t}));
    }(e['line-height']), function (t) {
      void 0 === t && (t = !1), d(T(T({}, B), {enable: t}));
    }(e['font-weight']), function (t) {
      void 0 === t && (t = !1), d(k(k({}, C), {enable: t}));
    }(e['readable-font']), function (t) {
      void 0 === t && (t = !1);
      var e = document.querySelector('.asw-rg-container');
      if (t) {
        if (!e) {
          (e = document.createElement('div')).setAttribute('class', 'asw-rg-container'), e.innerHTML = H;
          var n = e.querySelector('.asw-rg-top'), i = e.querySelector('.asw-rg-bottom');
          window.__asw__onScrollReadableGuide = function (t) {
            n.style.height = t.clientY - 20 + 'px', i.style.height = window.innerHeight - t.clientY - 40 + 'px';
          }, document.addEventListener('mousemove', window.__asw__onScrollReadableGuide, {passive: !1}), document.body.appendChild(e);
        }
      } else e && e.remove(), window.__asw__onScrollReadableGuide && (document.removeEventListener('mousemove', window.__asw__onScrollReadableGuide), delete window.__asw__onScrollReadableGuide);
    }(e['readable-guide']), function (t) {
      void 0 === t && (t = !1), d(f(f({}, y), {enable: t}));
    }(e['stop-animations']), function (t) {
      void 0 === t && (t = !1), d(A(A({}, L), {enable: t}));
    }(e['big-cursor']);
  }

  function I() {
    var t = s().states;
    r((null == t ? void 0 : t.fontSize) || 1), P(), w();
  }

  const V = '<style>.asw-menu,.asw-widget{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-weight:400;-webkit-font-smoothing:antialiased}.asw-menu *,.asw-widget *{box-sizing:border-box!important}.asw-menu-btn{position:fixed;z-index:500000;left:30px;bottom:30px;box-shadow:0 5px 15px 0 rgb(37 44 97 / 15%),0 2px 4px 0 rgb(93 100 148 / 20%);transition:transform .2s ease;border-radius:50%;align-items:center;justify-content:center;width:58px;height:58px;display:flex;cursor:pointer;border:3px solid #fff!important;outline:5px solid #0048ff!important;text-decoration:none!important;background:#326cff!important;background:linear-gradient(96deg,#326cff 0,#0048ff 100%)!important}.asw-menu-btn svg{width:36px;height:36px;min-height:36px;min-width:36px;max-width:36px;max-height:36px;background:0 0!important}.asw-menu-btn:hover{transform:scale(1.05)}@media only screen and (max-width:768px){.asw-menu-btn{width:42px;height:42px}.asw-menu-btn svg{width:26px;height:26px;min-height:26px;min-width:26px;max-width:26px;max-height:26px}}</style> <div class="asw-widget"> <a href="https://accessibility-widget.pages.dev" target="_blank" class="asw-menu-btn" title="Open Accessibility Menu" role="button" aria-expanded="false"> <svg xmlns="http://www.w3.org/2000/svg" style="fill:white" viewBox="0 0 24 24" width="30px" height="30px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg> </a> </div>';

  function N(t, e) {
    t.style.display = void 0 === e ? 'none' === t.style.display ? 'block' : 'none' : 1 == e ? 'block' : 'none';
  }

  const G = '<style>.asw-menu{position:fixed;left:0;top:0;box-shadow:0 0 20px #00000080;opacity:1;transition:.3s;z-index:500000;overflow:hidden;background:#eff1f5;width:500px;line-height:1;font-size:16px;height:100%;letter-spacing:.015em}.asw-menu *{color:#000!important;font-family:inherit;padding:0;margin:0;line-height:1!important;letter-spacing:normal!important}.asw-menu-header{display:flex;align-items:center;justify-content:space-between;padding-left:18px;padding-right:18px;height:55px;font-weight:700!important;background-color:#0848ca!important}.asw-menu-title{font-size:16px!important;color:#fff!important}.asw-menu-header svg{fill:#0848ca!important;width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;max-width:24px!important;max-height:24px!important}.asw-menu-header>div{display:flex}.asw-menu-header div[role=button]{padding:5px;background:#fff!important;cursor:pointer;border-radius:50%;transition:opacity .3s ease}.asw-menu-header div[role=button]:hover{opacity:.8}.asw-card{margin:0 15px 20px}.asw-card-title{font-size:14px!important;padding:15px 0;font-weight:600!important;opacity:.8}.asw-menu .asw-select{width:100%!important;padding:0 15px!important;font-size:16px!important;font-family:inherit!important;font-weight:600!important;border-radius:45px!important;background:#fff!important;border:none!important;min-height:45px!important;max-height:45px!important;height:45px!important;color:inherit!important}.asw-items{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1rem}.asw-btn{aspect-ratio:6/5;border-radius:12px;padding:0 15px;display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;color:#333;font-size:16px!important;background:#fff!important;border:2px solid transparent!important;transition:border-color .2s ease;cursor:pointer;word-break:break-word;gap:10px;position:relative}.asw-adjust-font .asw-label div,.asw-btn .asw-translate{font-size:14px!important;font-weight:600!important}.asw-minus,.asw-plus{background-color:#eff1f5!important;border:2px solid transparent;transition:border .2s ease}.asw-minus:hover,.asw-plus:hover{border-color:#0848ca!important}.asw-amount{font-size:18px!important;font-weight:600!important}.asw-adjust-font svg{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;max-width:24px!important;max-height:24px!important}.asw-btn svg{width:34px!important;height:34px!important;min-width:34px!important;min-height:34px!important;max-width:34px!important;max-height:34px!important}.asw-btn.asw-selected,.asw-btn:hover{border-color:#0848ca!important}.asw-btn.asw-selected span,.asw-btn.asw-selected svg{fill:#0848ca!important;color:#0848ca!important}.asw-btn.asw-selected:after{content:"✓";position:absolute;top:10px;right:10px;background-color:#0848ca!important;color:#fff;padding:6px;font-size:10px;width:18px;height:18px;border-radius:100%;line-height:6px}.asw-footer{position:absolute;bottom:0;left:0;right:0;background:#fff;padding:20px;text-align:center;border-top:2px solid #eff1f5}.asw-footer a{font-size:16px!important;text-decoration:none!important;color:#000!important;background:0 0!important;font-weight:600!important}.asw-footer a:hover,.asw-footer a:hover span{color:#0848ca!important}.asw-menu-content{overflow:scroll;max-height:calc(100% - 80px);padding:30px 0 15px}.asw-adjust-font{background:#fff;padding:20px;margin-bottom:20px}.asw-adjust-font .asw-label{display:flex;justify-content:flex-start}.asw-adjust-font>div{display:flex;justify-content:space-between;margin-top:20px;align-items:center;font-size:15px}.asw-adjust-font .asw-label div{font-size:15px!important}.asw-adjust-font div[role=button]{background:#eff1f5!important;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer}.asw-overlay{position:fixed;top:0;left:0;width:100%;height:100%;z-index:10000}@media only screen and (max-width:560px){.asw-menu{width:100%}}@media only screen and (max-width:420px){.asw-items{grid-template-columns:repeat(2,minmax(0,1fr));gap:.5rem}}</style> <div class="asw-menu"> <div class="asw-menu-header"> <div class="asw-menu-title asw-translate"> Accessibility Menu </div> <div style="gap:15px"> <div role="button" class="asw-menu-reset" title="Reset settings"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M12 4c2.1 0 4.1.8 5.6 2.3 3.1 3.1 3.1 8.2 0 11.3a7.78 7.78 0 0 1-6.7 2.3l.5-2c1.7.2 3.5-.4 4.8-1.7a6.1 6.1 0 0 0 0-8.5A6.07 6.07 0 0 0 12 6v4.6l-5-5 5-5V4M6.3 17.6C3.7 15 3.3 11 5.1 7.9l1.5 1.5c-1.1 2.2-.7 5 1.2 6.8.5.5 1.1.9 1.8 1.2l-.6 2a8 8 0 0 1-2.7-1.8Z"/> </svg> </div> <div role="button" class="asw-menu-close" title="Close"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"/> </svg> </div> </div> </div> <div class="asw-menu-content"> <div class="asw-card"> <select id="asw-language" title="Language" class="asw-select"></select> </div> <div class="asw-card"> <div class="asw-card-title"> Content Adjustments </div> <div class="asw-adjust-font"> <div class="asw-label" style="margin:0"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="margin-right:15px"> <path d="M2 4v3h5v12h3V7h5V4H2m19 5h-9v3h3v7h3v-7h3V9Z"/> </svg> <div class="asw-translate"> Adjust Font Size </div> </div> <div> <div class="asw-minus" data-key="font-size" role="button" aria-pressed="false" title="Decrease Font Size" tabindex="0"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M19 13H5v-2h14v2Z"/> </svg> </div> <div class="asw-amount"> 100% </div> <div class="asw-plus" data-key="font-size" role="button" aria-pressed="false" title="Increase Font Size" tabindex="0"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"/> </svg> </div> </div> </div> <div class="asw-items content"> </div> </div> <div class="asw-card"> <div class="asw-card-title"> Color Adjustments </div> <div class="asw-items contrast"> </div> </div> <div class="asw-card"> <div class="asw-card-title"> Tools </div> <div class="asw-items tools"> </div> </div> </div> <div class="asw-footer"> <a href="https://accessibility-widget.pages.dev" target="_blank">Web Accessibility By <span style="font-weight:700;color:inherit">Sienna</span> ❤️</a> </div> </div> <div class="asw-overlay"> </div>',
    E = [{
      label: 'Monochrome',
      key: 'monochrome',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="m19 19-7-8v8H5l7-8V5h7m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>\n</svg>'
    }, {
      label: 'Low Saturation',
      key: 'low-saturation',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M11 9h2v2h-2V9m-2 2h2v2H9v-2m4 0h2v2h-2v-2m2-2h2v2h-2V9M7 9h2v2H7V9m12-6H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2M9 18H7v-2h2v2m4 0h-2v-2h2v2m4 0h-2v-2h2v2m2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6Z"/>\n</svg>'
    }, {
      label: 'High Saturation',
      key: 'high-saturation',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M12 16a4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4 4 4 0 0 1-4 4m6.7-3.6a6.06 6.06 0 0 0-.86-.4 5.98 5.98 0 0 0 3.86-5.59 6 6 0 0 0-6.78.54A5.99 5.99 0 0 0 12 .81a6 6 0 0 0-2.92 6.14A6 6 0 0 0 2.3 6.4 5.95 5.95 0 0 0 6.16 12a6 6 0 0 0-3.86 5.58 6 6 0 0 0 6.78-.54A6 6 0 0 0 12 23.19a6 6 0 0 0 2.92-6.14 6 6 0 0 0 6.78.54 5.98 5.98 0 0 0-3-5.19Z"/>\n</svg>'
    }, {
      label: 'High Contrast',
      key: 'high-contrast',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 17.93a8 8 0 0 1 0-15.86v15.86zm2-15.86a8 8 0 0 1 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87a8 8 0 0 1-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93a8.4 8.4 0 0 1-.19 1z"/>\n</svg>'
    }, {
      label: 'Light Contrast',
      key: 'light-contrast',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M12 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6 6 6 0 0 1 6 6 6 6 0 0 1-6 6m8-2.69L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69Z"/>\n</svg>'
    }, {
      label: 'Dark Contrast',
      key: 'dark-contrast',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M18 12c0-4.5-1.92-8.74-6-10a10 10 0 0 0 0 20c4.08-1.26 6-5.5 6-10Z"/>\n</svg>'
    }], Z = [{
      label: 'Font Weight',
      key: 'font-weight',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M13.5 15.5H10v-3h3.5A1.5 1.5 0 0 1 15 14a1.5 1.5 0 0 1-1.5 1.5m-3.5-9h3A1.5 1.5 0 0 1 14.5 8 1.5 1.5 0 0 1 13 9.5h-3m5.6 1.29c.97-.68 1.65-1.79 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.1 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42Z"/>\n</svg>'
    }, {
      label: 'Line Height',
      key: 'line-height',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M21 22H3v-2h18v2m0-18H3V2h18v2m-11 9.7h4l-2-5.4-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z"/>\n</svg>'
    }, {
      label: 'Letter Spacing',
      key: 'letter-spacing',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M22 3v18h-2V3h2M4 3v18H2V3h2m6 10.7h4l-2-5.4-2 5.4M11.2 6h1.7l4.7 12h-2l-.9-2.6H9.4L8.5 18h-2l4.7-12Z"/>\n</svg>'
    }, {
      label: 'Dyslexia Font',
      key: 'readable-font',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="m21.59 11.59-8.09 8.09L9.83 16l-1.41 1.41 5.08 5.09L23 13M6.43 11 8.5 5.5l2.07 5.5m1.88 5h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3Z"/>\n</svg>'
    }, {
      label: 'Highlight Links',
      key: 'highlight-links',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14v14m-5.06-8.94a3.37 3.37 0 0 1 0 4.75L11.73 17A3.29 3.29 0 0 1 7 17a3.31 3.31 0 0 1 0-4.74l1.35-1.36-.01.6c-.01.5.07 1 .23 1.44l.05.15-.4.41a1.6 1.6 0 0 0 0 2.28c.61.62 1.67.62 2.28 0l2.2-2.19c.3-.31.48-.72.48-1.15 0-.44-.18-.83-.48-1.14a.87.87 0 0 1 0-1.24.91.91 0 0 1 1.24 0m4.06-.7c0 .9-.35 1.74-1 2.38l-1.34 1.36v-.6c.01-.5-.07-1-.23-1.44l-.05-.14.4-.42a1.6 1.6 0 0 0 0-2.28 1.64 1.64 0 0 0-2.28 0l-2.2 2.2c-.3.3-.48.71-.48 1.14 0 .44.18.83.48 1.14.17.16.26.38.26.62s-.09.46-.26.62a.86.86 0 0 1-.62.25.88.88 0 0 1-.62-.25 3.36 3.36 0 0 1 0-4.75L12.27 7A3.31 3.31 0 0 1 17 7c.65.62 1 1.46 1 2.36Z"/>\n</svg>'
    }, {
      label: 'Highlight Title',
      key: 'highlight-title',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n    <path d="M5 4v3h5.5v12h3V7H19V4H5Z"/>\n</svg>'
    }], J = [{
      label: 'Big Cursor',
      key: 'big-cursor',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M11 1.07C7.05 1.56 4 4.92 4 9h7m-7 6a8 8 0 0 0 8 8 8 8 0 0 0 8-8v-4H4m9-9.93V9h7a8 8 0 0 0-7-7.93Z"/>\n</svg>'
    }, {
      label: 'Stop Animations',
      key: 'stop-animations',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M22 12c0-5.54-4.46-10-10-10-1.17 0-2.3.19-3.38.56l.7 1.94A7.15 7.15 0 0 1 12 3.97 8.06 8.06 0 0 1 20.03 12 8.06 8.06 0 0 1 12 20.03 8.06 8.06 0 0 1 3.97 12c0-.94.19-1.88.53-2.72l-1.94-.66A10.37 10.37 0 0 0 2 12c0 5.54 4.46 10 10 10s10-4.46 10-10M5.47 3.97c.85 0 1.53.71 1.53 1.5C7 6.32 6.32 7 5.47 7c-.79 0-1.5-.68-1.5-1.53 0-.79.71-1.5 1.5-1.5M18 12c0-3.33-2.67-6-6-6s-6 2.67-6 6 2.67 6 6 6 6-2.67 6-6m-7-3v6H9V9m6 0v6h-2V9"/>\n</svg>'
    }, {
      label: 'Reading Guide',
      key: 'readable-guide',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">\n  <path d="M12 8a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3m0 3.54A13.15 13.15 0 0 0 3 8v11c3.5 0 6.64 1.35 9 3.54A13.15 13.15 0 0 1 21 19V8c-3.5 0-6.64 1.35-9 3.54Z"/>\n</svg>'
    }];

  function W(t, e) {
    for (var n = '', i = t.length; i--;) {
      var a = t[i];
      n += '\n            <button class="asw-btn '.concat(e || '', '" type="button" data-key="').concat(a.key, '" title="').concat(a.label, '">\n                ').concat(a.icon, '\n                <span class="asw-translate">').concat(a.label, '</span>\n            </button>\n        ');
    }
    return n;
  }

  var K = {
    ar: JSON.parse('{"Accessibility Menu":"قائمة إمكانية الوصول","Reset settings":"إعادة تعيين الإعدادات","Close":"إغلاق","Content Adjustments":"تعديلات المحتوى","Adjust Font Size":"تعديل حجم الخط","Highlight Title":"تسليط الضوء على العنوان","Highlight Links":"تسليط الضوء على الروابط","Readable Font":"خط سهل القراءة","Color Adjustments":"تعديلات الألوان","Dark Contrast":"تباين داكن","Light Contrast":"تباين فاتح","High Contrast":"تباين عالي","High Saturation":"تشبع عالي","Low Saturation":"تشبع منخفض","Monochrome":"أحادي اللون","Tools":"أدوات","Reading Guide":"دليل القراءة","Stop Animations":"إيقاف الرسوم المتحركة","Big Cursor":"مؤشر كبير","Increase Font Size":"زيادة حجم الخط","Decrease Font Size":"تقليل حجم الخط","Letter Spacing":"تباعد الحروف","Line Height":"ارتفاع السطر","Font Weight":"سماكة الخط","Dyslexia Font":"خط القراءة لمن يعانون من عسر القراءة","Language":"اللغة","Open Accessibility Menu":"افتح قائمة الوصول"}'),
    bg: JSON.parse('{"Accessibility Menu":"Меню за достъпност","Reset settings":"Нулиране на настройките","Close":"Затвори","Content Adjustments":"Настройки на съдържанието","Adjust Font Size":"Настройка на размера на шрифта","Highlight Title":"Открояване на заглавието","Highlight Links":"Открояване на връзките","Readable Font":"Четим шрифт","Color Adjustments":"Настройки на цветовете","Dark Contrast":"Тъмен контраст","Light Contrast":"Светъл контраст","High Contrast":"Висок контраст","High Saturation":"Висока наситеност","Low Saturation":"Ниска наситеност","Monochrome":"Монохромен","Tools":"Инструменти","Reading Guide":"Ръководство за четене","Stop Animations":"Спри анимациите","Big Cursor":"Голям курсор","Increase Font Size":"Увеличи размера на шрифта","Decrease Font Size":"Намали размера на шрифта","Letter Spacing":"Разстояние между буквите","Line Height":"Височина на реда","Font Weight":"Дебелина на шрифта","Dyslexia Font":"Шрифт за дислексия","Language":"Език","Open Accessibility Menu":"Отвори меню за достъпност"}'),
    bn: JSON.parse('{"Accessibility Menu":"অভিগম্যতা মেনু","Reset settings":"নির্ধারণ পুনরায় সেট করুন","Close":"বন্ধ করুন","Content Adjustments":"কন্টেন্ট সংশোধন","Adjust Font Size":"ফন্ট সাইজ সংশোধন","Highlight Title":"শিরোনাম উজ্জ্বল করুন","Highlight Links":"লিঙ্কগুলি উজ্জ্বল করুন","Readable Font":"পঠনীয় ফন্ট","Color Adjustments":"রঙ সংশোধন","Dark Contrast":"অন্ধকারী প্রতিবিম্ব","Light Contrast":"আলোকিত প্রতিবিম্ব","High Contrast":"উচ্চ প্রতিবিম্ব","High Saturation":"উচ্চ সত্রাজন","Low Saturation":"নিম্ন সত্রাজন","Monochrome":"একরঙ","Tools":"সরঞ্জাম","Reading Guide":"পড়ার গাইড","Stop Animations":"অ্যানিমেশন বন্ধ করুন","Big Cursor":"বড় কার্সর","Increase Font Size":"ফন্ট সাইজ বাড়ান","Decrease Font Size":"ফন্ট সাইজ কমান","Letter Spacing":"অক্ষর বিরাটি","Line Height":"লাইন উচ্চতা","Font Weight":"ফন্ট ওজন","Dyslexia Font":"ডাইসলেক্সিয়া ফন্ট","Language":"ভাষা","Open Accessibility Menu":"অভিগম্যতা মেনু খোলুন"}'),
    cs: JSON.parse('{"Accessibility Menu":"Přístupnostní menu","Reset settings":"Obnovit nastavení","Close":"Zavřít","Content Adjustments":"Úpravy obsahu","Adjust Font Size":"Nastavit velikost písma","Highlight Title":"Zvýraznit nadpis","Highlight Links":"Zvýraznit odkazy","Readable Font":"Čitelný font","Color Adjustments":"Nastavení barev","Dark Contrast":"Tmavý kontrast","Light Contrast":"Světlý kontrast","High Contrast":"Vysoký kontrast","High Saturation":"Vysoká saturace","Low Saturation":"Nízká saturace","Monochrome":"Monochromatický","Tools":"Nástroje","Reading Guide":"Průvodce čtením","Stop Animations":"Zastavit animace","Big Cursor":"Velký kurzor","Increase Font Size":"Zvětšit velikost písma","Decrease Font Size":"Zmenšit velikost písma","Letter Spacing":"Mezery mezi písmeny","Line Height":"Výška řádku","Font Weight":"Tloušťka písma","Dyslexia Font":"Dyslexický font","Language":"Jazyk","Open Accessibility Menu":"Otevřít přístupnostní menu"}'),
    da: JSON.parse('{"Accessibility Menu":"Tilgængelighedsmenu","Reset settings":"Nulstil indstillinger","Close":"Luk","Content Adjustments":"Justeringer af indhold","Adjust Font Size":"Juster skriftstørrelse","Highlight Title":"Fremhæv titel","Highlight Links":"Fremhæv links","Readable Font":"Læsbar skrifttype","Color Adjustments":"Farvejusteringer","Dark Contrast":"Mørk kontrast","Light Contrast":"Lys kontrast","High Contrast":"Høj kontrast","High Saturation":"Høj mætning","Low Saturation":"Lav mætning","Monochrome":"Monokrom","Tools":"Værktøjer","Reading Guide":"Læsevejledning","Stop Animations":"Stop animationer","Big Cursor":"Stor markør","Increase Font Size":"Øg skriftstørrelse","Decrease Font Size":"Mindsk skriftstørrelse","Letter Spacing":"Bogstavafstand","Line Height":"Linjehøjde","Font Weight":"Skrifttypevægt","Dyslexia Font":"Ordblinde-skrifttype","Language":"Sprog","Open Accessibility Menu":"Åbn tilgængelighedsmenu"}'),
    de: JSON.parse('{"Accessibility Menu":"Barrierefreiheit","Reset settings":"Einstellungen zurücksetzen","Close":"Schließen","Content Adjustments":"Inhaltsanpassungen","Adjust Font Size":"Schriftgröße anpassen","Highlight Title":"Titel hervorheben","Highlight Links":"Links hervorheben","Readable Font":"Lesbare Schrift","Color Adjustments":"Farbanpassungen","Dark Contrast":"Dunkler Kontrast","Light Contrast":"Heller Kontrast","High Contrast":"Hoher Kontrast","High Saturation":"Hohe Farbsättigung","Low Saturation":"Niedrige Farbsättigung","Monochrome":"Monochrom","Tools":"Werkzeuge","Reading Guide":"Lesehilfe","Stop Animations":"Animationen stoppen","Big Cursor":"Großer Cursor","Increase Font Size":"Schriftgröße vergrößern","Decrease Font Size":"Schriftgröße verkleinern","Letter Spacing":"Zeichenabstand","Line Height":"Zeilenhöhe","Font Weight":"Schriftstärke","Dyslexia Font":"Dyslexie-Schrift","Language":"Sprache","Open Accessibility Menu":"Barrierefreiheitsmenü öffnen"}'),
    el: JSON.parse('{"Accessibility Menu":"Μενού προσβασιμότητας","Reset settings":"Επαναφορά ρυθμίσεων","Close":"Κλείσιμο","Content Adjustments":"Προσαρμογές περιεχομένου","Adjust Font Size":"Προσαρμογή μεγέθους γραμματοσειράς","Highlight Title":"Επισήμανση τίτλου","Highlight Links":"Επισήμανση συνδέσμων","Readable Font":"Ευανάγνωστη γραμματοσειρά","Color Adjustments":"Προσαρμογές χρωμάτων","Dark Contrast":"Αντίθεση σε σκούρο","Light Contrast":"Αντίθεση σε φωτεινό","High Contrast":"Υψηλή αντίθεση","High Saturation":"Υψηλός κορεσμός","Low Saturation":"Χαμηλός κορεσμός","Monochrome":"Μονόχρωμο","Tools":"Εργαλεία","Reading Guide":"Οδηγός ανάγνωσης","Stop Animations":"Αφαίρεση κίνησης","Big Cursor":"Μεγάλος δείκτης","Increase Font Size":"Αύξηση μεγέθους γραμματοσειράς","Decrease Font Size":"Μείωση μεγέθους γραμματοσειράς","Letter Spacing":"Διάκενο γραμμάτων","Line Height":"Υψος γραμμής","Font Weight":"Βάρος γραμματοσειράς","Dyslexia Font":"Γραμματοσειρά για δυσλεξία","Language":"Γλώσσα","Open Accessibility Menu":"Ανοίξτε το μενού προσβασιμότητας"}'),
    en: JSON.parse('{"Accessibility Menu":"Accessibility Menu","Reset settings":"Reset settings","Close":"Close","Content Adjustments":"Content Adjustments","Adjust Font Size":"Adjust Font Size","Highlight Title":"Highlight Title","Highlight Links":"Highlight Links","Readable Font":"Readable Font","Color Adjustments":"Color Adjustments","Dark Contrast":"Dark Contrast","Light Contrast":"Light Contrast","High Contrast":"High Contrast","High Saturation":"High Saturation","Low Saturation":"Low Saturation","Monochrome":"Monochrome","Tools":"Tools","Reading Guide":"Reading Guide","Stop Animations":"Stop Animations","Big Cursor":"Big Cursor","Increase Font Size":"Increase Font Size","Decrease Font Size":"Decrease Font Size","Letter Spacing":"Letter Spacing","Line Height":"Line Height","Font Weight":"Font Weight","Dyslexia Font":"Dyslexia Font","Language":"Language","Open Accessibility Menu":"Open Accessibility Menu"}'),
    es: JSON.parse('{"Accessibility Menu":"Menú de accesibilidad","Reset settings":"Restablecer configuración","Close":"Cerrar","Content Adjustments":"Ajustes de contenido","Adjust Font Size":"Ajustar el tamaño de fuente","Highlight Title":"Destacar título","Highlight Links":"Destacar enlaces","Readable Font":"Fuente legible","Color Adjustments":"Ajustes de color","Dark Contrast":"Contraste oscuro","Light Contrast":"Contraste claro","High Contrast":"Alto contraste","High Saturation":"Alta saturación","Low Saturation":"Baja saturación","Monochrome":"Monocromo","Tools":"Herramientas","Reading Guide":"Guía de lectura","Stop Animations":"Detener animaciones","Big Cursor":"Cursor grande","Increase Font Size":"Aumentar tamaño de fuente","Decrease Font Size":"Reducir tamaño de fuente","Letter Spacing":"Espaciado entre letras","Line Height":"Altura de línea","Font Weight":"Grosor de fuente","Dyslexia Font":"Fuente para dislexia","Language":"Idioma","Open Accessibility Menu":"Abrir menú de accesibilidad"}'),
    fi: JSON.parse('{"Accessibility Menu":"Saavutettavuusvalikko","Reset settings":"Palauta asetukset","Close":"Sulje","Content Adjustments":"Sisällön säädöt","Adjust Font Size":"Säädä fonttikokoa","Highlight Title":"Korosta otsikko","Highlight Links":"Korosta linkit","Readable Font":"Helposti luettava fontti","Color Adjustments":"Värien säädöt","Dark Contrast":"Tumma kontrasti","Light Contrast":"Vaalea kontrasti","High Contrast":"Korkea kontrasti","High Saturation":"Korkea kylläisyys","Low Saturation":"Matala kylläisyys","Monochrome":"Yksivärinen","Tools":"Työkalut","Reading Guide":"Lukemisopas","Stop Animations":"Pysäytä animaatiot","Big Cursor":"Iso kohdistin","Increase Font Size":"Suurenna fonttikokoa","Decrease Font Size":"Pienennä fonttikokoa","Letter Spacing":"Kirjainten välistys","Line Height":"Rivin korkeus","Font Weight":"Fontin paksuus","Dyslexia Font":"Dysleksiafontti","Language":"Kieli","Open Accessibility Menu":"Avaa saavutettavuusvalikko"}'),
    fr: JSON.parse('{"Accessibility Menu":"Menu d\'accessibilité","Reset settings":"Réinitialiser les paramètres","Close":"Fermer","Content Adjustments":"Ajustements de contenu","Adjust Font Size":"Ajuster la taille de police","Highlight Title":"Surligner le titre","Highlight Links":"Surligner les liens","Readable Font":"Police lisible","Color Adjustments":"Ajustements de couleur","Dark Contrast":"Contraste foncé","Light Contrast":"Contraste clair","High Contrast":"Contraste élevé","High Saturation":"Saturation élevée","Low Saturation":"Saturation faible","Monochrome":"Monochrome","Tools":"Outils","Reading Guide":"Guide de lecture","Stop Animations":"Arrêter les animations","Big Cursor":"Gros curseur","Increase Font Size":"Augmenter la taille de police","Decrease Font Size":"Réduire la taille de police","Letter Spacing":"Espacement des lettres","Line Height":"Hauteur de ligne","Font Weight":"Poids de la police","Dyslexia Font":"Police dyslexie","Language":"Langue","Open Accessibility Menu":"Ouvrir le menu d\'accessibilité"}'),
    he: JSON.parse('{"Accessibility Menu":"תפריט נגישות","Reset settings":"איפוס הגדרות","Close":"סגור","Content Adjustments":"התאמות תוכן","Adjust Font Size":"התאם גודל פונט","Highlight Title":"הדגש כותרת","Highlight Links":"הדגש קישורים","Readable Font":"פונט קריא","Color Adjustments":"התאמות צבע","Dark Contrast":"ניגודיות כהה","Light Contrast":"ניגודיות בהירה","High Contrast":"ניגודיות גבוהה","High Saturation":"רווי צבע גבוה","Low Saturation":"רווי צבע נמוך","Monochrome":"מונוכרום","Tools":"כלים","Reading Guide":"מדריך קריאה","Stop Animations":"עצירת אנימציות","Big Cursor":"סמן גדול","Increase Font Size":"הגדל גודל פונט","Decrease Font Size":"הקטן גודל פונט","Letter Spacing":"מרווח בין אותיות","Line Height":"גובה שורה","Font Weight":"משקל הפונט","Dyslexia Font":"פונט לדיסלקטים","Language":"שפה","Open Accessibility Menu":"פתח תפריט נגישות"}'),
    hi: JSON.parse('{"Accessibility Menu":"पहुँचियोग्यता मेनू","Reset settings":"सेटिंग रीसेट करें","Close":"बंद करें","Content Adjustments":"सामग्री समायोजन","Adjust Font Size":"फ़ॉन्ट आकार समायोजित करें","Highlight Title":"शीर्षक को हाइलाइट करें","Highlight Links":"लिंक को हाइलाइट करें","Readable Font":"पढ़ने योग्य फ़ॉन्ट","Color Adjustments":"रंग समायोजन","Dark Contrast":"अंधेरा विरोध","Light Contrast":"प्रकाश विरोध","High Contrast":"उच्च विरोध","High Saturation":"उच्च संतुलन","Low Saturation":"निम्न संतुलन","Monochrome":"एकरंग","Tools":"उपकरण","Reading Guide":"पढ़ने का गाइड","Stop Animations":"एनिमेशन रोकें","Big Cursor":"बड़ा कर्सर","Increase Font Size":"फ़ॉन्ट आकार बढ़ाएँ","Decrease Font Size":"फ़ॉन्ट आकार कम करें","Letter Spacing":"अक्षर स्पेसिंग","Line Height":"लाइन की ऊँचाई","Font Weight":"फ़ॉन्ट वेट","Dyslexia Font":"विविधताजनित विपथता फ़ॉन्ट","Language":"भाषा","Open Accessibility Menu":"एक्सेसिबिलिटी मेनू खोलें"}'),
    hr: JSON.parse('{"Accessibility Menu":"Izbornik Pristupačnosti","Reset settings":"Resetiraj postavke","Close":"Zatvori","Content Adjustments":"Prilagodbe Sadržaja","Adjust Font Size":"Prilagodi Veličinu Fonta","Highlight Title":"Istakni Naslove","Highlight Links":"Istakni Poveznice","Readable Font":"Čitljiv Font","Color Adjustments":"Prilagodbe Boja","Dark Contrast":"Tamni Kontrast","Light Contrast":"Svijetli Kontrast","High Contrast":"Visoki Kontrast","High Saturation":"Visoka Zasićenost","Low Saturation":"Niska Zasićenost","Monochrome":"Jednobojno","Tools":"Alati","Reading Guide":"Vodič Za Čitanje","Stop Animations":"Zaustavi Animacije","Big Cursor":"Veliki Kursor","Increase Font Size":"Povećaj Veličinu Fonta","Decrease Font Size":"Smanji Veličinu Fonta","Letter Spacing":"Razmak Između Slova","Line Height":"Visina Linije","Font Weight":"Debljina Fonta","Dyslexia Font":"Font Za Disleksiju","Language":"Jezik","Open Accessibility Menu":"Otvori Izbornik Pristupačnosti"}'),
    hu: JSON.parse('{"Accessibility Menu":"Hozzáférhetőségi menü","Reset settings":"Beállítások visszaállítása","Close":"Bezárás","Content Adjustments":"Tartalom beállításai","Adjust Font Size":"Betűméret beállítása","Highlight Title":"Cím kiemelése","Highlight Links":"Linkek kiemelése","Readable Font":"Olvasható betűtípus","Color Adjustments":"Színbeállítások","Dark Contrast":"Sötét kontraszt","Light Contrast":"Világos kontraszt","High Contrast":"Magas kontraszt","High Saturation":"Magas telítettség","Low Saturation":"Alacsony telítettség","Monochrome":"Monokróm","Tools":"Eszközök","Reading Guide":"Olvasási útmutató","Stop Animations":"Animációk leállítása","Big Cursor":"Nagy kurzor","Increase Font Size":"Betűméret növelése","Decrease Font Size":"Betűméret csökkentése","Letter Spacing":"Betűtávolság","Line Height":"Sor magasság","Font Weight":"Betűtípus vastagsága","Dyslexia Font":"Dyslexia betűtípus","Language":"Nyelv","Open Accessibility Menu":"Hozzáférhetőségi menü megnyitása"}'),
    id: JSON.parse('{"Accessibility Menu":"Menu Aksesibilitas","Reset settings":"Atur Ulang Pengaturan","Close":"Tutup","Content Adjustments":"Penyesuaian Konten","Adjust Font Size":"Sesuaikan Ukuran Font","Highlight Title":"Sorot Judul","Highlight Links":"Sorot Tautan","Readable Font":"Font Mudah Dibaca","Color Adjustments":"Penyesuaian Warna","Dark Contrast":"Kontras Gelap","Light Contrast":"Kontras Terang","High Contrast":"Kontras Tinggi","High Saturation":"Saturasi Tinggi","Low Saturation":"Saturasi Rendah","Monochrome":"Monokrom","Tools":"Alat","Reading Guide":"Panduan Membaca","Stop Animations":"Hentikan Animasi","Big Cursor":"Kursor Besar","Increase Font Size":"Perbesar Ukuran Font","Decrease Font Size":"Perkecil Ukuran Font","Letter Spacing":"Jarak Huruf","Line Height":"Tinggi Baris","Font Weight":"Ketebalan Font","Dyslexia Font":"Font Disleksia","Language":"Bahasa","Open Accessibility Menu":"Buka menu aksesibilitas"}'),
    it: JSON.parse('{"Accessibility Menu":"Menu di accessibilità","Reset settings":"Ripristina impostazioni","Close":"Chiudi","Content Adjustments":"Regolazioni del contenuto","Adjust Font Size":"Regola la dimensione del carattere","Highlight Title":"Evidenzia il titolo","Highlight Links":"Evidenzia i collegamenti","Readable Font":"Carattere leggibile","Color Adjustments":"Regolazioni del colore","Dark Contrast":"Contrasto scuro","Light Contrast":"Contrasto chiaro","High Contrast":"Alto contrasto","High Saturation":"Alta saturazione","Low Saturation":"Bassa saturazione","Monochrome":"Monocromatico","Tools":"Strumenti","Reading Guide":"Guida alla lettura","Stop Animations":"Arresta le animazioni","Big Cursor":"Cursore grande","Increase Font Size":"Aumenta la dimensione del carattere","Decrease Font Size":"Diminuisci la dimensione del carattere","Letter Spacing":"Spaziatura delle lettere","Line Height":"Altezza della linea","Font Weight":"Peso del carattere","Dyslexia Font":"Carattere per dislessia","Language":"Lingua","Open Accessibility Menu":"Apri il menu di accessibilità"}'),
    ja: JSON.parse('{"Accessibility Menu":"アクセシビリティメニュー","Reset settings":"設定をリセット","Close":"閉じる","Content Adjustments":"コンテンツ調整","Adjust Font Size":"フォントサイズを調整","Highlight Title":"タイトルを強調表示","Highlight Links":"リンクを強調表示","Readable Font":"読みやすいフォント","Color Adjustments":"色の調整","Dark Contrast":"ダークコントラスト","Light Contrast":"ライトコントラスト","High Contrast":"高いコントラスト","High Saturation":"彩度が高い","Low Saturation":"彩度が低い","Monochrome":"モノクローム","Tools":"ツール","Reading Guide":"読み上げガイド","Stop Animations":"アニメーションを停止","Big Cursor":"大きなカーソル","Increase Font Size":"フォントサイズを大きくする","Decrease Font Size":"フォントサイズを小さくする","Letter Spacing":"文字間隔","Line Height":"行の高さ","Font Weight":"フォントの太さ","Dyslexia Font":"ディスレクシア用フォント","Language":"言語","Open Accessibility Menu":"アクセシビリティメニューを開く"}'),
    ka: JSON.parse('{"Accessibility Menu":"ადაპტირებული მენიუ","Reset settings":"პარამეტრების დაბრუნება","Close":"დახურვა","Content Adjustments":"შიგთავსის მორგება","Adjust Font Size":"ფონტის ზომის მორგება","Highlight Title":"სათაურების გამოყოფა","Highlight Links":"ბმულების გამოყოფა","Readable Font":"წაკითხვადი ტექსტები","Color Adjustments":"ფერების მორგება","Dark Contrast":"ბნელი ელფერი","Light Contrast":"ნათელი ელფერი","High Contrast":"მაღალი ელფერი","High Saturation":"მაღალი გაჯერება","Low Saturation":"დაბალი გაჯერება","Monochrome":"ერთფეროვანი გამოსახულება","Tools":"ხელსაწყოები","Reading Guide":"კითხვის გამყოლი ზოლი","Stop Animations":"ანიმაციების გაჩერება","Big Cursor":"დიდი კურსორი","Increase Font Size":"ფონტის ზომის გაზრდა","Decrease Font Size":"ფონტის ზომის შემცირება","Letter Spacing":"ასოებს შორის დაშორება","Line Height":"ხაზის სიმაღლე","Font Weight":"ფონტის წონა","Dyslexia Font":"დისლექსიური ფონტი","Language":"ენა","Open Accessibility Menu":"გახსენი ადაპტირებული მენიუ"}'),
    ko: JSON.parse('{"Accessibility Menu":"접근성 메뉴","Reset settings":"설정 초기화","Close":"닫기","Content Adjustments":"컨텐츠 조정","Adjust Font Size":"글꼴 크기 조정","Highlight Title":"제목 강조","Highlight Links":"링크 강조","Readable Font":"읽기 쉬운 글꼴","Color Adjustments":"색상 조정","Dark Contrast":"어두운 대비","Light Contrast":"밝은 대비","High Contrast":"높은 대비","High Saturation":"높은 채도","Low Saturation":"낮은 채도","Monochrome":"단색","Tools":"도구","Reading Guide":"읽기 가이드","Stop Animations":"애니메이션 중지","Big Cursor":"큰 커서","Increase Font Size":"글꼴 크기 증가","Decrease Font Size":"글꼴 크기 감소","Letter Spacing":"자간","Line Height":"줄 간격","Font Weight":"글꼴 두께","Dyslexia Font":"난독증 글꼴","Language":"언어","Open Accessibility Menu":"접근성 메뉴 열기"}'),
    ms: JSON.parse('{"Accessibility Menu":"Menu Aksesibiliti","Reset settings":"Tetapkan semula tetapan","Close":"Tutup","Content Adjustments":"Penyesuaian Kandungan","Adjust Font Size":"Laraskan Saiz Fon","Highlight Title":"Serlahkan Tajuk","Highlight Links":"Serlahkan Pautan","Readable Font":"Fon Mudah Baca","Color Adjustments":"Penyesuaian Warna","Dark Contrast":"Kontras Gelap","Light Contrast":"Kontras Terang","High Contrast":"Kontras Tinggi","High Saturation":"Saturasi Tinggi","Low Saturation":"Saturasi Rendah","Monochrome":"Monokrom","Tools":"Peralatan","Reading Guide":"Panduan Membaca","Stop Animations":"Hentikan Animasi","Big Cursor":"Kursor Besar","Increase Font Size":"Besarkan Saiz Fon","Decrease Font Size":"Kecilkan Saiz Fon","Letter Spacing":"Ruangan Huruf","Line Height":"Ketinggian Garis","Font Weight":"Ketebalan Fon","Dyslexia Font":"Fon Dyslexia","Language":"Bahasa","Open Accessibility Menu":"Buka menu kebolehcapaian"}'),
    nl: JSON.parse('{"Accessibility Menu":"Toegankelijkheidsmenu","Reset settings":"Instellingen resetten","Close":"Sluiten","Content Adjustments":"Inhoudsaanpassingen","Adjust Font Size":"Lettergrootte aanpassen","Highlight Title":"Titel markeren","Highlight Links":"Links markeren","Readable Font":"Leesbaar lettertype","Color Adjustments":"Kleur aanpassingen","Dark Contrast":"Donker contrast","Light Contrast":"Licht contrast","High Contrast":"Hoog contrast","High Saturation":"Hoge verzadiging","Low Saturation":"Lage verzadiging","Monochrome":"Monochroom","Tools":"Gereedschappen","Reading Guide":"Leesgids","Stop Animations":"Animaties stoppen","Big Cursor":"Grote cursor","Increase Font Size":"Lettergrootte vergroten","Decrease Font Size":"Lettergrootte verkleinen","Letter Spacing":"Letterafstand","Line Height":"Regelhoogte","Font Weight":"Letterdikte","Dyslexia Font":"Dyslexie lettertype","Language":"Taal","Open Accessibility Menu":"Toegankelijkheidsmenu openen"}'),
    no: JSON.parse('{"Accessibility Menu":"Tilgjengelighetsmeny","Reset settings":"Tilbakestill innstillinger","Close":"Lukk","Content Adjustments":"Innholdstilpasninger","Adjust Font Size":"Juster skriftstørrelse","Highlight Title":"Fremhev tittel","Highlight Links":"Fremhev lenker","Readable Font":"Lesbar skrifttype","Color Adjustments":"Fargejusteringer","Dark Contrast":"Mørk kontrast","Light Contrast":"Lys kontrast","High Contrast":"Høy kontrast","High Saturation":"Høy metning","Low Saturation":"Lav metning","Monochrome":"Monokrom","Tools":"Verktøy","Reading Guide":"Leseguide","Stop Animations":"Stopp animasjoner","Big Cursor":"Stor peker","Increase Font Size":"Øk skriftstørrelsen","Decrease Font Size":"Reduser skriftstørrelsen","Letter Spacing":"Bokstavavstand","Line Height":"Linjehøyde","Font Weight":"Skriftvekt","Dyslexia Font":"Dysleksisk skrifttype","Language":"Språk","Open Accessibility Menu":"Åpne tilgjengelighetsmeny"}'),
    fa: JSON.parse('{"Accessibility Menu":"منوی دسترسی","Reset settings":"بازنشانی تنظیمات","Close":"بستن","Content Adjustments":"تنظیمات محتوا","Adjust Font Size":"تنظیم اندازه فونت","Highlight Title":"برجسته کردن عنوان","Highlight Links":"برجسته کردن لینک‌ها","Readable Font":"فونت خوانا","Color Adjustments":"تنظیمات رنگ","Dark Contrast":"کنتراست تاریک","Light Contrast":"کنتراست روشن","High Contrast":"کنتراست بالا","High Saturation":"اشباع بالا","Low Saturation":"اشباع پایین","Monochrome":"تک‌رنگ","Tools":"ابزارها","Reading Guide":"راهنمای خواندن","Stop Animations":"توقف انیمیشن‌ها","Big Cursor":"مؤشر بزرگ","Increase Font Size":"افزایش اندازه فونت","Decrease Font Size":"کاهش اندازه فونت","Letter Spacing":"فاصله بین حروف","Line Height":"ارتفاع خط","Font Weight":"وزن فونت","Dyslexia Font":"فونت دیسلکسیا","Language":"زبان","Open Accessibility Menu":"بازکردن منوی دسترسی"}'),
    pl: JSON.parse('{"Accessibility Menu":"Menu dostępności","Reset settings":"Reset ustawień","Close":"Zamknij","Content Adjustments":"Dostosowanie zawartości","Adjust Font Size":"Dostosuj rozmiar czcionki","Highlight Title":"Podświetl tytuły","Highlight Links":"Podświetl linki","Readable Font":"Czytelna czcionka","Color Adjustments":"Dostosowanie kolorów","Dark Contrast":"Ciemny kontrast","Light Contrast":"Jasny kontrast","High Contrast":"Wysoki kontrast","High Saturation":"Wysoka saturacja","Low Saturation":"Niska saturacja","Monochrome":"Monochromatyczność","Tools":"Narzędzia","Reading Guide":"Pomocnik czytania","Stop Animations":"Wstrzymaj animacje","Big Cursor":"Duży kursor","Increase Font Size":"Zwiększ rozmiar czcionki","Decrease Font Size":"Zmniejsz rozmiar czcionki","Letter Spacing":"Odstępy między literami","Line Height":"Wysokość wierszy","Font Weight":"Pogrubiona czcionka","Dyslexia Font":"Czcionka dla dyslektyków","Language":"Język","Open Accessibility Menu":"Otwórz menu dostępności"}'),
    pt: JSON.parse('{"Accessibility Menu":"Menu de Acessibilidade","Reset settings":"Redefinir configurações","Close":"Fechar","Content Adjustments":"Ajustes de Conteúdo","Adjust Font Size":"Ajustar Tamanho da Fonte","Highlight Title":"Destacar Título","Highlight Links":"Destacar Links","Readable Font":"Fonte Legível","Color Adjustments":"Ajustes de Cor","Dark Contrast":"Contraste Escuro","Light Contrast":"Contraste Claro","High Contrast":"Alto Contraste","High Saturation":"Saturação Alta","Low Saturation":"Saturação Baixa","Monochrome":"Monocromático","Tools":"Ferramentas","Reading Guide":"Guia de Leitura","Stop Animations":"Parar Animações","Big Cursor":"Cursor Grande","Increase Font Size":"Aumentar Tamanho da Fonte","Decrease Font Size":"Diminuir Tamanho da Fonte","Letter Spacing":"Espaçamento entre Letras","Line Height":"Altura da Linha","Font Weight":"Espessura da Fonte","Dyslexia Font":"Fonte para Dislexia","Language":"Idioma","Open Accessibility Menu":"Abrir menu de acessibilidade"}'),
    ro: JSON.parse('{"Accessibility Menu":"Meniu de accesibilitate","Reset settings":"Resetează setările","Close":"Închide","Content Adjustments":"Ajustări conținut","Adjust Font Size":"Ajustează dimensiunea fontului","Highlight Title":"Evidențiază titlul","Highlight Links":"Evidențiază legăturile","Readable Font":"Font lizibil","Color Adjustments":"Ajustări de culoare","Dark Contrast":"Contrast întunecat","Light Contrast":"Contrast luminos","High Contrast":"Contrast ridicat","High Saturation":"Saturație ridicată","Low Saturation":"Saturație redusă","Monochrome":"Monocrom","Tools":"Instrumente","Reading Guide":"Ghid de lectură","Stop Animations":"Opriți animațiile","Big Cursor":"Cursor mare","Increase Font Size":"Mărește dimensiunea fontului","Decrease Font Size":"Micșorează dimensiunea fontului","Letter Spacing":"Spațierea literelor","Line Height":"Înălțimea liniei","Font Weight":"Grosimea fontului","Dyslexia Font":"Font pentru dislexie","Language":"Limbă","Open Accessibility Menu":"Deschideți meniul de accesibilitate"}'),
    ru: JSON.parse('{"Accessibility Menu":"Меню специальных возможностей","Reset settings":"Сброс настроек","Close":"Закрыть","Content Adjustments":"Корректировка контента","Adjust Font Size":"Настройка размера шрифта","Highlight Title":"Выделить заголовки","Highlight Links":"Выделить ссылки","Readable Font":"Читаемый шрифт","Color Adjustments":"Коррекция цвета","Dark Contrast":"Темный контраст","Light Contrast":"Светлый контраст","High Contrast":"Высокий контраст","High Saturation":"Высокая насыщенность","Low Saturation":"Низкая насыщенность","Monochrome":"Монохромный цвет","Tools":"Инструменты","Reading Guide":"Руководство по чтению","Stop Animations":"Остановить анимацию","Big Cursor":"Большой курсор","Increase Font Size":"Увеличить размер шрифта","Decrease Font Size":"Уменьшить размер шрифта","Letter Spacing":"Межбуквенное расстояние","Line Height":"Высота линии","Font Weight":"Вес шрифта","Dyslexia Font":"Шрифт Дислексия","Language":"Язык","Open Accessibility Menu":"Открыть меню специальных возможностей"}'),
    sk: JSON.parse('{"Accessibility Menu":"Menu prístupnosti","Reset settings":"Obnoviť nastavenia","Close":"Zavrieť","Content Adjustments":"Nastavenia obsahu","Adjust Font Size":"Prispôsobiť veľkosť písma","Highlight Title":"Zvýrazniť nadpis","Highlight Links":"Zvýrazniť odkazy","Readable Font":"Čitateľné písmo","Color Adjustments":"Nastavenia farieb","Dark Contrast":"Tmavý kontrast","Light Contrast":"Svetlý kontrast","High Contrast":"Vysoký kontrast","High Saturation":"Vysoká saturácia","Low Saturation":"Nízka saturácia","Monochrome":"Monochromatické","Tools":"Nástroje","Reading Guide":"Sprievodca čítaním","Stop Animations":"Zastaviť animácie","Big Cursor":"Veľký kurzor","Increase Font Size":"Zväčšiť veľkosť písma","Decrease Font Size":"Zmenšiť veľkosť písma","Letter Spacing":"Rozostup písmen","Line Height":"Výška riadku","Font Weight":"Tlak písma","Dyslexia Font":"Písmo pre dyslexiu","Language":"Jazyk","Open Accessibility Menu":"Otvoriť menu prístupnosti"}'),
    sr: JSON.parse('{"Accessibility Menu":"Meni Za Pristupačnost","Reset settings":"Resetuj postavke","Close":"Zatvori","Content Adjustments":"Podešavanje Sadržaja","Adjust Font Size":"Podešavanje Veličine Fonta","Highlight Title":"Označi Naslove","Highlight Links":"Označi Veze","Readable Font":"Čitljiviji Font","Color Adjustments":"Podešavanje Boja","Dark Contrast":"Tamni Kontrast","Light Contrast":"Svijetli Kontrast","High Contrast":"Visoki Kontrast","High Saturation":"Velika Zasićenost","Low Saturation":"Niska Zasićenost","Monochrome":"Jednobojni","Tools":"Alati","Reading Guide":"Vodič Za Čitanje","Stop Animations":"Zaustavi Animacije","Big Cursor":"Veliki Kursor","Increase Font Size":"Povećaj Veličinu Fonta","Decrease Font Size":"Smanji Veličinu Fonta","Letter Spacing":"Razmak Slova","Line Height":"Visina Linije","Font Weight":"Debljina Fonta","Dyslexia Font":"Font Za Disleksičare","Language":"Jezik","Open Accessibility Menu":"Otvori Meni Za Pristupačnost"}'),
    'sr-SP': JSON.parse('{"Accessibility Menu":"Мени За Приступачност","Reset settings":"Ресетуј поставке","Close":"Затвори","Content Adjustments":"Подешавање Садржаја","Adjust Font Size":"Подешавање Величине Фонта","Highlight Title":"Означи Наслове","Highlight Links":"Означи Везе","Readable Font":"Читљивији Фонт","Color Adjustments":"Подешавање Боја","Dark Contrast":"Тамни Контраст","Light Contrast":"Свијетли Контраст","High Contrast":"Високи Контраст","High Saturation":"Велика Засићеност","Low Saturation":"Ниска Засићеност","Monochrome":"Једнобојни","Tools":"Алати","Reading Guide":"Водич За Читање","Stop Animations":"Заустави Анимације","Big Cursor":"Велики Курсор","Increase Font Size":"Повећај Величину Фонта","Decrease Font Size":"Смањи Величину Фонта","Letter Spacing":"Размак Слова","Line Height":"Висина Линије","Font Weight":"Дебљина Фонта","Dyslexia Font":"Фонт За Дислексичаре","Language":"Језик","Open Accessibility Menu":"Отвори Мени За Приступачност"}'),
    sv: JSON.parse('{"Accessibility Menu":"Tillgänglighetsmeny","Reset settings":"Nollställ inställningar","Close":"Stäng","Content Adjustments":"Anpassa innehåll","Adjust Font Size":"Justera textstorlek","Highlight Title":"Framhäv titel","Highlight Links":"Framhäv länkar","Readable Font":"Läsbart teckensnitt","Color Adjustments":"Anpassa färger","Dark Contrast":"Mörk kontrast","Light Contrast":"Ljus kontrast","High Contrast":"Hög kontrast","High Saturation":"Hög mättnad","Low Saturation":"Låg mättnad","Monochrome":"Monokrom","Tools":"Verktyg","Reading Guide":"Läslinjal","Stop Animations":"Hindra animationer","Big Cursor":"Stor muspekare","Increase Font Size":"Öka textstorlek","Decrease Font Size":"Minska textstorlek","Letter Spacing":"Teckenavstånd","Line Height":"Radhöjd","Font Weight":"Teckensnitt tjocklek","Dyslexia Font":"Dyslektiskt teckensnitt","Language":"Språk","Open Accessibility Menu":"Öppna tillgänglighetsmeny"}'),
    ta: JSON.parse('{"Accessibility Menu":"Menu ng Accessibility","Reset settings":"I-reset ang mga setting","Close":"Isara","Content Adjustments":"Ayusin ang Nilalaman","Adjust Font Size":"I-adjust ang Laki ng Font","Highlight Title":"I-highlight ang Pamagat","Highlight Links":"I-highlight ang mga Link","Readable Font":"Madaling Basahing Font","Color Adjustments":"Ayusin ang Kulay","Dark Contrast":"Madilim na Pagkakaiba","Light Contrast":"Maliwanag na Pagkakaiba","High Contrast":"Mataas na Pagkakaiba","High Saturation":"Mataas na Saturation","Low Saturation":"Mababang Saturation","Monochrome":"Monokrom","Tools":"Mga Kasangkapan","Reading Guide":"Gabay sa Pagbabasa","Stop Animations":"Itigil ang Mga Animasyon","Big Cursor":"Malaking Cursor","Increase Font Size":"Palakihin ang Laki ng Font","Decrease Font Size":"Bawasan ang Laki ng Font","Letter Spacing":"Espasyo ng mga Titik","Line Height":"Taas ng Linya","Font Weight":"Bigat ng Font","Dyslexia Font":"Font para sa Dyslexia","Language":"Wika","Open Accessibility Menu":"Buksan ang Menu ng Accessibility"}'),
    th: JSON.parse('{"Accessibility Menu":"เมนูการช่วยการเข้าถึง","Reset settings":"รีเซ็ตการตั้งค่า","Close":"ปิด","Content Adjustments":"การปรับเนื้อหา","Adjust Font Size":"ปรับขนาดตัวอักษร","Highlight Title":"เน้นหัวเรื่อง","Highlight Links":"เน้นลิงก์","Readable Font":"แบบอักษรที่อ่านง่าย","Color Adjustments":"การปรับสี","Dark Contrast":"ความเปรียบต่างเข้ม","Light Contrast":"ความเปรียบต่างสว่าง","High Contrast":"ความเปรียบต่างสูง","High Saturation":"ความอิ่มตัวของสีสูง","Low Saturation":"ความอิ่มตัวของสีต่ำ","Monochrome":"โมโนโครม","Tools":"เครื่องมือ","Reading Guide":"คู่มือการอ่าน","Stop Animations":"หยุดการเคลื่อนไหว","Big Cursor":"เคอร์เซอร์ขนาดใหญ่","Increase Font Size":"เพิ่มขนาดตัวอักษร","Decrease Font Size":"ลดขนาดตัวอักษร","Letter Spacing":"ระยะห่างระหว่างตัวอักษร","Line Height":"ความสูงของบรรทัด","Font Weight":"น้ำหนักตัวอักษร","Dyslexia Font":"แบบอักษรสำหรับดิสเล็กเซีย","Language":"ภาษา","Open Accessibility Menu":"เปิดเมนูการช่วยการเข้าถึง"}'),
    tr: JSON.parse('{"Accessibility Menu":"Erişilebilirlik Menüsü","Reset settings":"Ayarları Sıfırla","Close":"Kapat","Content Adjustments":"İçerik Ayarları","Adjust Font Size":"Yazı Tipi Boyutunu Ayarla","Highlight Title":"Başlığı Vurgula","Highlight Links":"Bağlantıları Vurgula","Readable Font":"Okunaklı Yazı Tipi","Color Adjustments":"Renk Ayarları","Dark Contrast":"Koyu Kontrast","Light Contrast":"Açık Kontrast","High Contrast":"Yüksek Kontrast","High Saturation":"Yüksek Doygunluk","Low Saturation":"Düşük Doygunluk","Monochrome":"Tek Renkli","Tools":"Araçlar","Reading Guide":"Okuma Rehberi","Stop Animations":"Animasyonları Durdur","Big Cursor":"Büyük İmleç","Increase Font Size":"Yazı Tipi Boyutunu Artır","Decrease Font Size":"Yazı Tipi Boyutunu Azalt","Letter Spacing":"Harf Aralığı","Line Height":"Satır Yüksekliği","Font Weight":"Yazı Tipi Kalınlığı","Dyslexia Font":"Disleksi Yazı Tipi","Language":"Dil","Open Accessibility Menu":"Erişilebilirlik menüsünü aç"}'),
    zh_Hans: JSON.parse('{"Accessibility Menu":"辅助功能菜单","Reset settings":"重置设置","Close":"关闭","Content Adjustments":"内容调整","Adjust Font Size":"调整字体大小","Highlight Title":"标题高亮","Highlight Links":"链接高亮","Readable Font":"易读字体","Color Adjustments":"色彩调整","Dark Contrast":"高对比度（黑色）","Light Contrast":"高对比度（白色）","High Contrast":"高对比度","High Saturation":"高饱和度","Low Saturation":"低饱和度","Monochrome":"单色","Tools":"工具","Reading Guide":"阅读指南","Stop Animations":"停止动画","Big Cursor":"大光标","Increase Font Size":"增加字体大小","Decrease Font Size":"减小字体大小","Letter Spacing":"字母间距","Line Height":"行距","Font Weight":"字重","Dyslexia Font":"阅读障碍字体","Language":"语言","Open Accessibility Menu":"打开辅助功能菜单"}'),
    zh_Hant: JSON.parse('{"Accessibility Menu":"輔助功能菜單","Reset settings":"重置設定","Close":"關閉","Content Adjustments":"內容調整","Adjust Font Size":"調整字體大小","Highlight Title":"標題高亮","Highlight Links":"連結高亮","Readable Font":"易讀字體","Color Adjustments":"色彩調整","Dark Contrast":"高對比度（黑色）","Light Contrast":"高對比度（白色）","High Contrast":"高對比度","High Saturation":"高飽和度","Low Saturation":"低飽和度","Monochrome":"單色","Tools":"工具","Reading Guide":"閱讀指南","Stop Animations":"停止動畫","Big Cursor":"大光標","Increase Font Size":"增加字體大小","Decrease Font Size":"減小字體大小","Letter Spacing":"字母間距","Line Height":"行距","Font Weight":"字重","Dyslexia Font":"閱讀障礙字體","Language":"語言","Open Accessibility Menu":"打開輔助功能菜單"}'),
    vi: JSON.parse('{"Accessibility Menu":"Menu Truy cập","Reset settings":"Đặt lại cài đặt","Close":"Đóng","Content Adjustments":"Điều chỉnh Nội dung","Adjust Font Size":"Điều chỉnh Kích thước Font chữ","Highlight Title":"Đánh dấu Tiêu đề","Highlight Links":"Đánh dấu Liên kết","Readable Font":"Font chữ Dễ đọc","Color Adjustments":"Điều chỉnh Màu sắc","Dark Contrast":"Tương phản Tối","Light Contrast":"Tương phản Sáng","High Contrast":"Tương phản Cao","High Saturation":"Bão hòa Cao","Low Saturation":"Bão hòa Thấp","Monochrome":"Đơn sắc","Tools":"Công cụ","Reading Guide":"Hướng dẫn Đọc","Stop Animations":"Dừng Hoạt hình","Big Cursor":"Con trỏ Lớn","Increase Font Size":"Tăng Kích thước Font chữ","Decrease Font Size":"Giảm Kích thước Font chữ","Letter Spacing":"Khoảng cách Chữ","Line Height":"Độ Cao dòng","Font Weight":"Độ Đậm của Font chữ","Dyslexia Font":"Font chữ Cho người có Khuyết tật đọc hiểu","Language":"Ngôn ngữ","Open Accessibility Menu":"Mở Menu Truy cập"}')
  }, _ = [
    {code: 'ar', label: 'العربية (Arabic)'},
    {code: 'bg', label: 'български (Bulgarian)'},
    {code: 'bn', label: 'বাংলা (Bengali)'},
    {code: 'cs', label: 'čeština (Czech)'},
    {code: 'da', label: 'Danish (Denmark)'},
    {code: 'de', label: 'Deutsch (German)'},
    {code: 'el', label: 'Ελληνικά (Greek)'},
    {code: 'en', label: 'English (English)'},
    {code: 'es', label: 'Español (Spanish)'},
    {code: 'fi', label: 'suomi (Finnish)'},
    {code: 'fr', label: 'Français (French)'},
    {code: 'he', label: 'עברית (Hebrew)'},
    {code: 'hi', label: 'हिन्दी (Hindi)'},
    {code: 'hr', label: 'Hrvatski (Croatian)'},
    {code: 'hu', label: 'Magyar (Hungarian)'},
    {code: 'id', label: 'Bahasa Indonesia (Indonesian)'},
    {code: 'it', label: 'Italiano (Italian)'},
    {code: 'ja', label: '日本語 (Japanese)'},
    {code: 'ka', label: 'ქართული (Georgian)'},
    {code: 'ko', label: '한국어 (Korean)'},
    {code: 'ms', label: 'Bahasa Malaysia (Malay)'},
    {code: 'nl', label: 'Nederlands (Dutch)'},
    {code: 'no', label: 'Norsk (Norwegian)'},
    {code: 'fa', label: 'فارسی (Persian)'},
    {code: 'pl', label: 'Polski (Polish)'},
    {code: 'pt', label: 'Português (Portuguese)'},
    {code: 'ro', label: 'Română (Romanian)'},
    {code: 'ru', label: 'Русский (Russian)'},
    {code: 'sk', label: 'slovenčina (Slovak)'},
    {code: 'sr', label: 'Srpski (Serbian)'},
    {code: 'sr-SP', label: 'Српски (Serbian Cyrillic)'},
    {code: 'sv', label: 'Svenska (Swedish)'},
    {code: 'ta', label: 'Tagalog (Filipno)'},
    {code: 'th', label: 'ไทย (Thai)'},
    {code: 'tr', label: 'Türkçe (Turkish)'},
    {code: 'zh_Hans', label: '繁体中文 (Simplified Chinese)'},
    {code: 'zh_Hant', label: '繁體中文 (Traditional Chinese)'},
    {code: 'vi', label: 'Tiếng Việt (Vietnamese)'}
  ];

  function q(t, e) {
    var n = t.getAttribute('data-translate');
    return !n && e && (n = e, t.setAttribute('data-translate', n)), function (t) {
      var e = s().lang;
      if (e === 'zh') {
        return (K['zh_Hans'] || K.en)[t] || t;
      }
      return (K[e] || K.en)[t] || t;
    }(n);
  }

  function U(t) {
    t.querySelectorAll('.asw-card-title, .asw-translate').forEach((function (t) {
      t.innerText = q(t, String(t.innerText || '').trim());
    })), t.querySelectorAll('[title]').forEach((function (t) {
      t.setAttribute('title', q(t, t.getAttribute('title')));
    }));
  }

  var Y = function (t, e) {
    var n = {};
    for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
    if (null != t && 'function' == typeof Object.getOwnPropertySymbols) {
      var a = 0;
      for (i = Object.getOwnPropertySymbols(t); a < i.length; a++) e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (n[i[a]] = t[i[a]]);
    }
    return n;
  };

  function Q(t) {
    var e, n, l, c, g = t.container, u = t.position, d = Y(t, ['container', 'position']),
      h = document.createElement('div');
    h.innerHTML = G;
    var p = h.querySelector('.asw-menu');
    (null == u ? void 0 : u.includes('right')) && (p.style.right = '0px', p.style.left = 'auto'), p.querySelector('.content').innerHTML = W(Z), p.querySelector('.tools').innerHTML = W(J, 'asw-tools'), p.querySelector('.contrast').innerHTML = W(E, 'asw-filter'), h.querySelectorAll('.asw-menu-close, .asw-overlay').forEach((function (t) {
      t.addEventListener('click', (function () {
        N(h, !1);
      }));
    })), p.querySelectorAll('.asw-adjust-font div[role=\'button\']').forEach((function (t) {
      t.addEventListener('click', (function () {
        var e, n = null !== (e = o('fontSize')) && void 0 !== e ? e : 1;
        t.classList.contains('asw-minus') ? n -= .1 : n += .1, n = Math.max(n, .1), n = Math.min(n, 2), r((n = Number(n.toFixed(2))) || 1), i({fontSize: n});
      }));
    })), p.querySelectorAll('.asw-btn').forEach((function (t) {
      t.addEventListener('click', (function () {
        var e, n = t.dataset.key, a = !t.classList.contains('asw-selected');
        t.classList.contains('asw-filter') ? (p.querySelectorAll('.asw-filter').forEach((function (t) {
          t.classList.remove('asw-selected');
        })), i({contrast: !!a && n}), a && t.classList.add('asw-selected'), w()) : (t.classList.toggle('asw-selected', a), i(((e = {})[n] = a, e)), P());
      }));
    })), null === (e = p.querySelector('.asw-menu-reset')) || void 0 === e || e.addEventListener('click', (function () {
      !function () {
        var t;
        a({states: {}}), I(), null === (t = null === document || void 0 === document ? void 0 : document.querySelectorAll('.asw-selected')) || void 0 === t || t.forEach((function (t) {
          var e;
          return null === (e = null == t ? void 0 : t.classList) || void 0 === e ? void 0 : e.remove('asw-selected');
        }));
      }();
    }));
    var m = s(), v = Number(null === (n = null == m ? void 0 : m.states) || void 0 === n ? void 0 : n.fontSize) || 1;
    1 != v && (p.querySelector('.asw-amount').innerHTML = ''.concat(100 * v, '%'));
    var b = p.querySelector('#asw-language');
    if (b.innerHTML = _.map((function (t) {
      return '<option value="'.concat(t.code, '">').concat(t.label, '</option>');
    })).join(''), m.lang !== d.lang && a({lang: d.lang}), b.value = (null == d ? void 0 : (d.lang === 'zh' ? 'zh_Hans' : d.lang)) || 'en', null == b || b.addEventListener('change', (function () {
      a({lang: b.value}), U(g);
    })), U(p), m.states) for (var S in m.states) if (m.states[S] && 'fontSize' !== S) {
      var f = 'contrast' === S ? m.states[S] : S;
      null === (c = null === (l = p.querySelector('.asw-btn[data-key="'.concat(f, '"]'))) || void 0 === l ? void 0 : l.classList) || void 0 === c || c.add('asw-selected');
    }
    return g.appendChild(h), h;
  }

  var X = function () {
    return X = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, X.apply(this, arguments);
  };
  var $ = function () {
    return $ = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) for (var a in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      return t;
    }, $.apply(this, arguments);
  }, tt = {lang: 'en', position: 'bottom-left', classes: ''};

  function et(t) {
    var e = $({}, tt);
    try {
      var n = s(!1);
      e = $($({}, e), n), I();
    } catch (t) {
    }
    a(e = $($({}, e), t)), function (t) {
      var e, n, i, a, o, s, r, l = t.position, c = void 0 === l ? 'bottom-left' : l, g = t.offset,
        u = void 0 === g ? [20, 20] : g, d = t.classes, h = void 0 === d ? '' : d, p = document.createElement('div');
      if (p.innerHTML = V, p.classList.add('asw-container'), h) {
        var m = h.split(' ');
        (e = p.classList).add.apply(e, m);
      }
      var v, b = p.querySelector('.asw-menu-btn'),
        S = null !== (n = null == u ? void 0 : u[0]) && void 0 !== n ? n : 20,
        w = null !== (i = null == u ? void 0 : u[1]) && void 0 !== i ? i : 25,
        f = {left: ''.concat(S, 'px'), bottom: ''.concat(w, 'px')};
      'bottom-right' === c ? f = X(X({}, f), {
        right: ''.concat(S, 'px'),
        left: 'auto'
      }) : 'top-left' === c ? f = X(X({}, f), {
        top: ''.concat(w, 'px'),
        bottom: 'auto'
      }) : 'center-left' === c ? f = X(X({}, f), {bottom: 'calc(50% - (55px / 2) - '.concat(null !== (a = null == u ? void 0 : u[1]) && void 0 !== a ? a : 0, 'px)')}) : 'top-right' === c ? f = {
        top: ''.concat(w, 'px'),
        bottom: 'auto',
        right: ''.concat(S, 'px'),
        left: 'auto'
      } : 'center-right' === c ? f = {
        right: ''.concat(S, 'px'),
        left: 'auto',
        bottom: 'calc(50% - (55px / 2) - '.concat(null !== (o = null == u ? void 0 : u[1]) && void 0 !== o ? o : 0, 'px)')
      } : 'bottom-center' === c ? f = X(X({}, f), {left: 'calc(50% - (55px / 2) - '.concat(null !== (s = null == u ? void 0 : u[0]) && void 0 !== s ? s : 0, 'px)')}) : 'top-center' === c && (f = {
        top: ''.concat(w, 'px'),
        bottom: 'auto',
        left: 'calc(50% - (55px / 2) - '.concat(null !== (r = null == u ? void 0 : u[0]) && void 0 !== r ? r : 0, 'px)')
      }), Object.assign(b.style, f), null == b || b.addEventListener('click', (function (e) {
        e.preventDefault(), v ? N(v) : v = Q(X(X({}, t), {container: p}));
      })), U(p), document.body.appendChild(p);
    }(e);
  }

  function nt(t) {
    var e;
    return t = 'data-asw-'.concat(t), null === (e = null === document || void 0 === document ? void 0 : document.querySelector('['.concat(t, ']'))) || void 0 === e ? void 0 : e.getAttribute(t);
  }

  document.addEventListener('readystatechange', (function t() {
    var e, n, i, a, o, s;
    'complete' !== document.readyState && 'interactive' !== document.readyState || (i = nt('lang'), a = nt('position'), o = nt('offset'), s = nt('classes'), i || (i = null === (n = null === (e = null === document || void 0 === document ? void 0 : document.querySelector('html')) || void 0 === e ? void 0 : e.getAttribute('lang')) || void 0 === n ? void 0 : n.replace(/[_-].*/, '')), !i && 'undefined' != typeof navigator && (null === navigator || void 0 === navigator ? void 0 : navigator.language) && (i = null === navigator || void 0 === navigator ? void 0 : navigator.language), o && (o = o.split(',').map((function (t) {
      return parseInt(t);
    }))), et({lang: i, position: a, offset: o, classes: s}), document.removeEventListener('readystatechange', t));
  }));
})();
},{}],42:[function(require,module,exports){
/*!
 * Splide.js
 * Version  : 2.4.20
 * License  : MIT
 * Copyright: 2020 Naotoshi Fujita
 */!function(){"use strict";var t={d:function(n,e){for(var i in e)t.o(e,i)&&!t.o(n,i)&&Object.defineProperty(n,i,{enumerable:!0,get:e[i]})},o:function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},r:function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})}},n={};t.r(n),t.d(n,{CREATED:function(){return R},DESTROYED:function(){return X},IDLE:function(){return F},MOUNTED:function(){return B},MOVING:function(){return G}});function e(){return(e=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i])}return t}).apply(this,arguments)}var i=Object.keys;function o(t,n){i(t).some((function(e,i){return n(t[e],e,i)}))}function r(t){return i(t).map((function(n){return t[n]}))}function s(t){return"object"==typeof t}function a(t,n){var i=e({},t);return o(n,(function(t,n){s(t)?(s(i[n])||(i[n]={}),i[n]=a(i[n],t)):i[n]=t})),i}function u(t){return Array.isArray(t)?t:[t]}function c(t,n,e){return Math.min(Math.max(t,n>e?e:n),n>e?n:e)}function d(t,n){var e=0;return t.replace(/%s/g,(function(){return u(n)[e++]}))}function f(t){var n=typeof t;return"number"===n&&t>0?parseFloat(t)+"px":"string"===n?t:""}function l(t){return t<10?"0"+t:t}function h(t,n){if("string"==typeof n){var e=m("div",{});E(e,{position:"absolute",width:n}),w(t,e),n=e.clientWidth,b(e)}return+n||0}function p(t,n){return t?t.querySelector(n.split(" ")[0]):null}function g(t,n){return v(t,n)[0]}function v(t,n){return t?r(t.children).filter((function(t){return P(t,n.split(" ")[0])||t.tagName===n})):[]}function m(t,n){var e=document.createElement(t);return o(n,(function(t,n){return C(e,n,t)})),e}function y(t){var n=m("div",{});return n.innerHTML=t,n.firstChild}function b(t){u(t).forEach((function(t){if(t){var n=t.parentElement;n&&n.removeChild(t)}}))}function w(t,n){t&&t.appendChild(n)}function x(t,n){if(t&&n){var e=n.parentElement;e&&e.insertBefore(t,n)}}function E(t,n){t&&o(n,(function(n,e){null!==n&&(t.style[e]=n)}))}function _(t,n,e){t&&u(n).forEach((function(n){n&&t.classList[e?"remove":"add"](n)}))}function k(t,n){_(t,n,!1)}function S(t,n){_(t,n,!0)}function P(t,n){return!!t&&t.classList.contains(n)}function C(t,n,e){t&&t.setAttribute(n,e)}function z(t,n){return t?t.getAttribute(n):""}function I(t,n){u(n).forEach((function(n){u(t).forEach((function(t){return t&&t.removeAttribute(n)}))}))}function M(t){return t.getBoundingClientRect()}var T="slide",A="loop",O="fade",L=function(t,n){var e,i;return{mount:function(){e=n.Elements.list,t.on("transitionend",(function(t){t.target===e&&i&&i()}),e)},start:function(o,r,s,a,u){var c=t.options,d=n.Controller.edgeIndex,f=c.speed;i=u,t.is(T)&&(0===s&&r>=d||s>=d&&0===r)&&(f=c.rewindSpeed||f),E(e,{transition:"transform "+f+"ms "+c.easing,transform:"translate("+a.x+"px,"+a.y+"px)"})}}},W=function(t,n){function e(e){var i=t.options;E(n.Elements.slides[e],{transition:"opacity "+i.speed+"ms "+i.easing})}return{mount:function(){e(t.index)},start:function(t,i,o,r,s){var a=n.Elements.track;E(a,{height:f(a.clientHeight)}),e(i),setTimeout((function(){s(),E(a,{height:""})}))}}};function H(t){console.error("[SPLIDE] "+t)}function j(t,n){if(!t)throw new Error(n)}var q="splide",D={active:"is-active",visible:"is-visible",loading:"is-loading"},N={type:"slide",rewind:!1,speed:400,rewindSpeed:0,waitForTransition:!0,width:0,height:0,fixedWidth:0,fixedHeight:0,heightRatio:0,autoWidth:!1,autoHeight:!1,perPage:1,perMove:0,clones:0,start:0,focus:!1,gap:0,padding:0,arrows:!0,arrowPath:"",pagination:!0,autoplay:!1,interval:5e3,pauseOnHover:!0,pauseOnFocus:!0,resetProgress:!0,lazyLoad:!1,preloadPages:1,easing:"cubic-bezier(.42,.65,.27,.99)",keyboard:"global",drag:!0,dragAngleThreshold:30,swipeDistanceThreshold:150,flickVelocityThreshold:.6,flickPower:600,flickMaxPages:1,direction:"ltr",cover:!1,accessibility:!0,slideFocus:!0,isNavigation:!1,trimSpace:!0,updateOnMove:!1,throttle:100,destroy:!1,breakpoints:!1,classes:{root:q,slider:q+"__slider",track:q+"__track",list:q+"__list",slide:q+"__slide",container:q+"__slide__container",arrows:q+"__arrows",arrow:q+"__arrow",prev:q+"__arrow--prev",next:q+"__arrow--next",pagination:q+"__pagination",page:q+"__pagination__page",clone:q+"__slide--clone",progress:q+"__progress",bar:q+"__progress__bar",autoplay:q+"__autoplay",play:q+"__play",pause:q+"__pause",spinner:q+"__spinner",sr:q+"__sr"},i18n:{prev:"Previous slide",next:"Next slide",first:"Go to first slide",last:"Go to last slide",slideX:"Go to slide %s",pageX:"Go to page %s",play:"Start autoplay",pause:"Pause autoplay"}},R=1,B=2,F=3,G=4,X=5;function V(t,n){for(var e=0;e<n.length;e++){var i=n[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var U=function(){function t(t,e,i){var o;void 0===e&&(e={}),void 0===i&&(i={}),this.root=t instanceof Element?t:document.querySelector(t),j(this.root,"An invalid element/selector was given."),this.Components=null,this.Event=function(){var t=[];function n(t){t.elm&&t.elm.removeEventListener(t.event,t.handler,t.options)}return{on:function(n,e,i,o){void 0===i&&(i=null),void 0===o&&(o={}),n.split(" ").forEach((function(n){i&&i.addEventListener(n,e,o),t.push({event:n,handler:e,elm:i,options:o})}))},off:function(e,i){void 0===i&&(i=null),e.split(" ").forEach((function(e){t=t.filter((function(t){return!t||t.event!==e||t.elm!==i||(n(t),!1)}))}))},emit:function(n){for(var e=arguments.length,i=new Array(e>1?e-1:0),o=1;o<e;o++)i[o-1]=arguments[o];t.forEach((function(t){t.elm||t.event.split(".")[0]!==n||t.handler.apply(t,i)}))},destroy:function(){t.forEach(n),t=[]}}}(),this.State=(o=R,{set:function(t){o=t},is:function(t){return t===o}}),this.STATES=n,this._o=a(N,e),this._i=0,this._c=i,this._e={},this._t=null}var e,i,s,u=t.prototype;return u.mount=function(t,n){var e=this;void 0===t&&(t=this._e),void 0===n&&(n=this._t),this.State.set(R),this._e=t,this._t=n,this.Components=function(t,n,e){var i={};return o(n,(function(n,e){i[e]=n(t,i,e.toLowerCase())})),e||(e=t.is(O)?W:L),i.Transition=e(t,i),i}(this,a(this._c,t),n);try{o(this.Components,(function(t,n){var i=t.required;void 0===i||i?t.mount&&t.mount():delete e.Components[n]}))}catch(t){return void H(t.message)}var i=this.State;return i.set(B),o(this.Components,(function(t){t.mounted&&t.mounted()})),this.emit("mounted"),i.set(F),this.emit("ready"),E(this.root,{visibility:"visible"}),this.on("move drag",(function(){return i.set(G)})).on("moved dragged",(function(){return i.set(F)})),this},u.sync=function(t){return this.sibling=t,this},u.on=function(t,n,e,i){return void 0===e&&(e=null),void 0===i&&(i={}),this.Event.on(t,n,e,i),this},u.off=function(t,n){return void 0===n&&(n=null),this.Event.off(t,n),this},u.emit=function(t){for(var n,e=arguments.length,i=new Array(e>1?e-1:0),o=1;o<e;o++)i[o-1]=arguments[o];return(n=this.Event).emit.apply(n,[t].concat(i)),this},u.go=function(t,n){return void 0===n&&(n=this.options.waitForTransition),(this.State.is(F)||this.State.is(G)&&!n)&&this.Components.Controller.go(t,!1),this},u.is=function(t){return t===this._o.type},u.add=function(t,n){return void 0===n&&(n=-1),this.Components.Elements.add(t,n,this.refresh.bind(this)),this},u.remove=function(t){return this.Components.Elements.remove(t),this.refresh(),this},u.refresh=function(){return this.emit("refresh:before").emit("refresh").emit("resize"),this},u.destroy=function(t){var n=this;if(void 0===t&&(t=!0),!this.State.is(R))return r(this.Components).reverse().forEach((function(n){n.destroy&&n.destroy(t)})),this.emit("destroy",t),this.Event.destroy(),this.State.set(X),this;this.on("ready",(function(){return n.destroy(t)}))},e=t,(i=[{key:"index",get:function(){return this._i},set:function(t){this._i=parseInt(t)}},{key:"length",get:function(){return this.Components.Elements.length}},{key:"options",get:function(){return this._o},set:function(t){var n=this.State.is(R);n||this.emit("update"),this._o=a(this._o,t),n||this.emit("updated",this._o)}},{key:"classes",get:function(){return this._o.classes}},{key:"i18n",get:function(){return this._o.i18n}}])&&V(e.prototype,i),s&&V(e,s),t}(),Y=function(t){var n=z(t.root,"data-splide");if(n)try{t.options=JSON.parse(n)}catch(t){H(t.message)}return{mount:function(){t.State.is(R)&&(t.index=t.options.start)}}},J="rtl",K="ttb",Q="update.slide",Z=function(t,n){var e=t.root,i=t.classes,s=[];if(!e.id){window.splide=window.splide||{};var a=window.splide.uid||0;window.splide.uid=++a,e.id="splide"+l(a)}var u={mount:function(){var n=this;this.init(),t.on("refresh",(function(){n.destroy(),n.init()})).on("updated",(function(){S(e,c()),k(e,c())}))},destroy:function(){s.forEach((function(t){t.destroy()})),s=[],S(e,c())},init:function(){var t=this;!function(){u.slider=g(e,i.slider),u.track=p(e,"."+i.track),u.list=g(u.track,i.list),j(u.track&&u.list,"Track or list was not found."),u.slides=v(u.list,i.slide);var t=d(i.arrows);u.arrows={prev:p(t,"."+i.prev),next:p(t,"."+i.next)};var n=d(i.autoplay);u.bar=p(d(i.progress),"."+i.bar),u.play=p(n,"."+i.play),u.pause=p(n,"."+i.pause),u.track.id=u.track.id||e.id+"-track",u.list.id=u.list.id||e.id+"-list"}(),k(e,c()),this.slides.forEach((function(n,e){t.register(n,e,-1)}))},register:function(n,e,i){var o=function(t,n,e,i){var o=t.options.updateOnMove,s="ready.slide updated.slide resized.slide moved.slide"+(o?" move.slide":""),a={slide:i,index:n,realIndex:e,container:g(i,t.classes.container),isClone:e>-1,mount:function(){var r=this;this.isClone||(i.id=t.root.id+"-slide"+l(n+1)),t.on(s,(function(){return r.update()})).on(Q,c).on("click",(function(){return t.emit("click",r)}),i),o&&t.on("move.slide",(function(t){t===e&&u(!0,!1)})),E(i,{display:""}),this.styles=z(i,"style")||""},destroy:function(){t.off(s).off(Q).off("click",i),S(i,r(D)),c(),I(this.container,"style")},update:function(){u(this.isActive(),!1),u(this.isVisible(),!0)},isActive:function(){return t.index===n},isVisible:function(){var n=this.isActive();if(t.is(O)||n)return n;var e=Math.ceil,o=M(t.Components.Elements.track),r=M(i);return t.options.direction===K?o.top<=r.top&&r.bottom<=e(o.bottom):o.left<=r.left&&r.right<=e(o.right)},isWithin:function(e,i){var o=Math.abs(e-n);return t.is(T)||this.isClone||(o=Math.min(o,t.length-o)),o<i}};function u(n,e){var o=e?"visible":"active",r=D[o];n?(k(i,r),t.emit(""+o,a)):P(i,r)&&(S(i,r),t.emit(e?"hidden":"inactive",a))}function c(){C(i,"style",a.styles)}return a}(t,e,i,n);o.mount(),s.push(o)},getSlide:function(t){return s.filter((function(n){return n.index===t}))[0]},getSlides:function(t){return t?s:s.filter((function(t){return!t.isClone}))},getSlidesByPage:function(e){var i=n.Controller.toIndex(e),o=t.options,r=!1!==o.focus?1:o.perPage;return s.filter((function(t){var n=t.index;return i<=n&&n<i+r}))},add:function(t,n,e){if("string"==typeof t&&(t=y(t)),t instanceof Element){var i=this.slides[n];E(t,{display:"none"}),i?(x(t,i),this.slides.splice(n,0,t)):(w(this.list,t),this.slides.push(t)),function(t,n){var e=t.querySelectorAll("img"),i=e.length;if(i){var r=0;o(e,(function(t){t.onload=t.onerror=function(){++r===i&&n()}}))}else n()}(t,(function(){e&&e(t)}))}},remove:function(t){b(this.slides.splice(t,1)[0])},each:function(t){s.forEach(t)},get length(){return this.slides.length},get total(){return s.length}};function c(){var n=i.root,e=t.options;return[n+"--"+e.type,n+"--"+e.direction,e.drag?n+"--draggable":"",e.isNavigation?n+"--nav":"",D.active]}function d(t){return g(e,t)||g(u.slider,t)}return u},$=Math.floor,tt=function(t,n){var e,i,o={mount:function(){e=t.options,i=t.is(A),t.on("move",(function(n){t.index=n})).on("updated refresh",(function(n){e=n||e,t.index=c(t.index,0,o.edgeIndex)}))},go:function(t,e){var i=this.trim(this.parse(t));n.Track.go(i,this.rewind(i),e)},parse:function(n){var i=t.index,r=String(n).match(/([+\-<>]+)(\d+)?/),s=r?r[1]:"",a=r?parseInt(r[2]):0;switch(s){case"+":i+=a||1;break;case"-":i-=a||1;break;case">":case"<":i=function(t,n,i){if(t>-1)return o.toIndex(t);var r=e.perMove,s=i?-1:1;if(r)return n+r*s;return o.toIndex(o.toPage(n)+s)}(a,i,"<"===s);break;default:i=parseInt(n)}return i},toIndex:function(n){if(r())return n;var i=t.length,o=e.perPage,s=n*o;return i-o<=(s-=(this.pageLength*o-i)*$(s/i))&&s<i&&(s=i-o),s},toPage:function(n){if(r())return n;var i=t.length,o=e.perPage;return $(i-o<=n&&n<i?(i-1)/o:n/o)},trim:function(t){return i||(t=e.rewind?this.rewind(t):c(t,0,this.edgeIndex)),t},rewind:function(t){var n=this.edgeIndex;if(i){for(;t>n;)t-=n+1;for(;t<0;)t+=n+1}else t>n?t=0:t<0&&(t=n);return t},isRtl:function(){return e.direction===J},get pageLength(){var n=t.length;return r()?n:Math.ceil(n/e.perPage)},get edgeIndex(){var n=t.length;return n?r()||e.isNavigation||i?n-1:n-e.perPage:0},get prevIndex(){var n=t.index-1;return(i||e.rewind)&&(n=this.rewind(n)),n>-1?n:-1},get nextIndex(){var n=t.index+1;return(i||e.rewind)&&(n=this.rewind(n)),t.index<n&&n<=this.edgeIndex||0===n?n:-1}};function r(){return!1!==e.focus}return o},nt=Math.abs,et=function(t,n){var e,i,o,r=t.options.direction===K,s=t.is(O),a=t.options.direction===J,u=!1,d=a?1:-1,f={sign:d,mount:function(){i=n.Elements,e=n.Layout,o=i.list},mounted:function(){var n=this;s||(this.jump(0),t.on("mounted resize updated",(function(){n.jump(t.index)})))},go:function(e,i,o){var r=h(e),a=t.index;t.State.is(G)&&u||(u=e!==i,o||t.emit("move",i,a,e),Math.abs(r-this.position)>=1||s?n.Transition.start(e,i,a,this.toCoord(r),(function(){l(e,i,a,o)})):e!==a&&"move"===t.options.trimSpace?n.Controller.go(e+e-a,o):l(e,i,a,o))},jump:function(t){this.translate(h(t))},translate:function(t){E(o,{transform:"translate"+(r?"Y":"X")+"("+t+"px)"})},cancel:function(){t.is(A)?this.shift():this.translate(this.position),E(o,{transition:""})},shift:function(){var n=nt(this.position),e=nt(this.toPosition(0)),i=nt(this.toPosition(t.length)),o=i-e;n<e?n+=o:n>i&&(n-=o),this.translate(d*n)},trim:function(n){return!t.options.trimSpace||t.is(A)?n:c(n,d*(e.totalSize()-e.size-e.gap),0)},toIndex:function(t){var n=this,e=0,o=1/0;return i.getSlides(!0).forEach((function(i){var r=i.index,s=nt(n.toPosition(r)-t);s<o&&(o=s,e=r)})),e},toCoord:function(t){return{x:r?0:t,y:r?t:0}},toPosition:function(t){var n=e.totalSize(t)-e.slideSize(t)-e.gap;return d*(n+this.offset(t))},offset:function(n){var i=t.options.focus,o=e.slideSize(n);return"center"===i?-(e.size-o)/2:-(parseInt(i)||0)*(o+e.gap)},get position(){var t=r?"top":a?"right":"left";return M(o)[t]-(M(i.track)[t]-e.padding[t]*d)}};function l(n,e,i,r){E(o,{transition:""}),u=!1,s||f.jump(e),r||t.emit("moved",e,i,n)}function h(t){return f.trim(f.toPosition(t))}return f},it=function(t,n){var e=[],i=0,o=n.Elements,r={mount:function(){var n=this;t.is(A)&&(s(),t.on("refresh:before",(function(){n.destroy()})).on("refresh",s).on("resize",(function(){i!==a()&&(n.destroy(),t.refresh())})))},destroy:function(){b(e),e=[]},get clones(){return e},get length(){return e.length}};function s(){r.destroy(),function(t){var n=o.length,i=o.register;if(n){for(var r=o.slides;r.length<t;)r=r.concat(r);r.slice(0,t).forEach((function(t,r){var s=u(t);w(o.list,s),e.push(s),i(s,r+n,r%n)})),r.slice(-t).forEach((function(o,s){var a=u(o);x(a,r[0]),e.push(a),i(a,s-t,(n+s-t%n)%n)}))}}(i=a())}function a(){var n=t.options;if(n.clones)return n.clones;var e=n.autoWidth||n.autoHeight?o.length:n.perPage,i=n.direction===K?"Height":"Width",r=h(t.root,n["fixed"+i]);return r&&(e=Math.ceil(o.track["client"+i]/r)),e*(n.drag?n.flickMaxPages+1:1)}function u(n){var e=n.cloneNode(!0);return k(e,t.classes.clone),I(e,"id"),e}return r};function ot(t,n){var e;return function(){e||(e=setTimeout((function(){t(),e=null}),n))}}var rt=function(t,n){var e,o,r=n.Elements,s=t.options.direction===K,a=(e={mount:function(){t.on("resize load",ot((function(){t.emit("resize")}),t.options.throttle),window).on("resize",c).on("updated refresh",u),u(),this.totalSize=s?this.totalHeight:this.totalWidth,this.slideSize=s?this.slideHeight:this.slideWidth},destroy:function(){I([r.list,r.track],"style")},get size(){return s?this.height:this.width}},o=s?function(t,n){var e,i,o=n.Elements,r=t.root;return{margin:"marginBottom",init:function(){this.resize()},resize:function(){i=t.options,e=o.track,this.gap=h(r,i.gap);var n=i.padding,s=h(r,n.top||n),a=h(r,n.bottom||n);this.padding={top:s,bottom:a},E(e,{paddingTop:f(s),paddingBottom:f(a)})},totalHeight:function(n){void 0===n&&(n=t.length-1);var e=o.getSlide(n);return e?M(e.slide).bottom-M(o.list).top+this.gap:0},slideWidth:function(){return h(r,i.fixedWidth||this.width)},slideHeight:function(t){if(i.autoHeight){var n=o.getSlide(t);return n?n.slide.offsetHeight:0}var e=i.fixedHeight||(this.height+this.gap)/i.perPage-this.gap;return h(r,e)},get width(){return e.clientWidth},get height(){var t=i.height||this.width*i.heightRatio;return j(t,'"height" or "heightRatio" is missing.'),h(r,t)-this.padding.top-this.padding.bottom}}}(t,n):function(t,n){var e,i=n.Elements,o=t.root,r=t.options;return{margin:"margin"+(r.direction===J?"Left":"Right"),height:0,init:function(){this.resize()},resize:function(){r=t.options,e=i.track,this.gap=h(o,r.gap);var n=r.padding,s=h(o,n.left||n),a=h(o,n.right||n);this.padding={left:s,right:a},E(e,{paddingLeft:f(s),paddingRight:f(a)})},totalWidth:function(n){void 0===n&&(n=t.length-1);var e=i.getSlide(n),o=0;if(e){var s=M(e.slide),a=M(i.list);o=r.direction===J?a.right-s.left:s.right-a.left,o+=this.gap}return o},slideWidth:function(t){if(r.autoWidth){var n=i.getSlide(t);return n?n.slide.offsetWidth:0}var e=r.fixedWidth||(this.width+this.gap)/r.perPage-this.gap;return h(o,e)},slideHeight:function(){var t=r.height||r.fixedHeight||this.width*r.heightRatio;return h(o,t)},get width(){return e.clientWidth-this.padding.left-this.padding.right}}}(t,n),i(o).forEach((function(t){e[t]||Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(o,t))})),e);function u(){a.init(),E(t.root,{maxWidth:f(t.options.width)}),r.each((function(t){t.slide.style[a.margin]=f(a.gap)})),c()}function c(){var n=t.options;a.resize(),E(r.track,{height:f(a.height)});var e=n.autoHeight?null:f(a.slideHeight());r.each((function(t){E(t.container,{height:e}),E(t.slide,{width:n.autoWidth?null:f(a.slideWidth(t.index)),height:t.container?null:e})})),t.emit("resized")}return a},st=Math.abs,at=function(t,n){var e,i,r,s,a=n.Track,u=n.Controller,d=t.options.direction===K,f=d?"y":"x",l={disabled:!1,mount:function(){var e=this,i=n.Elements,r=i.track;t.on("touchstart mousedown",h,r).on("touchmove mousemove",g,r,{passive:!1}).on("touchend touchcancel mouseleave mouseup dragend",v,r).on("mounted refresh",(function(){o(i.list.querySelectorAll("img, a"),(function(n){t.off("dragstart",n).on("dragstart",(function(t){t.preventDefault()}),n,{passive:!1})}))})).on("mounted updated",(function(){e.disabled=!t.options.drag}))}};function h(t){l.disabled||s||p(t)}function p(t){e=a.toCoord(a.position),i=m(t,{}),r=i}function g(n){if(i)if(r=m(n,i),s){if(n.cancelable&&n.preventDefault(),!t.is(O)){var o=e[f]+r.offset[f];a.translate(function(n){if(t.is(T)){var e=a.sign,i=e*a.trim(a.toPosition(0)),o=e*a.trim(a.toPosition(u.edgeIndex));(n*=e)<i?n=i-7*Math.log(i-n):n>o&&(n=o+7*Math.log(n-o)),n*=e}return n}(o))}}else(function(n){var e=n.offset;if(t.State.is(G)&&t.options.waitForTransition)return!1;var i=180*Math.atan(st(e.y)/st(e.x))/Math.PI;d&&(i=90-i);return i<t.options.dragAngleThreshold})(r)&&(t.emit("drag",i),s=!0,a.cancel(),p(n))}function v(){i=null,s&&(t.emit("dragged",r),function(e){var i=e.velocity[f],o=st(i);if(o>0){var r=t.options,s=t.index,d=i<0?-1:1,l=s;if(!t.is(O)){var h=a.position;o>r.flickVelocityThreshold&&st(e.offset[f])<r.swipeDistanceThreshold&&(h+=d*Math.min(o*r.flickPower,n.Layout.size*(r.flickMaxPages||1))),l=a.toIndex(h)}l===s&&o>.1&&(l=s+d*a.sign),t.is(T)&&(l=c(l,0,u.edgeIndex)),u.go(l,r.isNavigation)}}(r),s=!1)}function m(t,n){var e=t.timeStamp,i=t.touches,o=i?i[0]:t,r=o.clientX,s=o.clientY,a=n.to||{},u=a.x,c=void 0===u?r:u,d=a.y,f={x:r-c,y:s-(void 0===d?s:d)},l=e-(n.time||0);return{to:{x:r,y:s},offset:f,time:e,velocity:{x:f.x/l,y:f.y/l}}}return l},ut=function(t,n){var e=!1;function i(t){e&&(t.preventDefault(),t.stopPropagation(),t.stopImmediatePropagation())}return{required:t.options.drag,mount:function(){t.on("click",i,n.Elements.track,{capture:!0}).on("drag",(function(){e=!0})).on("dragged",(function(){setTimeout((function(){e=!1}))}))}}},ct=1,dt=2,ft=3,lt=function(t,n,e){var i,o,r,s=t.classes,a=t.root,u=n.Elements;function c(){var r=n.Controller,s=r.prevIndex,a=r.nextIndex,u=t.length>t.options.perPage||t.is(A);i.disabled=s<0||!u,o.disabled=a<0||!u,t.emit(e+":updated",i,o,s,a)}function d(n){return y('<button class="'+s.arrow+" "+(n?s.prev:s.next)+'" type="button"><svg xmlns="http://www.w3.org/2000/svg"\tviewBox="0 0 40 40"\twidth="40"\theight="40"><path d="'+(t.options.arrowPath||"m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z")+'" />')}return{required:t.options.arrows,mount:function(){i=u.arrows.prev,o=u.arrows.next,i&&o||!t.options.arrows||(i=d(!0),o=d(!1),r=!0,function(){var n=m("div",{class:s.arrows});w(n,i),w(n,o);var e=u.slider,r="slider"===t.options.arrows&&e?e:a;x(n,r.firstElementChild)}()),i&&o&&t.on("click",(function(){t.go("<")}),i).on("click",(function(){t.go(">")}),o).on("mounted move updated refresh",c),this.arrows={prev:i,next:o}},mounted:function(){t.emit(e+":mounted",i,o)},destroy:function(){I([i,o],"disabled"),r&&b(i.parentElement)}}},ht="move.page",pt="updated.page refresh.page",gt=function(t,n,e){var i={},o=n.Elements,r={mount:function(){var n=t.options.pagination;if(n){i=function(){var n=t.options,e=t.classes,i=m("ul",{class:e.pagination}),r=o.getSlides(!1).filter((function(t){return!1!==n.focus||t.index%n.perPage==0})).map((function(n,r){var s=m("li",{}),a=m("button",{class:e.page,type:"button"});return w(s,a),w(i,s),t.on("click",(function(){t.go(">"+r)}),a),{li:s,button:a,page:r,Slides:o.getSlidesByPage(r)}}));return{list:i,items:r}}();var e=o.slider;w("slider"===n&&e?e:t.root,i.list),t.on(ht,s)}t.off(pt).on(pt,(function(){r.destroy(),t.options.pagination&&(r.mount(),r.mounted())}))},mounted:function(){if(t.options.pagination){var n=t.index;t.emit(e+":mounted",i,this.getItem(n)),s(n,-1)}},destroy:function(){b(i.list),i.items&&i.items.forEach((function(n){t.off("click",n.button)})),t.off(ht),i={}},getItem:function(t){return i.items[n.Controller.toPage(t)]},get data(){return i}};function s(n,o){var s=r.getItem(o),a=r.getItem(n),u=D.active;s&&S(s.button,u),a&&k(a.button,u),t.emit(e+":updated",i,s,a)}return r},vt="data-splide-lazy",mt="data-splide-lazy-srcset",yt="aria-current",bt="aria-controls",wt="aria-label",xt="aria-hidden",Et="tabindex",_t={ltr:{ArrowLeft:"<",ArrowRight:">",Left:"<",Right:">"},rtl:{ArrowLeft:">",ArrowRight:"<",Left:">",Right:"<"},ttb:{ArrowUp:"<",ArrowDown:">",Up:"<",Down:">"}},kt=function(t,n){var e=t.i18n,i=n.Elements,o=[xt,Et,bt,wt,yt,"role"];function r(n,e){C(n,xt,!e),t.options.slideFocus&&C(n,Et,e?0:-1)}function s(t,n){var e=i.track.id;C(t,bt,e),C(n,bt,e)}function a(n,i,o,r){var s=t.index,a=o>-1&&s<o?e.last:e.prev,u=r>-1&&s>r?e.first:e.next;C(n,wt,a),C(i,wt,u)}function u(n,i){i&&C(i.button,yt,!0),n.items.forEach((function(n){var i=t.options,o=d(!1===i.focus&&i.perPage>1?e.pageX:e.slideX,n.page+1),r=n.button,s=n.Slides.map((function(t){return t.slide.id}));C(r,bt,s.join(" ")),C(r,wt,o)}))}function c(t,n,e){n&&I(n.button,yt),e&&C(e.button,yt,!0)}function f(t){i.each((function(n){var i=n.slide,o=n.realIndex;h(i)||C(i,"role","button");var r=o>-1?o:n.index,s=d(e.slideX,r+1),a=t.Components.Elements.getSlide(r);C(i,wt,s),a&&C(i,bt,a.slide.id)}))}function l(t,n){var e=t.slide;n?C(e,yt,!0):I(e,yt)}function h(t){return"BUTTON"===t.tagName}return{required:t.options.accessibility,mount:function(){t.on("visible",(function(t){r(t.slide,!0)})).on("hidden",(function(t){r(t.slide,!1)})).on("arrows:mounted",s).on("arrows:updated",a).on("pagination:mounted",u).on("pagination:updated",c).on("refresh",(function(){I(n.Clones.clones,o)})),t.options.isNavigation&&t.on("navigation:mounted navigation:updated",f).on("active",(function(t){l(t,!0)})).on("inactive",(function(t){l(t,!1)})),["play","pause"].forEach((function(t){var n=i[t];n&&(h(n)||C(n,"role","button"),C(n,bt,i.track.id),C(n,wt,e[t]))}))},destroy:function(){var t=n.Arrows,e=t?t.arrows:{};I(i.slides.concat([e.prev,e.next,i.play,i.pause]),o)}}},St="move.sync",Pt="mouseup touchend",Ct=[" ","Enter","Spacebar"],zt={Options:Y,Breakpoints:function(t){var n,e,i=t.options.breakpoints,o=ot(s,50),r=[];function s(){var o,s=(o=r.filter((function(t){return t.mql.matches}))[0])?o.point:-1;if(s!==e){e=s;var a=t.State,u=i[s]||n,c=u.destroy;c?(t.options=n,t.destroy("completely"===c)):(a.is(X)&&t.mount(),t.options=u)}}return{required:i&&matchMedia,mount:function(){r=Object.keys(i).sort((function(t,n){return+t-+n})).map((function(t){return{point:t,mql:matchMedia("(max-width:"+t+"px)")}})),this.destroy(!0),addEventListener("resize",o),n=t.options,s()},destroy:function(t){t&&removeEventListener("resize",o)}}},Controller:tt,Elements:Z,Track:et,Clones:it,Layout:rt,Drag:at,Click:ut,Autoplay:function(t,n,e){var i,o=[],r=n.Elements,s={required:t.options.autoplay,mount:function(){var n=t.options;r.slides.length>n.perPage&&(i=function(t,n,e){var i,o,r,s=window.requestAnimationFrame,a=!0,u=function u(c){a||(i||(i=c,r&&r<1&&(i-=r*n)),r=(o=c-i)/n,o>=n&&(i=0,r=1,t()),e&&e(r),s(u))};return{pause:function(){a=!0,i=0},play:function(t){i=0,t&&(r=0),a&&(a=!1,s(u))}}}((function(){t.go(">")}),n.interval,(function(n){t.emit(e+":playing",n),r.bar&&E(r.bar,{width:100*n+"%"})})),function(){var n=t.options,e=t.sibling,i=[t.root,e?e.root:null];n.pauseOnHover&&(a(i,"mouseleave",ct,!0),a(i,"mouseenter",ct,!1));n.pauseOnFocus&&(a(i,"focusout",dt,!0),a(i,"focusin",dt,!1));r.play&&t.on("click",(function(){s.play(dt),s.play(ft)}),r.play);r.pause&&a([r.pause],"click",ft,!1);t.on("move refresh",(function(){s.play()})).on("destroy",(function(){s.pause()}))}(),this.play())},play:function(n){void 0===n&&(n=0),(o=o.filter((function(t){return t!==n}))).length||(t.emit(e+":play"),i.play(t.options.resetProgress))},pause:function(n){void 0===n&&(n=0),i.pause(),-1===o.indexOf(n)&&o.push(n),1===o.length&&t.emit(e+":pause")}};function a(n,e,i,o){n.forEach((function(n){t.on(e,(function(){s[o?"play":"pause"](i)}),n)}))}return s},Cover:function(t,n){function e(t){n.Elements.each((function(n){var e=g(n.slide,"IMG")||g(n.container,"IMG");e&&e.src&&i(e,t)}))}function i(t,n){E(t.parentElement,{background:n?"":'center/cover no-repeat url("'+t.src+'")'}),E(t,{display:n?"":"none"})}return{required:t.options.cover,mount:function(){t.on("lazyload:loaded",(function(t){i(t,!1)})),t.on("mounted updated refresh",(function(){return e(!1)}))},destroy:function(){e(!0)}}},Arrows:lt,Pagination:gt,LazyLoad:function(t,n,e){var i,r,s=t.options,a="sequential"===s.lazyLoad;function u(){r=[],i=0}function c(n){n=isNaN(n)?t.index:n,(r=r.filter((function(t){return!t.Slide.isWithin(n,s.perPage*(s.preloadPages+1))||(d(t.img,t.Slide),!1)})))[0]||t.off("moved."+e)}function d(n,e){k(e.slide,D.loading);var i=m("span",{class:t.classes.spinner});w(n.parentElement,i),n.onload=function(){l(n,i,e,!1)},n.onerror=function(){l(n,i,e,!0)},C(n,"srcset",z(n,mt)||""),C(n,"src",z(n,vt)||"")}function f(){if(i<r.length){var t=r[i];d(t.img,t.Slide)}i++}function l(n,i,o,r){S(o.slide,D.loading),r||(b(i),E(n,{display:""}),t.emit(e+":loaded",n).emit("resize")),a&&f()}return{required:s.lazyLoad,mount:function(){t.on("mounted refresh",(function(){u(),n.Elements.each((function(t){o(t.slide.querySelectorAll("[data-splide-lazy], ["+mt+"]"),(function(n){n.src||n.srcset||(r.push({img:n,Slide:t}),E(n,{display:"none"}))}))})),a&&f()})),a||t.on("mounted refresh moved."+e,c)},destroy:u}},Keyboard:function(t){var n;return{mount:function(){t.on("mounted updated",(function(){var e=t.options,i=t.root,o=_t[e.direction],r=e.keyboard;n&&(t.off("keydown",n),I(i,Et)),r&&("focused"===r?(n=i,C(i,Et,0)):n=document,t.on("keydown",(function(n){o[n.key]&&t.go(o[n.key])}),n))}))}}},Sync:function(t){var n=t.sibling,e=n&&n.options.isNavigation;function i(){t.on(St,(function(t,e,i){n.off(St).go(n.is(A)?i:t,!1),o()}))}function o(){n.on(St,(function(n,e,o){t.off(St).go(t.is(A)?o:n,!1),i()}))}function r(){n.Components.Elements.each((function(n){var e=n.slide,i=n.index;t.off(Pt,e).on(Pt,(function(t){t.button&&0!==t.button||s(i)}),e),t.off("keyup",e).on("keyup",(function(t){Ct.indexOf(t.key)>-1&&(t.preventDefault(),s(i))}),e,{passive:!1})}))}function s(e){t.State.is(F)&&n.go(e)}return{required:!!n,mount:function(){i(),o(),e&&(r(),t.on("refresh",(function(){setTimeout((function(){r(),n.emit("navigation:updated",t)}))})))},mounted:function(){e&&n.emit("navigation:mounted",t)}}},A11y:kt};var It=function(t){var n,e;function i(n,e){return t.call(this,n,e,zt)||this}return e=t,(n=i).prototype=Object.create(e.prototype),n.prototype.constructor=n,n.__proto__=e,i}(U);window.Splide=It}();
},{}]},{},[38])

